import "./SendCreate.css";
import "./CustomDatePicker.css";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ReactMultiEmail } from "react-multi-email";
import moment from "moment";
import "react-multi-email/style.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import MultipleIps from "../../Controls/MultipleIps/MultipleIps";
import MultipleEmails from "../../Controls/MultipleEmails/MultipleEmails";
import WorldContinents from "../../Controls/WorldContinents/WorldContinents";
import Alert from "../../Controls/Alerts/Alerts";
import LoadingSpinner from "../../Controls/Spinner/LoadingSpinner";
import SendDataService from "../../../Services/SendDocument.service";
import APIRequest from "../../../Services/commonAPIConsumer";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
// import { useCookies } from "react-cookie";
import timerpng from "../../../assets/img/time2.png";
import ModalPopUp from "../../Controls/ModalPopUp/ModalPopUp";
import ManageTemplate from "./TemplateCreation/ManageTemplate";
import CreateTemplate from "./TemplateCreation/CreateTemplate";

import {
  clearInterval,
  clearTimeout,
  setInterval,
  setTimeout,
} from "worker-timers";

import { useSelector, useDispatch } from "react-redux";
import {
  languageChange,
  currentSelectedLanguage,
  removeConfiguredData,
  retainConfiguredData,
  sethandleTabValues,
  resetIdentifyLeakers,
  setIDLeakersType,
  setDocumentTemplateName
} from "../../../StateManagement/actions";
import DatePicker from "react-datepicker";
import PageRestrictions from "./PageLevelRestrictions/PageRestrictions";
import { AppContext } from "../../../AppContext";
import Select, { components, NonceProvider } from "react-select";
import IdentifyLeakersModal from "./IdentifyLeakers/IdentifyLeakers";
import { useFetchIdentifyLeakers } from "./IdentifyLeakers/useIdentifyLeakers";
import { TableView, Update } from "@mui/icons-material";
import UpdatePopup from "../../Controls/ModalPopUp/UpdatePopup";

import { storeIdentifyLeakers, storeTemplateIdentifyLeakers } from "../../../StateManagement/actions";
import { resetFormData, storeInitialData, updateFormData } from '../../../StateManagement/formChanges-slice';



function SendCreate(props) {
  const defaultSecurityLevelFromSettings = useRef(0);
  //const isFromSecurityLevel2=useRef(false);
  const identifyLeakersRef = useRef(null);
  const identifyLeakerWrapperRef = useRef(null);
  const waterMarkWrapperRef = useRef(null);
  const isIdentifyLeakersDisabled = useRef(false);
  const identifyLeakersSetting = useRef(false);
  const initialIdLeakersData = useRef(null);
  const timeZoneRef = useRef("");
  const textAuthenticationRef = useRef(false);
  const lookupData = useSelector((state) => state.identifyLeakers.lookupData)
  const idLeakersType = useSelector((state) => state.idLeakers.idLeakersType);
  const history = useNavigate();
  const location = useLocation();
  // const [signCookie, settabCookie] = useCookies([""]);
  const data = useSelector((state) => state.pageLevelRestriction);
  const cipherTextData = useSelector((state) => state.identifyLeakers.cipherText);
  const floatingTextData = useSelector((state) => state.identifyLeakers.floatingText);
  const proofOfSendingValue = useSelector((state) => state.hanldeValues);
  const [securityLevel, setSecurityLevel] = useState(1);
  const [template, setTemplate] = useState(null);
  const [isSendGenerateClick, setIsSendGenerateClick] = useState(false);
  // let UserName = getCookie("UserName");
  // let UserTabSend = getCookie("TabSend");
  // let UserTabSignIn = getCookie("TabSignIn");
  // let UserTabCreate = getCookie("TabCreate");
  // let UserTabDocumentHistory = getCookie("TabDocumentHistory");
  const [showConfirm, setShowConfirm] = useState(false);
  const [pendingChange, setPendingChange] = useState(null);
  const restoreRestrictions = useRef(false);
  const noReadersRestrictionsRef = useRef(false);
  const selectedOrEveryoneExceptSelectedReadersRef = useRef(false);
  const backUpOfConfiguredRestrictions = useRef([]);
  const prevFeatureMapKeys = useRef([]);
  const prevSelectedLanguageRef = useRef(null);
  const prevVerifKeysRef = useRef({ email: null, text: null });
  // Feature entries stored in settingsTemplateCreation by translated label that are
  // NOT part of FEATURE_MAP, and therefore not re-keyed by the FEATURE_MAP effect.
  // (Send verification code is handled by its own dedicated re-sync effect below.)
  const AUX_TEMPLATE_KEY_NAMES = [
    "UI_IDLeakers",
    "UI_EDisclosure",
    "UI_MaxReadsperReader",
    "UI_MaxviewsPerDocument",
  ];
  const [isNavigatedFromL2L3, setIsNavigatedFromL2L3] = useState(false);
  const [ServiceLanguageOptions, setServiceLanguageOptions] = useState([]);
  const [settingsTemplateCreation, setSettingsTemplateCreation] = useState(null);
  const [textSelected, setTextSelected] = useState(false);
  const [istext, setText] = useState("");
  const [isProofOfSending, setIsProofOfSending] = useState(false);
  const [isRPDLight, setIsRPDLight] = useState(false);
  const [isRPDLightDisabled, setIsRPDLightDisabled] = useState(false);
  const [isConfirmClicked, setIsConfirmClicked] = useState(false);
  const [showRecipientPrintPopup, setShowRecipientPrintPopup] = useState(false);
  const [recipientPrintData, setRecipientPrintData] = useState([]);
  const [recipientPrintSearch, setRecipientPrintSearch] = useState("");
  const [allRecipientPrintData, setAllRecipientPrintData] = useState([]);
  const [isPrintHeaderChecked, setIsPrintHeaderChecked] = useState(false);
  const [printEnabledType, setPrintEnabledType] = useState("everyone");
  const [previousPrintEnabledType, setPreviousPrintEnabledType] = useState("");
  const [originalRecipientPrintData, setOriginalRecipientPrintData] = useState([]);
  const [originalPrintEnabledType, setOriginalPrintEnabledType] = useState("");
  if (props.tabValue == "send") {
    if (
      // (UserTabCreate == "" &&
      //   UserTabDocumentHistory == "" &&
      //   UserTabSignIn == "" &&
      //   UserName != null) ||
      // UserName === null ||
      localStorage.getItem("UserName") === undefined ||
      localStorage.getItem("UserName") === "" ||
      localStorage.getItem("UserName") === null
    ) {
      history("/");
    }
    // settabCookie("TabSend", "Send");
    // if (window.performance) {
    //   if (performance.navigation.type == 1) {
    //     settabCookie("TabSignIn", "Referesh");
    //   }
    // }
    // window.addEventListener("beforeunload", (ev) => {
    //   settabCookie("TabSend", "");
    //   settabCookie("TabSignIn", "");
    //   ev.preventDefault();
    // });
    // function getCookie(name) {
    //   var nameEQ = name + "=";
    //   var ca = document.cookie.split(";");
    //   for (var i = 0; i < ca.length; i++) {
    //     var c = ca[i];
    //     while (c.charAt(0) == " ") c = c.substring(1, c.length);
    //     if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    //   }
    //   return null;
    // }
    localStorage.setItem("tabValue", "send");
  } else if (props.tabValue == "create") {
    if (
      // (UserTabSend == "" &&
      //   UserTabDocumentHistory == "" &&
      //   UserTabSignIn == "" &&
      //   UserName != null) ||
      // UserName === null ||
      localStorage.getItem("UserName") === undefined ||
      localStorage.getItem("UserName") === "" ||
      localStorage.getItem("UserName") === null
    ) {
      history("/");
    }
    // window.addEventListener("beforeunload", (ev) => {
    //   settabCookie("TabCreate", "");
    //   settabCookie("TabSignIn", "");
    //   ev.preventDefault();
    // });
    // function getCookie(name) {
    //   var nameEQ = name + "=";
    //   var ca = document.cookie.split(";");
    //   for (var i = 0; i < ca.length; i++) {
    //     var c = ca[i];
    //     while (c.charAt(0) == " ") c = c.substring(1, c.length);
    //     if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    //   }
    //  return null;
    //}
    // settabCookie("TabCreate", "Create");
    localStorage.setItem("tabValue", "create");
  }
  // if (window.performance) {
  //   if (performance.navigation.type == 1) {
  //     settabCookie("TabSignIn", "Referesh");
  //   }
  // }
  if (
    // (((UserTabCreate == "" && UserTabSend != "") ||
    //   (UserTabCreate != "" && UserTabSend == "")) &&
    //   UserTabDocumentHistory == "" &&
    //   UserTabSignIn == "" &&
    //   UserName != null) ||
    // UserName === null ||
    localStorage.getItem("UserName") === undefined ||
    localStorage.getItem("UserName") === "" ||
    localStorage.getItem("UserName") === null
  ) {
    history("/");
  }
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const [timerText, settimertimerText] = useState("You will be logged out in ");
  const [timerValue, settimerValue] = useState("5 minute(s) & 00 second(s).");
  const [openSession, setOpenSession] = useState(false);
  const [selectedFile, setSelectedFile] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([
    { value: 'email', label: selectedLanguage?.LstLanguageCodes?.UI_Email || 'Email' },
  ]);
  const TemplatesData = useSelector((state) => state.documentTemplates.docTemplateOptions);
  const templateName = useSelector((state) => state.documentTemplateName.docTemplateName);
  const [isModelOpenChild, setIsModelOpenChild] = useState(false);
  const [IsWhatsApp, setIsWhatsApp] = useState(false);
  const [IsSMS, setIsSMS] = useState(false);
  const [isEmail, setIsEmail] = useState(true);
  const [isSMSAuthentication, setIsSMSAuthentication] = useState(false);
  const [isWhatsAppAuthentication, setIsWhatsAppAuthentication] = useState(false);
  const [showValidationModal, setShowValidationModal] = useState(false);
  const [validationRows, setValidationRows] = useState([]);
  const [sendVerificationCodechkbx, setSendVerificationCodechkbx] = useState(false);
  const [sendVerificationCodeDisable, setSendVerificationCodeDisable] = useState(false);
  const [isTextRemovePopup, setIsTextRemovePopup] = useState(false);
  const tabValue = localStorage.getItem("tabValue");
  const enabled = true;
  const [emails, setEmailId] = useState([]);
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [file, setFile] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileLength, setFileLength] = useState("0 kb");
  const [openRecord, setOpenRecord] = useState(true);
  const [geolocation, setGeolocation] = useState(true);
  const [watermark, setWatermark] = useState(0);
  const [verifyCode, setVerifyCode] = useState(false);
  const [readerEmail, setReaderEmail] = useState(false);
  const [domains, setDomains] = useState("");
  const [domainsForManageTemplate, setDomainsForManageTemplate] = useState("");
  const [readTimes, setReadTimes] = useState(false);
  const [readTiming, setReadTiming] = useState(false);
  const [maxReads, setMaxReads] = useState(0);
  const [maxReadsText, setMaxReadsText] = useState("");
  const [isExcelSupport, setIsExcelSupport] = useState(false);
  const [maxViewsPerDocument, setMaxViewsPerDocument] = useState(0);
  const [maxViewsPerDocumentText, setMaxViewsPerDocumentText] = useState("");
  const [maxPrintsPerReaderText, setMaxPrintsPerReaderText] = useState("");
  const [maxPrintsPerDocumentText, setMaxPrintsPerDocumentText] = useState("");
  const [maxReadsTextForManageTemplate, setMaxReadsTextForManageTemplate] = useState("");
  const [maxViewsPerDocumentTextForManageTemplate, setMaxViewsPerDocumentTextForManageTemplate] = useState("");
  const [maxPrintsPerReaderTextForManageTemplate, setMaxPrintsPerReaderTextForManageTemplate] = useState("");
  const [maxPrintsPerDocumentTextForManageTemplate, setMaxPrintsPerDocumentTextForManageTemplate] = useState("");
  const [voting, setVoting] = useState(false);
  const [isIdLeakersTypeMatched, setIsIdLeakersTypeMatched] = useState(false);
  const [isConfiguredUser, setIsConfiguredUser] = useState(false);
  const [voteSharing, setVoteSharing] = useState(false);
  const [readNotification, setReadNotification] = useState(false);
  const [distRestriction, setDistRestriction] = useState(false);
  const [proofOfSending, setProofOfSending] = useState(false);
  const [distributionList, setDistributionList] = useState(false);
  const [sideNote, setSideNote] = useState("");
  const [responseAddress, setResponseAddress] = useState(
    localStorage.getItem("UserName")
  );
  const [showManageTemplates, setShowManageTemplates] = useState(false);
  const [showCreateTemplateSettings, setShowCreateTemplateSettings] = useState(false);
  const [constmultipleips, setConstMultipleIps] = useState("");
  const [constmultipleEmails, setConstMultipleEmails] = useState([]);
  const [steganography, setSteganography] = useState(false);
  const [termsOfService, setTermsOfService] = useState("");
  const [timestamp, setTimestamp] = useState(false);
  const [confirmPopup, setConfirmPopup] = useState({
    open: false,
    featureKey: null,
    reduxKey: null,
    newValue: null
  });
  const [templateOptions, setTemplateOptions] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [canPrint, setPrint] = useState(false);
  const [eDisclosure, setEDisclosure] = useState(false);
  const [startTime, setStartTime] = useState("");
  const [expiryTime, setExpiryTime] = useState("");
  const [expirationDays, setExpirationDays] = useState("");
  const [expirationDaysFlag, setExpirationDaysFlag] = useState(true);
  const [authorizedEmails, setAuthorizedEmailId] = useState([]);
  const [eDisclosureLevel1, setEDisclosureLevel1] = useState(false);
  const [eDisclosureLevel2, setEDisclosureLevel2] = useState(false);
  const [eDisclosureLevel3, setEDisclosureLevel3] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");
  const [alertClass, setAlertClass] = useState("alertindex");
  const [openLoader, setOpen] = useState(false);
  const [pendingCount, setPendingCount] = useState(0);
  const [constAllowResFlag, setConstAllowResFlag] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [createDownloadLink, setCreateDownloadLink] = useState("");
  const [createMultipleRPDs, setCreateMultipleRPDs] = useState([]);
  const [createMultipleRPDsFlag, setCreateMultipleRPDsFlag] = useState(false);
  const [downloadFileName, setDownloadFileName] = useState("");
  const [dragActive, setDragActive] = useState(false);
  const [dragStartPosition, setDragStartPosition] = useState(0);
  const [constContinents, setConstContinents] = useState("");
  const [serviceLanguageCode, setServiceLanguageCode] = useState("");
  const [dateFormatValue, setDateFormatValue] = useState("");
  //const [timer, setTimer] = useState("");
  const [inputFields, setInputFields] = useState([]);
  const [preferredFileName, setPreferredFileName] = useState("");
  const [multipleRPDsYesFlag, setMultipleRPDsYesFlag] = useState(true);
  const [multipleRPDsNoFlag, setMultipleRPDsNoFlag] = useState(false);
  const [isXlsClass, setIsXlsClass] = useState(false);
  const [onlineStatus, setOnlineStatus] = useState(true);
  const [noInternetImg, setnoInternetImg] = useState(
    "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"
  );
  const [MultipleemailList, setMultipleemailList] = useState([]);
  const [SourceFrom, setSourceFrom] = useState("UI");
  const [documentId, setdocumentId] = useState(0);
  const [browserLanguage, setbrowserLanguage] = useState(false);
  const [browserLanguageDrop, setBrowserLanguageDrop] = useState(true);
  const [languageCodes, setLanguage] = useState(
    localStorage.getItem("language")
  );
  const [isDatetimeControl, setisDatetimeControl] = useState(
    localStorage.getItem("DateControlFormat")
  );
  const [isPageLevelRestriction, setIsPageLevelRestriction] = useState(false);
  const [isPageLevelRestrictionChecked, setIsPageLevelRestrictionChecked] =
    useState(false);
  const [ModalIsUpdateConfirmOpen, setModalIsUpdateConfirmOpen] = useState(false);
  const pageLevelResRef = useRef();
  const pageLevelResModalRef = useRef();
  const [selectionOfRestriction, setSelectionOfRestriction] = useState([]);
  const [chailedToParentRecipients, setChailedToParentRecipients] = useState(
    []
  );
  const [isEDisclosure, setIsEDisclosure] = useState(false);
  const level2Ref = useRef();
  const unSaveWarnModal = useRef();
  const childRef = useRef();
  const childIPs = useRef();
  const isSendGenerateRef = useRef(false);
  const validationShowRef = useRef(false);
  const childWorldContinents = useRef();
  var multipleemailsadding = [];
  const dispatch = useDispatch();
  const [position, setPosition] = useState(null);
  const level3Ref = useRef();
  const [retainSecurityLevel, setRetainSecurityLevel] = useState("");
  const [countryCodeDrpOptions, setCountryCodedrpOptions] = useState([]);
  const enablePageLevelRes = useRef();
  const removedOptionRef = useRef(null);
  const xlsFileSelectedRef = useRef(false);
  const handleMouseEnter = (e) => {
    const box = e.target.getBoundingClientRect();
    const { top, bottom, left, right } = box;
    const centerX = left + (right - left) / 2;
    const centerY = top + (bottom - top) / 2;
    const newPosition = centerY < window.innerHeight / 2 ? "bottom" : "top";
    setPosition(newPosition);
  };
  // useEffect(() => {
  //   pageLevelResRef.current.disabled = isPageLevelRestriction ? false : true;
  // }, [isPageLevelRestriction]);
  const startLoading = () => setPendingCount(prev => prev + 1);
  const stopLoading = () => setPendingCount(prev => Math.max(prev - 1, 0));
  const [isXLSfileSelected, setIsXLSfileSelected] = useState(false);
  const { getContentSecuritySettings, fetchLookupData } = useFetchIdentifyLeakers(startLoading, stopLoading);
  const [continentsForTemplateC, setContinentsForTemplateC] = useState();
  const [ipsForTemplateC, setIpsForTemplateC] = useState();
  const responseAddressRef = useRef(null);
  const isResponseAddressUserEdited = useRef(false);
  useEffect(() => {
    if (!constAllowResFlag && !isResponseAddressUserEdited.current) {
      const defaultUser = localStorage.getItem("UserName");
      setResponseAddress(defaultUser);
      dispatch(updateFormData({ type: "ResponseAddress", value: defaultUser }));
    }
  }, [constAllowResFlag, dispatch]);
  useEffect(() => {
    if (!selectedLanguage?.LstLanguageCodes) return;
    const labelMap = {
      email: selectedLanguage.LstLanguageCodes.UI_Email || 'Email',
      text: selectedLanguage.LstLanguageCodes.UI_Text || 'Text',
      both: selectedLanguage.LstLanguageCodes.UI_Both || 'Both',
    };
    setSelectedOptions((prev) =>
      prev.map((opt) => ({
        ...opt,
        label: labelMap[opt.value] ?? opt.label,
      }))
    );
  }, [selectedLanguage]);
  useEffect(() => {
    if (templateName) {
      setSelectedTemplate(templateName[0]?.templateName);
      setTemplate(templateName[0]);
    }
  }, [templateName]);
  console.log("tabvalue", tabValue);
  useEffect(() => {
    if (pendingCount > 0) setOpen(true);
    else setOpen(false);
  }, [pendingCount]);
  useEffect(() => {
    if (!Array.isArray(TemplatesData)) return;
    setTemplateOptions(
      TemplatesData && TemplatesData.map((item) => ({
        value: item.templateName || item.TemplateName,
        label: item.templateName || item.TemplateName
      }))
    );
  }, [TemplatesData]);

  const addInputField = (files, source = 0) => {
    const arrayTemp = [];
    var index = 0;
    var validationFlag = false;
    if (inputFields.length > 0) {
      arrayTemp.push(...inputFields);
      index = inputFields.length;
      inputFields.some((oldfile) => {
        files.some((newfile) => {
          if (oldfile.orgFileName == newfile.name && validationFlag == false)
            validationFlag = true;
        });
      });
    }
    if (validationFlag == true) {
      setAlertMsg(
        selectedLanguage.LstLanguageCodes.UI_DuplicateFilesAreNotallowed
      );
      setAlertType("warning");
      return;
    } else {
      if (source === 1) {
        files.some((loopFile) => {
          const tempFile = loopFile; //files[index];
          var lastindexof = tempFile.name.lastIndexOf(".");
          var mlastindexof = tempFile.modifiedFileName.lastIndexOf(".");
          arrayTemp.push({
            file: loopFile,
            orgFileName: tempFile.name,
            orgFileNameWithoutExt: tempFile.name.slice(0, lastindexof),
            mdfFileName: tempFile.modifiedFileName.slice(0, mlastindexof),
            tempFileName: tempFile.modifiedFileName.slice(0, mlastindexof),
            fileFormat: tempFile.name.slice(lastindexof),
            fileSize: bytesToSize(tempFile.size),
            edit: false,
            indexVal: index,
            modified: false,
          });
          index++;
        });
      } else {
        files.some((loopFile) => {
          const tempFile = loopFile; //files[index];
          var lastindexof = tempFile.name.lastIndexOf(".");
          arrayTemp.push({
            file: loopFile,
            orgFileName: tempFile.name,
            orgFileNameWithoutExt: tempFile.name.slice(0, lastindexof),
            mdfFileName: tempFile.name.slice(0, lastindexof),
            tempFileName: tempFile.name.slice(0, lastindexof),
            fileFormat: tempFile.name.slice(lastindexof),
            fileSize: bytesToSize(tempFile.size),
            edit: false,
            indexVal: index,
            modified: false,
          });
          index++;
        });
      }
      if (arrayTemp.length > 0) setInputFields(arrayTemp);
    }
  };
  async function BindLookUpItems() {
    try {
      startLoading();
      const JsonSettingDetails = [];
      var url = `${process.env.REACT_APP_API + process.env.REACT_APP_API_GetLookUpDetails
        }`;
      var response = await APIRequest.GET(
        "",
        url + "?Lang=" + localStorage.getItem("language")
      );
      if (response && response === "Server maintenance") {
        history("/maintenance");
        return;
      }
      if (response && response !== "Failed to fetch") {
        if (response.errorMessage == undefined || response.errorMessage == "") {
          setServiceLanguageOptions(
            response.bindLookUpData.filter(
              (data) => data.fieldName === "ServiceLanguage"
            )
          );

        } else {
          setAlertMsg(response.errorMessage);
          setAlertType("warning");
          return;
        }
      } else {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_FailedtoSaveSetting + "."
        );
        setAlertType("warning");
        return;
      }
    } catch (error) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_FailedtoLoadSetting);
      setAlertType("warning");
      return;
    }
    finally {
      stopLoading();
    }
  }
  const applyChange = (featureKey, reduxKey, value) => {
    const stateMap = {
      timestamp: setTimestamp,
      voting: setVoting,
      canPrint: setPrint,
      proofOfSending: setProofOfSending,
      notificationOfReading: setReadNotification,
      voteSharing: setVoteSharing
      // add more if needed
    };
    stateMap[featureKey]?.(value);
    dispatch(updateFormData({
      type: reduxKey,
      value
    }));
  };

  useEffect(() => {

    if (isDatetimeControl == "true") {
      if (document.getElementById("dtstart") != null) {
        document
          .getElementById("dtstart")
          .addEventListener("keydown", (event) => {
            if (event.keyCode != 8) {
              event.preventDefault();
            } else {
              document.getElementById("dtstart").value = "";
              setStartTime("");
              dispatch(updateFormData({ type: "Launches", value: "" }));
              if (document.getElementById("dtexpiry") == null) {
                setExpirationDays("");
              }
            }
          });
        if (document.getElementById("dtexpiry") != null) {
          document
            .getElementById("dtexpiry")
            .addEventListener("keydown", (event) => {
              if (event.keyCode != 8) {
                event.preventDefault();
              } else {
                document.getElementById("dtexpiry").value = "";
                setExpiryTime("");
                setExpirationDays("");
                dispatch(updateFormData({ type: "Expires", value: "" }))
              }
            });
        }
      }

    } else {
      if (document.getElementById("dtstart1") != null) {
        document
          .getElementById("dtstart1")
          .addEventListener("keydown", (event) => {
            if (event.keyCode != 8) {
              event.preventDefault();
            } else {
              document.getElementById("dtstart1").value = "";
              setStartTime("");
              dispatch(updateFormData({ type: "Launches", value: "" }));
              if (document.getElementById("dtexpiry1") == null) {
                setExpirationDays("");
              }
            }
          });
      }
      if (document.getElementById("dtexpiry1") != null) {
        document
          .getElementById("dtexpiry1")
          .addEventListener("keydown", (event) => {
            if (event.keyCode != 8) {
              event.preventDefault();
            } else {
              document.getElementById("dtexpiry1").value = "";
              setExpiryTime("");
              setExpirationDays("");
              dispatch(updateFormData({ type: "Expires", value: "" }))
            }
          });
      }
    }
    BindLookUpItems();
  }, []);
  const updateSetting = (key, value) => {
    setSettingsTemplateCreation(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const removeSetting = (key) => {
    setSettingsTemplateCreation(prev => {
      const updated = { ...prev };
      delete updated[key];
      return updated;
    });
  };
  function recipientDetailsFromChaild(emailData) {
    setChailedToParentRecipients(emailData);
    if (emailData.length === 0) {
      const noReadersRestrictions = selectionOfRestriction.filter(
        (item) =>
          item.category === "No Readers"
      );
      if (noReadersRestrictions.length > 0) {
        setSelectionOfRestriction([...noReadersRestrictions]);
      } else {
        setSelectionOfRestriction([]);
        pageLevelResRef.current.checked = false;
        dispatch(updateFormData({ type: "PageLevelRestrictions", value: false }));
        setIsPageLevelRestrictionChecked(false);
        backUpOfConfiguredRestrictions.current = [];
      }
      return;
    }
    const readers = emailData.reduce((acc, i) => {
      return acc.concat(i[0]);
    }, []);
    //setConstMultipleEmails(emailData);
    dispatch(
      retainConfiguredData({
        isConfirm: data.onConfirm,
        authorizedReaders: emailData,
        pageRestrictionData: data.pageLevelRestrictionData
          .map((record) => {
            const filteredReaders = record.readers.filter((r) =>
              readers.includes(r)
            );
            return filteredReaders.length > 0
              ? { ...record, readers: filteredReaders }
              : record.category ===
                "No Readers"
                ? { ...record }
                : null;
          })
          .filter((record) => record !== null),
      })
    );

    setSelectionOfRestriction((prev) => {
      return prev
        .map((record) => {
          const filteredReaders = record.readers.filter((r) =>
            readers.includes(r)
          );
          return filteredReaders.length > 0
            ? { ...record, readers: filteredReaders }
            : record.category === "No Readers"
              ? { ...record }
              : null;
        })
        .filter((record) => record !== null);
    });
  }

  const handleRecipientPrintDataUpdate = (updatedReaders) => {
    setRecipientPrintData(updatedReaders);
  };

  const options = [
    { value: 'email', label: selectedLanguage.LstLanguageCodes.UI_Email },
    // { value: 'whatsapp', label: selectedLanguage.LstLanguageCodes.UI_Whatsapp },
    { value: 'text', label: selectedLanguage.LstLanguageCodes.UI_Text },
  ];
  const filteredOptions = options.filter((option) => {
    if (option.value === 'text' && !isSMSAuthentication) return false; // Exclude "Text" if IsSMSAuthentication is false
    // if (option.value === 'whatsapp' && !isWhatsAppAuthentication) return false; // Exclude "WhatsApp" if SsWhatsAppAuthentication is false
    return true; // Include other options
  });
  // useEffect(()=>{
  //   if(identifyLeakersSetting.current == true){
  //     updateSetting(selectedLanguage.LstLanguageCodes.UI_IDLeakers, true);
  //   }
  // },[identifyLeakersSetting.current])
  const handleSelectionChange = (selected) => {
    const selectedList = selected || [];
    if (tabValue === "create" && securityLevel === 2) {
      const incomingValues = selectedList.map((opt) => opt.value);
      if (!incomingValues.includes("email")) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_EmailMandatoryForControlReaders);
        setAlertType("warning");
        return;
      }
    }
    setSelectedOptions(selectedList);

    const selectedValues = selectedList.map((opt) => opt.value);

    const isTextSelected = selectedValues.includes("text");
    const isEmailSelected = selectedValues.includes("email");
    updateSetting(
      selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeText,
      isTextSelected
    );
    updateSetting(
      selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeEmail,
      isEmailSelected
    );
    setIsSMS(isTextSelected);
    setIsEmail(isEmailSelected);
    dispatch(updateFormData({
      type: "SendVerficationType", value: selectedValues.join(","),
    })
    );
  };

  const onConfirmUpdatePopup = () => {
    setIsTextRemovePopup(false);
    const removedOption = removedOptionRef.current;

    const updatedData = data.authorizedReaders.map((recipient) => {
      if (!recipient) return recipient;
      console.log("recipient", chailedToParentRecipients);

      // Deep clone recipient row so we don't mutate state directly
      const updatedRecipient = [...recipient];

      // ✅ Only update if the recipient has the same value as the removed option
      if (updatedRecipient[3]?.value === removedOption) {
        if (removedOption === "text") {
          setIsSMS(false);
          updatedRecipient[3] = {
            value: "email",
            label: selectedLanguage?.LstLanguageCodes?.UI_Email || "Email",
          };
        } else if (removedOption === "email") {
          setIsEmail(false);
          updatedRecipient[3] = {
            value: "text",
            label: selectedLanguage?.LstLanguageCodes?.UI_Text || "Text",
          };
        }
      }
      if (updatedRecipient[3]?.value === "both" && removedOption === "email") {
        updatedRecipient[3] = {
          value: "text",
          label: selectedLanguage?.LstLanguageCodes?.UI_Text || "Text",
        };
      } else if (updatedRecipient[3]?.value === "both" && removedOption === "text") {
        updatedRecipient[3] = {
          value: "email",
          label: selectedLanguage?.LstLanguageCodes?.UI_Email || "Email",
        };
      }
      return updatedRecipient;
    });
    setChailedToParentRecipients(updatedData);
    setSelectedOptions((prev) => prev.filter((opt) => opt.value !== removedOption));

    dispatch(
      retainConfiguredData({
        isConfirm: true,
        authorizedReaders: updatedData,
        pageRestrictionData: data.pageLevelRestrictionData,
      })
    );
  };



  const onCancelUpdatePopup = () => {
    setIsTextRemovePopup(false); // just close popup
  };
  const onCancelUpdatePopup1 = () => {
    setIsIdLeakersTypeMatched(false); // just close popup
    if (identifyLeakersRef.current)
      identifyLeakersRef.current.checked = false;
  };
  const onConfirmUpdatePopup1 = () => {
    setIsIdLeakersTypeMatched(false);
  };
  const MultiValueRemove = (props) => {
    const removedValue = props.data.value;

    const handleMouseDown = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (removedValue === "email" && tabValue === "create" && securityLevel === 2) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_EmailMandatoryForControlReaders);
        setAlertType("warning");
        return;
      }
      const currentValues = selectedOptions.map((opt) => opt.value);
      const isLastOption =
        (removedValue === "text" && !currentValues.includes("email")) ||
        (removedValue === "email" && !currentValues.includes("text"));

      if (isLastOption) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_AtleastOneOptionRequired);
        setAlertType("warning");
        return;
      }

      removedOptionRef.current = removedValue;
      let existsInRecipients = false;

      if (removedValue === "text") {
        existsInRecipients = data.authorizedReaders.some(
          (item) => item?.[3]?.value === "text" || item?.[3]?.value === "both"
        );
        if (existsInRecipients) {
          if (tabValue == "create" && securityLevel == 2) {
          } else {
            setIsTextRemovePopup(true);
            setText(selectedLanguage.LstLanguageCodes.UI_SomeRecipientshavetextselected);
            return;
          }
        }
      } else if (removedValue === "email") {
        existsInRecipients = data.authorizedReaders.some(
          (item) => item?.[3]?.value === "email" || item?.[3]?.value === "both"
        );
        if (existsInRecipients) {
          setIsTextRemovePopup(true);
          setText(selectedLanguage.LstLanguageCodes.UI_SomeRecipientshaveEmailselected);
          return;
        }
      }

      props.innerProps.onMouseDown(e);
    };

    return (
      <components.MultiValueRemove
        {...props}
        innerProps={{
          ...props.innerProps,
          onMouseDown: handleMouseDown,
        }}
      />
    );
  };


  function IntiateTime(e, flag) {
    if (isDatetimeControl == "true") {
      if ((expiryTime == "" || expiryTime == null) && flag == 1) {
        setExpiryTime(
          new Date(
            new Date().getUTCFullYear(),
            new Date().getUTCMonth(),
            new Date().getUTCDate(),
            new Date().getUTCHours(),
            new Date().getUTCMinutes()
          )
        );
        handlerExpirationDaysExpiryTime(
          new Date(
            new Date().getUTCFullYear(),
            new Date().getUTCMonth(),
            new Date().getUTCDate(),
            new Date().getUTCHours(),
            new Date().getUTCMinutes()
          )
        );
      } else if ((startTime == null || startTime == "") && flag == 0) {
        setStartTime(
          new Date(
            new Date().getUTCFullYear(),
            new Date().getUTCMonth(),
            new Date().getUTCDate(),
            new Date().getUTCHours(),
            new Date().getUTCMinutes()
          )
        );
        handlerExpirationDaysStartTime(
          new Date(
            new Date().getUTCFullYear(),
            new Date().getUTCMonth(),
            new Date().getUTCDate(),
            new Date().getUTCHours(),
            new Date().getUTCMinutes()
          )
        );
      }
    } else {
      if ((expiryTime == "" || expiryTime == null) && flag == 1) {
        setExpiryTime(
          new Date(
            new Date().getUTCFullYear(),
            new Date().getUTCMonth(),
            new Date().getUTCDate()
          )
        );
        handlerExpirationDaysExpiryTime(
          new Date(
            new Date().getUTCFullYear(),
            new Date().getUTCMonth(),
            new Date().getUTCDate()
          )
        );
      } else if ((startTime == "" || startTime == null) && flag == 0) {
        setStartTime(
          new Date(
            new Date().getUTCFullYear(),
            new Date().getUTCMonth(),
            new Date().getUTCDate()
          )
        );
        handlerExpirationDaysStartTime(
          new Date(
            new Date().getUTCFullYear(),
            new Date().getUTCMonth(),
            new Date().getUTCDate()
          )
        );
      }
    }
  }

  const fileNameEdit = (indexValEdit) => {
    var arrayTemp = [];
    arrayTemp.push(...inputFields);
    for (let index = 0; index < arrayTemp.length; index++) {
      if (arrayTemp[index].indexVal == indexValEdit) {
        arrayTemp[index].tempFileName = arrayTemp[index].mdfFileName;
        arrayTemp[index].edit = true;
      }
    }
    setInputFields(arrayTemp);
  };
  const fileNameCancel = (indexValCancel) => {
    var arrayTemp = [];
    arrayTemp.push(...inputFields);
    for (let index = 0; index < arrayTemp.length; index++) {
      if (arrayTemp[index].indexVal == indexValCancel) {
        arrayTemp[index].mdfFileName = arrayTemp[index].tempFileName;
        arrayTemp[index].edit = false;
      }
    }
    setInputFields(arrayTemp);
  };
  const fileNameSave = (indexValSave) => {
    var arrayTemp = [];
    arrayTemp.push(...inputFields);

    for (let index = 0; index < arrayTemp.length; index++) {
      if (arrayTemp[index].indexVal == indexValSave) {
        if (arrayTemp[index].mdfFileName.trim() == "") {
          setAlertMsg(selectedLanguage.LstLanguageCodes.UI_FilenameisRequired);
          setAlertType("warning");
          return;
        } else {
          arrayTemp[index].tempFileName = arrayTemp[index].mdfFileName;
          arrayTemp[index].edit = false;
          if (
            arrayTemp[index].orgFileNameWithoutExt !=
            arrayTemp[index].mdfFileName
          ) {
            arrayTemp[index].modified = true;
            setSelectionOfRestriction((prev) => {
              return prev.map((record) => {
                if (
                  record.fileName === arrayTemp[index].orgFileNameWithoutExt
                ) {
                  return { ...record, fileName: arrayTemp[index].mdfFileName };
                } else {
                  return { ...record };
                }
              });
            });
            dispatch(
              retainConfiguredData({
                isConfirm: data.onConfirm,
                authorizedReaders: data.authorizedReaders,
                pageRestrictionData: data.pageLevelRestrictionData.map(
                  (record) => {
                    if (
                      record.fileName === arrayTemp[index].orgFileNameWithoutExt
                    ) {
                      return {
                        ...record,
                        fileName: arrayTemp[index].mdfFileName,
                      };
                    } else {
                      return record;
                    }
                  }
                ),
              })
            );
          } else arrayTemp[index].modified = false;
        }
      }
      setInputFields(arrayTemp);
    }
  };
  const RegionValues = [
    { value: 0, label: "Europe" },
    { value: 2, label: "North America" },
    { value: 3, label: "South America" },
    { value: 4, label: "Asia" },
    { value: 5, label: "Oceania" },
    { value: 1, label: "Africa" },
  ];
  const savePageLevelRestrictions = async (responseData) => {
    try {
      let url = `${process.env.REACT_APP_API +
        process.env.REACT_APP_API_SavePageRestrictions
        }`;

      const fileInfoData = responseData.map((record) => ({
        fileName: record.inputFiles[0].fileName,
        docId: record.documentId,
      }));

      let selectionOfAllowedRestrictedReaderData = [];

      for (const fileInfo of fileInfoData) {
        const updatedRecords = selectionOfRestriction
          .filter((record) => record.fileName === fileInfo.fileName)
          .map((record) => {
            return {
              ...record,
              DocumentId: fileInfo.docId,
              DocumentName: fileInfo.fileName,
            };
          });
        selectionOfAllowedRestrictedReaderData.push(...updatedRecords);
      }

      const pageLevelRestrictionData = {
        ReaderData: [...selectionOfAllowedRestrictedReaderData],
      };

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(pageLevelRestrictionData),
      });
      console.log(response);
    } catch (error) { }
  };
  const handleConfirmPopup = () => {
    const { featureKey, reduxKey, newValue } = confirmPopup;
    applyChange(featureKey, reduxKey, newValue);
    setConfirmPopup({
      open: false,
      featureKey: null,
      reduxKey: null,
      newValue: null
    });
  };
  const handleCancelPopup = () => {
    setConfirmPopup({
      open: false,
      featureKey: null,
      reduxKey: null,
      newValue: null
    });
  };

  const handleFeatureToggle = (featureKey, newValue, reduxKey) => {
    const templateValue = template?.[featureKey];

    // Only confirm when turning OFF something that template has ON
    if (templateValue === true && newValue === false) {
      setConfirmPopup({
        open: true,
        featureKey,
        reduxKey,
        newValue
      });
      return;
    }
    applyChange(featureKey, reduxKey, newValue);
  };

  async function RDocsDefaultSettingsData() {
    startLoading();
    let initialFormData = [
      { type: "Subject", keyValue: "", prevValue: "", isDataChanged: false },
      { type: "EmailBody", keyValue: "", prevValue: "", isDataChanged: false },
      { type: "Description", keyValue: "", prevValue: "", isDataChanged: false },
      { type: "SendVerficationType", keyValue: "email", prevValue: "email", isDataChanged: false },
      { type: 'ResponseAddress', keyValue: localStorage.getItem("UserName"), prevValue: localStorage.getItem("UserName"), isDataChanged: false },
      { type: 'IDLeakers', keyValue: false, prevValue: false, isDataChanged: false }
    ];
    var url = `${process.env.REACT_APP_API + process.env.REACT_APP_API_GetSettingDetails
      }`;
    var userEmailID = localStorage.getItem("UserName");
    try {
      var response = await APIRequest.GET(
        "",
        url +
        "?SettingFor=User&Lang=" +
        localStorage.getItem("language") +
        "&userEmail=" +
        userEmailID +
        "&isFromSendCreate=send"
      );
      if (response && response === "Server maintenance") {
        history("/maintenance");
        return;
      }
      // updateSetting(selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeEmail, true);
      if (response && response.setting) {
        var securitylevelvalue = 0;
        let et = null;
        let st = null;
        let isPrint = false;
        response.setting.forEach((item) => {
          if (item.type === "maxViewsPerDocument") {
            var textValue = item.keyValue.replace(/[^0-9]+/g, "");
            if (textValue == "") {
              setMaxViewsPerDocument(0);
              setMaxViewsPerDocumentText(textValue);
              setMaxViewsPerDocumentTextForManageTemplate(textValue);
              //updateSetting(selectedLanguage.LstLanguageCodes.UI_MaxviewsPerDocument, false);
            } else if (
              parseInt(textValue) >= 1 &&
              parseInt(textValue) <= 2147483647
            ) {
              setMaxViewsPerDocument(textValue);
              setMaxViewsPerDocumentText(textValue);
              setMaxViewsPerDocumentTextForManageTemplate(textValue);
              //updateSetting(selectedLanguage.LstLanguageCodes.UI_MaxviewsPerDocument, true);
            }
            initialFormData.push({ type: "maxViewsPerDocument", keyValue: textValue, prevValue: textValue, isDataChanged: false });
          } else if (item.type === "MaxReadsperReader") {
            if (securitylevelvalue == 2 || securitylevelvalue == 3) {
              var textValue = item.keyValue.replace(/[^0-9]+/g, "");
              if (textValue == "") {
                setMaxReads(0);
                setMaxReadsText(textValue);
                setMaxReadsTextForManageTemplate(textValue);
                //updateSetting(selectedLanguage.LstLanguageCodes.UI_MaxReadsperReader, false);
              } else if (
                parseInt(textValue) >= 1 &&
                parseInt(textValue) <= 2147483647
              ) {
                setMaxReads(textValue);
                setMaxReadsText(textValue);
                setMaxReadsTextForManageTemplate(textValue);
                //updateSetting(selectedLanguage.LstLanguageCodes.UI_MaxReadsperReader, true);
              }
            }
            initialFormData.push({ type: "MaxReadsperReader", keyValue: textValue, prevValue: textValue, isDataChanged: false });
          }
          else if (item.type == "Identifyleakers" && !AppContext.ContentSecurity) {
            if (
              item.keyValue == "true" &&
              (securitylevelvalue == 2 || securitylevelvalue == 3)
            ) {
              setSteganography(true);
              // updateSetting(selectedLanguage.LstLanguageCodes.UI_IDLeakers, true);
              if (identifyLeakerWrapperRef.current) {
                identifyLeakerWrapperRef.current.classList.remove("disable_section");
              }
              if (identifyLeakersRef.current) {
                identifyLeakersRef.current.checked = true;
              }
              identifyLeakersSetting.current = true;
            } else if (item.keyValue == "true" && securitylevelvalue == 1) {
              setSteganography(false);
              if (identifyLeakerWrapperRef.current) {
                identifyLeakerWrapperRef.current.classList.add("disable_section");
              }
            } else {
              setSteganography(false);
              if (securitylevelvalue !== 1) {
                identifyLeakersSetting.current = true;
                if (identifyLeakerWrapperRef.current) {
                  identifyLeakerWrapperRef.current.classList.remove("disable_section");
                }
              }
            }
            initialFormData.push({ type: "Identifyleakers", keyValue: item.keyValue, prevValue: item.keyValue, isDataChanged: false });
          }
          else if (item.type == "ContentSecurity") {
            if (item.keyValue == "false") {
              setSteganography(false);
              isIdentifyLeakersDisabled.current = true;
              identifyLeakerWrapperRef.current.classList.add("disable_section");
            }
            initialFormData.push({ type: "ContentSecurity", keyValue: item.keyValue, prevValue: item.keyValue, isDataChanged: false });
          }
          else if (item.type == "CanPrint") {
            if (item.keyValue == "true") {
              setPrint(true);
              isPrint = true;
              //updateSetting(selectedLanguage.LstLanguageCodes.UI_CanPrint, true);
            }
            else {
              setPrint(false);
              isPrint = false;
              //updateSetting(selectedLanguage.LstLanguageCodes.UI_CanPrint, false);
            }
            initialFormData.push({ type: "CanPrint", keyValue: item.keyValue === "true", prevValue: item.keyValue === "true", isDataChanged: false });
          } else if (item.type === "MaxPrintsPerReader") {
            var textValue = item.keyValue.replace(/[^0-9]+/g, "");
            if (securitylevelvalue == 1) {
              textValue = "";
            }
            if (textValue == "" || isPrint == false) {
              setMaxPrintsPerReaderText(textValue);
              setMaxPrintsPerReaderTextForManageTemplate(textValue)
            } else if (parseInt(textValue) >= 1 && parseInt(textValue) <= 2147483647 && isPrint == true) {
              setMaxPrintsPerReaderText(parseInt(textValue));
              setMaxPrintsPerReaderTextForManageTemplate(textValue)
            }
            initialFormData.push({ type: "MaxPrintsPerReader", keyValue: isPrint ? textValue : "", prevValue: isPrint ? textValue : "", isDataChanged: false });
          } else if (item.type === "MaxPrintsPerDocument") {
            var textValue = item.keyValue.replace(/[^0-9]+/g, "");
            if (textValue == "" || isPrint == false) {
              setMaxPrintsPerDocumentText(textValue);
              setMaxPrintsPerDocumentTextForManageTemplate(textValue)
            } else if (parseInt(textValue) >= 1 && parseInt(textValue) <= 2147483647 && isPrint == true) {
              setMaxPrintsPerDocumentText(parseInt(textValue));
              setMaxPrintsPerDocumentTextForManageTemplate(parseInt(textValue))
            }
            initialFormData.push({ type: "MaxPrintsPerDocument", keyValue: isPrint ? textValue : "", prevValue: isPrint ? textValue : "", isDataChanged: false });
          } else if (item.type == "TimeStamp") {
            if (item.keyValue == "true") {
              setTimestamp(true);
              updateSetting(selectedLanguage.LstLanguageCodes.UI_TimeStamp, true);
            } else {
              setTimestamp(false);
            }
            initialFormData.push({ type: "TimeStamp", keyValue: item.keyValue === "true", prevValue: item.keyValue === "true", isDataChanged: false });
          } else if (item.type == "AllowResponseTo") {
            if (item.keyValue == "true") {
              setConstAllowResFlag(true);
              updateSetting(selectedLanguage.LstLanguageCodes.UI_AllowResponsesTo, true);
            } else {
              setConstAllowResFlag(false);
            }
            initialFormData.push({ type: "AllowResponseTo", keyValue: item.keyValue === "true", prevValue: item.keyValue === "true", isDataChanged: false });
          } else if (item.type == "ProofOfSending") {
            let flag = false;
            dispatch(sethandleTabValues(item.keyValue));
            if (item.keyValue == "true") {
              setIsProofOfSending(true);

              if (props.tabValue == "send") {
                setProofOfSending(true);
              } else {
                setProofOfSending(false);
              }
              updateSetting(selectedLanguage.LstLanguageCodes.UI_ProofOfSending, true);
              flag = true;
            } else {
              setIsProofOfSending(false);
              setProofOfSending(false);
              flag = false;
            }
            initialFormData.push({ type: "ProofOfSending", keyValue: flag, prevValue: flag, isDataChanged: false });
          } else if (item.type == "Voting") {
            let flag = false;
            if (item.keyValue == "true" && (securitylevelvalue == 2 || securitylevelvalue == 3)) {
              setVoting(true);
              document.getElementById("voting").checked = true;
              document.getElementById("voteShare_id").classList.remove("disable_sectionChailed");
              flag = true;
              updateSetting(selectedLanguage.LstLanguageCodes.UI_Voting, true);
            } else if (item.keyValue == "true" && securitylevelvalue == 1) {
              setVoting(false);
              flag = false;
            } else {
              setVoting(false);
              flag = false;
            }
            initialFormData.push({ type: "Voting", keyValue: flag, prevValue: flag, isDataChanged: false });
          } else if (item.type == "ShareVotes") {
            let flag = false;
            if (item.keyValue == "true" && (securitylevelvalue == 2 || securitylevelvalue == 3)) {
              setVoteSharing(true);
              flag = true;
              updateSetting(selectedLanguage.LstLanguageCodes.UI_ShareVotes, true);
            } else if (item.keyValue == "true" && securitylevelvalue == 1) {
              setVoteSharing(false);
              flag = false;
            } else {
              setVoteSharing(false);
              flag = false;
            }
            initialFormData.push({ type: "ShareVotes", keyValue: flag, prevValue: flag, isDataChanged: false });
          }
          else if (item.type == "NotificationOfReading") {
            let flag = false;
            if (item.keyValue == "true" && (securitylevelvalue == 2 || securitylevelvalue == 3)) {
              setReadNotification(true);
              document.getElementById("readNotify").checked = true;
              flag = true;
              updateSetting(selectedLanguage.LstLanguageCodes.UI_NotificationofReading, true);
            } else if (item.keyValue == "true" && securitylevelvalue == 1) {
              setReadNotification(false);
              flag = false;
            } else {
              setReadNotification(false);
              flag = false;
            }
            initialFormData.push({ type: "NotificationOfReading", keyValue: flag, prevValue: flag, isDataChanged: false });
          } else if (item.type == "ExcelSupport") {
            if (item.keyValue == "true") {
              setIsExcelSupport(true);
              setIsConfiguredUser(true);
            }
            else {
              const readersList = AppContext.ExcelConfigReaders?.[0]
                ?.split(",")
                .map(email => email.trim().toLowerCase())
                .filter(Boolean) || [];

              const isAllowed = readersList.includes(userEmailID?.toLowerCase());
              if (isAllowed) {
                setIsExcelSupport(true);
                setIsConfiguredUser(true);
              }
              else {
                setIsExcelSupport(false);
                setIsConfiguredUser(false);
              }
            }
          }

          else if (item.type == "DisplayDistributionList") {
            let flag = false;
            if (item.keyValue == "true" && (securitylevelvalue == 2 || securitylevelvalue == 3)) {
              setDistributionList(true);
              document.getElementById("distribution").checked = true;
              flag = true;
              updateSetting(selectedLanguage.LstLanguageCodes.UI_DisplayDistributionlist, true);
            } else if (item.keyValue == "true" && securitylevelvalue == 1) {
              setDistributionList(false);
              flag = false;
            } else {
              setDistributionList(false);
              flag = false;
            }
            initialFormData.push({ type: "DisplayDistributionList", keyValue: flag, prevValue: flag, isDataChanged: false });
          } else if (item.type == "SendVerificationCode") {
            let flag = false;
            if (item.keyValue == "true" && props.tabValue == "send") {
              flag = true;
            }
            initialFormData.push({ type: "SendVerificationCode", keyValue: flag, prevValue: flag, isDataChanged: false });
          }
          else if (item.type == "SideNote") {
            setSideNote(item.keyValue);
            initialFormData.push({ type: "SideNote", keyValue: item.keyValue, prevValue: item.keyValue, isDataChanged: false });
          } else if (item.type == "TermsOfService") {
            if ((securitylevelvalue == 2 || securitylevelvalue == 3))
              setTermsOfService(item.keyValue);
            // initialFormData.push({type:"TermsOfService",keyValue:item.keyValue,prevValue:item.keyValue,isDataChanged:false});
          }
          else if (item.type == "Watermark") {
            setWatermark(item.keyValue);
            initialFormData.push({ type: "Watermark", keyValue: item.keyValue, prevValue: item.keyValue, isDataChanged: false });
          } else if (item.type === "AccessControl") {
            if (item.keyValue === "L1") {
              // document.getElementById("level1").checked = true;
              SecurityLevel1();
              updateSetting(selectedLanguage.LstLanguageCodes.UI_TrackViews, false);
              securitylevelvalue = 1;
              //defaultSecurityLevelFromSettings.current = 1;

            } else if (item.keyValue === "L2") {
              document.getElementById("level2").checked = true;
              SecurityLevel2();
              updateSetting(selectedLanguage.LstLanguageCodes.UI_TrackReaders, false);
              securitylevelvalue = 2;
              //defaultSecurityLevelFromSettings.current = 2;
            } else if (item.keyValue === "L3") {
              document.getElementById("level3").checked = true;
              SecurityLevel3();
              securitylevelvalue = 3;
              // defaultSecurityLevelFromSettings.current = 3;
              updateSetting(selectedLanguage.LstLanguageCodes.UI_LimitReaders, false);
            }
            setRetainSecurityLevel(item.keyValue);
            initialFormData.push({ type: "AccessControl", keyValue: item.keyValue, prevValue: item.keyValue, isDataChanged: false });
          } else if (item.type == "RestrictToDomains") {
            if (securitylevelvalue == 2 || securitylevelvalue == 3) {
              setDomains(item.keyValue);
              setDomainsForManageTemplate(item.keyValue);
            }
            initialFormData.push({ type: "RestrictToDomains", keyValue: item.keyValue, prevValue: item.keyValue, isDataChanged: false });
          } else if (item.type == "SMSAuthentication") {
            if (item.keyValue == 'true') {
              setIsSMSAuthentication(true)
              textAuthenticationRef.current = true;
            } else {
              setIsSMSAuthentication(false)
              textAuthenticationRef.current = false;
            }
            //initialFormData.push({type:"SMSAuthentication",keyValue:item.keyValue,prevValue:item.keyValue,isDataChanged:false});
          }
          else if (item.type == "EDisclosure") {
            if (
              item.keyValue == "true"
            ) {
              // setEDisclosure(true);
              // updateSetting(selectedLanguage.LstLanguageCodes.UI_EDisclosure, true);
              setIsEDisclosure(true);
            } else {
              // setEDisclosure(false);
              setIsEDisclosure(false);
            }
            if (item.keyCollection && Array.isArray(item.keyCollection)) {
              const l1 = item.keyCollection.find(k => k.level === "L1")?.levelFlag === true;
              const l2 = item.keyCollection.find(k => k.level === "L2")?.levelFlag === true;
              const l3 = item.keyCollection.find(k => k.level === "L3")?.levelFlag === true;

              setEDisclosureLevel1(l1);
              setEDisclosureLevel2(l2);
              setEDisclosureLevel3(l3);
            } else {
              // If keyCollection is missing or invalid, set all levels to false
              setEDisclosureLevel1(false);
              setEDisclosureLevel2(false);
              setEDisclosureLevel3(false);
            }
            initialFormData.push({ type: "EDisclosure", keyValue: false, prevValue: false, isDataChanged: false });
          }
          else if (item.type == "WhatsAppAuthentication") {
            if (item.keyValue == 'true') {
              setIsWhatsAppAuthentication(true)
            } else {
              setIsWhatsAppAuthentication(false)
            }
          }

          else if (item.type == "Launches") {

            var launchesValuef = parseInt(item.keyValue);
            if (launchesValuef == null || launchesValuef == "") {
              st = new Date(

                new Date().getUTCFullYear(),
                new Date().getUTCMonth(),
                new Date().getUTCDate(),
                new Date().getUTCHours(),
                new Date().getUTCMinutes()
              )

              //initialFormData.push({ type: "Launches", keyValue: "" , prevValue: "", isDataChanged: false });
            }
            if (!Number.isNaN(launchesValuef)) {
              const now = new Date();
              const launchDate = new Date(now);
              launchDate.setDate(now.getDate() + launchesValuef);


              st = new Date(
                launchDate.getUTCFullYear(),
                launchDate.getUTCMonth(),
                launchDate.getUTCDate(),
                launchDate.getUTCHours(),
                launchDate.getUTCMinutes()
              )


              // if (initialFormData.findIndex(i => i.type === 'Launches') === -1 && launchDate) {
              //   initialFormData.push({
              //     type: "Launches", keyValue: new Date(
              //       launchDate.getUTCFullYear(),
              //       launchDate.getUTCMonth(),
              //       launchDate.getUTCDate(),
              //       launchDate.getUTCHours(),
              //       launchDate.getUTCMinutes()
              //     ).toUTCString(), prevValue: new Date(
              //       launchDate.getUTCFullYear(),
              //       launchDate.getUTCMonth(),
              //       launchDate.getUTCDate(),
              //       launchDate.getUTCHours(),
              //       launchDate.getUTCMinutes()
              //     ).toUTCString(), isDataChanged: false
              //   });
              // }
            }
            // initialFormData.push({type:"Launches",keyValue:item.keyValue,prevValue:item.keyValue,isDataChanged:false});
          }
          else if (item.type === "Expires") {
            const launchesSetting = response.setting.find(
              (settingItem) => settingItem.type === "Launches"
            );

            const LaunchVal = parseInt(launchesSetting.keyValue);
            const expirationDaysValuef =
              item.keyValue != null && item.keyValue !== ""
                ? parseInt(item.keyValue)
                : "";

            const expirationDaysValue =
              item.keyValue != null && item.keyValue !== ""
                ? `${item.keyValue} ${item.keyValue > 1 ? "Days" : "Day"}`
                : "";

            setExpirationDays(expirationDaysValue);

            // Start time (UTC)
            st = new Date(
              new Date().getUTCFullYear(),
              new Date().getUTCMonth(),
              new Date().getUTCDate(),
              new Date().getUTCHours(),
              new Date().getUTCMinutes()
            );

            let dtStartTime;
            if (expirationDaysValuef !== "") {
              const today = new Date();
              dtStartTime = new Date(today);
              dtStartTime.setDate(dtStartTime.getDate() + (LaunchVal + expirationDaysValuef));

              // Expiry time (UTC)
              et = new Date(
                dtStartTime.getUTCFullYear(),
                dtStartTime.getUTCMonth(),
                dtStartTime.getUTCDate(),
                dtStartTime.getUTCHours(),
                dtStartTime.getUTCMinutes()
              );
            }

            // if (initialFormData.findIndex((i) => i.type === "Expires") === -1 && dtStartTime) {
            //   const expiryUTC = new Date(
            //     dtStartTime.getUTCFullYear(),
            //     dtStartTime.getUTCMonth(),
            //     dtStartTime.getUTCDate(),
            //     dtStartTime.getUTCHours(),
            //     dtStartTime.getUTCMinutes()
            //   ).toUTCString();

            //   initialFormData.push({
            //     type: "Expires",
            //     keyValue: expiryUTC,
            //     prevValue: expiryUTC,
            //     isDataChanged: false,
            //   });
            // } else {
            //   initialFormData.push({
            //     type: "Expires",
            //     keyValue: "",
            //     prevValue: "",
            //     isDataChanged: false,
            //   });
            // }
          } else if (item.type === "TimeZone") {
            const tzString = item.keyValue;
            const match = tzString && tzString.match(/([+-]\d{2}:\d{2})/);
            const timeZoneValue = match && match[1] ? match[1] : "+00:00";
            timeZoneRef.current = timeZoneValue
            // Convert existing dates if any
            if (st) {
              const localStartTime = handleTimeZoneConversion(st, "utcToLocal", timeZoneValue);
              setStartTime(localStartTime);
              initialFormData.push({ type: "Launches", keyValue: localStartTime, prevValue: localStartTime, isDataChanged: false });
            }
            if (et) {
              const localExpiryTime = handleTimeZoneConversion(et, "utcToLocal", timeZoneValue);
              setExpiryTime(localExpiryTime);
              initialFormData.push({ type: "Expires", keyValue: localExpiryTime, prevValue: localExpiryTime, isDataChanged: false });
            }
          }



          else if (item.type === "DateFormat") {
            const colonIndex = item.keyValue.indexOf(":");
            if (colonIndex !== -1) {
              const dateFormat = item.keyValue.substr(colonIndex + 1).trim();
              setDateFormatValue(dateFormat);
              localStorage.setItem("dateFormat", dateFormat);
            }
          } else if (item.type == "Watermark") {
            setWatermark(item.keyValue);
          } else if (item.type == "ServiceLanguage") {
            setServiceLanguageCode(item.keyValue.toLowerCase());
            setLanguage(item.keyValue.toLowerCase());
            initialFormData.push({ type: "ServiceLanguage", keyValue: item.keyValue.toLowerCase(), prevValue: item.keyValue.toLowerCase(), isDataChanged: false });
          } else if (item.type == "BannedRegions") {
            var optinlist = [];
            var optinlist1 = [];
            var str = item.keyValue.replace(/[{}]/g, "");
            str.split(",").map((items, i) => {
              RegionValues.filter((option) => {
                if (items != "" && option.value == items) {
                  optinlist.push(option);
                }
              });
            });
            var excludedItems = RegionValues.filter(
              (region) => !optinlist.includes(region)
            );
            excludedItems.map((exitem) => {
              optinlist1.push(exitem.value);
            });
            //);
            setConstContinents(optinlist1);
            childWorldContinents.current.setWorldContinents(optinlist1);
            initialFormData.push({ type: "BannedRegions", keyValue: str, prevValue: str, isDataChanged: false });
          } else if (item.type == "AllowedIP") {
            var ipArrayList = [];
            var ipList = item.keyValue.replace(/[{}]/g, "");
            if (ipList !== "") {
              ipArrayList = ipList.split(",");
              setConstMultipleIps(ipArrayList);
              childIPs.current.setUserArrayIpList(ipArrayList);
              if (initialFormData.findIndex(i => i.type === 'IpCheck') === -1)
                initialFormData.push({ type: 'IpCheck', keyValue: true, prevValue: true, isDataChanged: false });
            } else {
              if (initialFormData.findIndex(i => i.type === 'IpCheck') === -1)
                initialFormData.push({ type: 'IpCheck', keyValue: false, prevValue: false, isDataChanged: false });
            }
            initialFormData.push({ type: "AllowedIP", keyValue: ipArrayList.join(","), prevValue: ipArrayList.join(","), isDataChanged: false });
          } else if (item.type === "PageLevelRestrictions") {
            if (item.keyValue === "false") {
              setIsPageLevelRestriction(false);
              pageLevelResRef.current.disabled = true;
              enablePageLevelRes.current.classList.add("disable_section");
            } else {
              setIsPageLevelRestriction(true);
              pageLevelResRef.current.disabled = false;
              enablePageLevelRes.current.classList.remove("disable_section");
            }
            initialFormData.push({ type: "PageLevelRestrictions", keyValue: false, prevValue: false, isDataChanged: false });

          }
        });
        dispatch(storeInitialData(initialFormData));
        const sendVerifSetting = response.setting.find(s => s.type === "SendVerificationCode");
        if (sendVerifSetting?.keyValue == "true" && props.tabValue == "send" && (securitylevelvalue == 2 || securitylevelvalue == 3)) {
          setVerifyCode(true);
          document.getElementById("emailVerify").checked = true;
        } else {
          setVerifyCode(false);
          document.getElementById("emailVerify").checked = false;
        }
        console.log(initialFormData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    finally {
      stopLoading();
    }
  }
  async function fetchCountryCodes() {
    try {
      const url = `${process.env.REACT_APP_API}/docs/GetAllCountryCodedes`;
      const response = await fetch(url);
      const data = await response.json();
      if (data != null) {
        const formattedOptions = [

          ...data.map((item) => ({
            value: `${item.dialCode}`,
            label: `${item.countryName} (${item.dialCode})`,
            languageCode: item.countryCode.toLowerCase(), // Ensure lowercase
            mobileMaxLeng: item.mobileMaxLeng
          })),
        ];

        // Update the state with transformed options
        setCountryCodedrpOptions(formattedOptions);
        return formattedOptions;
        // setCountryCodeOptions(formattedOptions);
      }
    } catch (error) {
      console.error('Error fetching country codes:', error);
    }
  }
  const manageTemplateShow = () => {
    setShowManageTemplates(true);
  }
  async function RDocsDataSend() {
    //console.log(localStorage.getItem("DocumentID"));
    if (localStorage.getItem("DocumentID") != null) {
      setdocumentId(localStorage.getItem("DocumentID"));
      var objRDocsDocumentDetails = {
        DocumentId: localStorage.getItem("DocumentID"),
      };
      let startTimeLocal = null;
      let expiryTimeLocal = null;
      let expirationDaysValue = null;
      let expiryValueOutlook = null;
      let startValueOutlook = null;
      var response = await APIRequest.GetRdocsData(objRDocsDocumentDetails);
      if (response === "Server maintenance") {
        history("/maintenance");
        return;
      } else if (response && response.status === 200) {
        const rdocsLevel = localStorage.getItem("Level");
        setisDatetimeControl(String(response.data.dateControlFormat));
        setServiceLanguageCode(response.data.document.documentOptions.language);
        var isSMS = localStorage.getItem("SMSAuthentication");
        setIsEmail(true);
        if (response.data.document.documentOptions.isSMS && isSMS === "true") {
          setIsSMS(true);
          const emailOption = [
            { value: 'email', label: selectedLanguage.LstLanguageCodes.UI_Email },
          ];
          const newOption = { value: 'text', label: selectedLanguage.LstLanguageCodes.UI_Text };
          // Add only if it doesn't already exist
          const newSelected = emailOption.some(option => option.value === newOption.value)
            ? emailOption
            : [...emailOption, newOption];
          setIsSMSAuthentication(true);
          setSelectedOptions(newSelected);
        }
        else if (!response.data.document.documentOptions.isSMS && isSMS === "true") {
          setIsSMSAuthentication(true);
        }
        // if(response.data.document.documentOptions.isEmail){
        //   const emailOption = [
        //     { value: 'email', label: selectedLanguage.LstLanguageCodes.UI_Email },
        //   ];
        //   setSelectedOptions(emailOption);
        //   setIsEmail(true);
        // } else{
        //   setIsEmail(false);
        // setSelectedOptions([]);
        // }
        // else if (response.data.document.documentOptions.isWhatsApp) {
        //   setSelectedOptions([{value: 'email', label: selectedLanguage.LstLanguageCodes.UI_Email}, { value: 'whatsapp', label: selectedLanguage.LstLanguageCodes.UI_Whatsapp }]);
        // }
        // else if (response.data.document.documentOptions.isSMS && response.data.document.documentOptions.isWhatsApp){
        //   setSelectedOptions([{value: 'email', label: selectedLanguage.LstLanguageCodes.UI_Email},{ value: 'text', label: selectedLanguage.LstLanguageCodes.UI_Text },{ value: 'whatsapp', label: selectedLanguage.LstLanguageCodes.UI_Whatsapp }]);
        // }
        if (rdocsLevel == "1") {
          SecurityLevel1();
        } else if (rdocsLevel == "2") {
          document.getElementById("level2").checked = true;
          SecurityLevel2();
        } else {
          document.getElementById("level3").checked = true;
          SecurityLevel3();
        }
        if (!response.data.pageLevelRestrictionsSettingValue) {
          setIsPageLevelRestriction(false);
          pageLevelResRef.current.disabled = true;
          enablePageLevelRes.current.classList.add("disable_section");
        } else {
          setIsPageLevelRestriction(true);
          pageLevelResRef.current.disabled = false;
          enablePageLevelRes.current.classList.remove("disable_section");
        }
        if (!response.data.eDisclosure) {
          setIsEDisclosure(false);
        } else if (rdocsLevel != "1") {
          setIsEDisclosure(true);
        }
        //console.log(response.data.document);

        let countryCodes = countryCodeDrpOptions;
        if (countryCodeDrpOptions.length === 0) {
          countryCodes = await fetchCountryCodes();
        }
        for (let index = 0; index < response.data.document.documentOptions.recipients.length; index++) {
          const recipient = response.data.document.documentOptions.recipients[index];
          const mobileCountryCode =
            recipient.mobileCountryCode &&
            countryCodes &&
            countryCodes.find((cc) => cc.value === recipient.mobileCountryCode);

          // Convert authType string into object
          let authTypeObj = [];
          if (recipient.authType) {
            const type = recipient.authType.toLowerCase();
            if (type === "text") {
              authTypeObj = { value: "text", label: selectedLanguage?.LstLanguageCodes?.UI_Text || "Text" };
            } else if (type === "email") {
              authTypeObj = { value: "email", label: selectedLanguage?.LstLanguageCodes?.UI_Email || "Email" };
            } else if (type === "both") {
              authTypeObj = { value: "both", label: selectedLanguage?.LstLanguageCodes?.UI_Both || "Both" };
            }
          }
          multipleemailsadding.push([
            recipient.email,
            recipient.firstName,
            recipient.lastName,
            authTypeObj,
            mobileCountryCode === '' ? [] : mobileCountryCode,
            recipient.mobileNumber,
            recipient.reference,
          ]);
        }
        setChailedToParentRecipients(multipleemailsadding);
        dispatch(
          retainConfiguredData({
            isConfirm: data.onConfirm,
            authorizedReaders: multipleemailsadding,
            pageRestrictionData: data.pageLevelRestrictionData,
          })
        );
        setSubject(response.data.document.documentOptions.subject);
        setMessage(response.data.document.documentOptions.message);
        if (response.data.dateFormat != "") {
          const colonIndex = response.data.dateFormat.indexOf(":");
          if (colonIndex !== -1) {
            const dateFormat = response.data.dateFormat
              .substr(colonIndex + 1)
              .trim();
            setDateFormatValue(dateFormat);
          }
        } else {
          setDateFormatValue("MM/dd/yyyy");
        }

        var dtStartTime =
          response.data.document.documentOptions.startTime != null
            ? new Date(response.data.document.documentOptions.startTime)
            : null;
        var dtexpiryTime =
          response.data.document.documentOptions.expiryTime != null
            ? new Date(response.data.document.documentOptions.expiryTime)
            : null;
        const timeZoneValue1 = response.data.timeZone;
        const match = timeZoneValue1 && timeZoneValue1.match(/([+-]\d{2}:\d{2})/);
        const matchTimeZone = match && match[1] ? match[1] : "+00:00";
        timeZoneRef.current = matchTimeZone;
        if (String(response.data.dateControlFormat) == "false") {
          startTimeLocal = dtStartTime != null
            ? new Date(
              dtStartTime.getUTCFullYear(),
              dtStartTime.getUTCMonth(),
              dtStartTime.getUTCDate(),
              dtStartTime.getUTCHours(),
              dtStartTime.getUTCMinutes()
            )
            : null;
          expiryTimeLocal = dtexpiryTime != null
            ? new Date(
              dtexpiryTime.getUTCFullYear(),
              dtexpiryTime.getUTCMonth(),
              dtexpiryTime.getUTCDate(),
              dtexpiryTime.getUTCHours(),
              dtexpiryTime.getUTCMinutes()
            )
            : null;
          if (startTimeLocal) {
            const localStartTime = handleTimeZoneConversion(startTimeLocal, "utcToLocal", matchTimeZone);
            setStartTime(localStartTime);
          }
          if (expiryTimeLocal) {
            const localExpiryTime = handleTimeZoneConversion(expiryTimeLocal, "utcToLocal", matchTimeZone);
            setExpiryTime(localExpiryTime);
          }
          expiryValueOutlook = dtexpiryTime != null
            ? new Date(
              dtexpiryTime.getUTCFullYear(),
              dtexpiryTime.getUTCMonth(),
              dtexpiryTime.getUTCDate(),
              dtexpiryTime.getUTCHours(),
              dtexpiryTime.getUTCMinutes()
            )
            : null;
          startValueOutlook = dtStartTime != null
            ? new Date(
              dtStartTime.getUTCFullYear(),
              dtStartTime.getUTCMonth(),
              dtStartTime.getUTCDate(),
              dtStartTime.getUTCHours(),
              dtStartTime.getUTCMinutes()
            )
            : null;
          const localExpiryTime = handleTimeZoneConversion(expiryValueOutlook, "utcToLocal", matchTimeZone);
          const localStartTime = handleTimeZoneConversion(startValueOutlook, "utcToLocal", matchTimeZone);
          handlerExpirationDaysExpiryTimeWithRdocsSend(localExpiryTime, localStartTime, response.data.dateControlFormat);
        } else {
          startTimeLocal = dtStartTime != null
            ? new Date(
              dtStartTime.getUTCFullYear(),
              dtStartTime.getUTCMonth(),
              dtStartTime.getUTCDate()
            )
            : null;
          expiryTimeLocal = dtexpiryTime != null
            ? new Date(
              dtexpiryTime.getUTCFullYear(),
              dtexpiryTime.getUTCMonth(),
              dtexpiryTime.getUTCDate()
            )
            : null;
          if (startTimeLocal) {
            const localStartTime = handleTimeZoneConversion(startTimeLocal, "utcToLocal", matchTimeZone);
            setStartTime(localStartTime);
          }
          if (expiryTimeLocal) {
            const localExpiryTime = handleTimeZoneConversion(expiryTimeLocal, "utcToLocal", matchTimeZone);
            setExpiryTime(localExpiryTime);
          }

          expirationDaysValue = new Date(
            dtStartTime.getUTCFullYear(),
            dtStartTime.getUTCMonth(),
            dtStartTime.getUTCDate(),
            dtStartTime.getUTCHours(),
            dtStartTime.getUTCMinutes()
          )
          if (expirationDaysValue) {
            const localStartTime = handleTimeZoneConversion(expirationDaysValue, "utcToLocal", matchTimeZone);
            handlerExpirationDaysStartTime(localStartTime);
          }
          expiryValueOutlook = dtexpiryTime != null
            ? new Date(
              dtexpiryTime.getUTCFullYear(),
              dtexpiryTime.getUTCMonth(),
              dtexpiryTime.getUTCDate(),
              dtexpiryTime.getUTCHours(),
              dtexpiryTime.getUTCMinutes()
            )
            : null;
          startValueOutlook = dtStartTime != null
            ? new Date(
              dtStartTime.getUTCFullYear(),
              dtStartTime.getUTCMonth(),
              dtStartTime.getUTCDate(),
              dtStartTime.getUTCHours(),
              dtStartTime.getUTCMinutes()
            )
            : null;
          const localExpiryTime = handleTimeZoneConversion(expiryValueOutlook, "utcToLocal", matchTimeZone);
          const localStartTime = handleTimeZoneConversion(startValueOutlook, "utcToLocal", matchTimeZone);
          handlerExpirationDaysExpiryTimeOutlook(localExpiryTime, localStartTime);
        }
        // setEDisclosure(response.data.document.documentOptions.eDisclosure);

        setSourceFrom(response.data.document.documentOptions.source);
        var inputFileArr = [];
        for (let i = 0; i < response.data.document.inputFiles.length; i++) {
          var inputObject = {
            name: "",
            size: "",
            modifiedFileName: "",
            Order: "",
          };
          inputObject.name = response.data.document.inputFiles[i].fileName;
          inputObject.size = response.data.document.inputFiles[i].fileSize;
          inputObject.modifiedFileName =
            response.data.document.inputFiles[i].modifiedFileName;
          inputObject.Order = response.data.document.inputFiles[i].order;
          inputFileArr.push(inputObject);
        }
        // if (response.data.document.fileName != "") {
        //   setPreferredFileName(response.data.document.fileName);
        //   setMultipleRPDsNoFlag(true);
        //   setMultipleRPDsYesFlag(false);
        // }
        fileSelection(inputFileArr, 1);
        //console.log(multipleemailsadding);
        //Navigate("send");
      } else {
        setOpen(false);
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_EmailAdressORpasswordNotValid
        );
        setAlertType("warning");
        //alert("Email address or password is not valid!");
      }

      // Clean up the event listener when the component unmounts
    }
  }


  useEffect(() => {
    const fetchData = async () => {
      try {
        const idLeakers = await getContentSecuritySettings();
        identifyLeakersSetting.current = idLeakers;
      } catch (error) {
        console.error('Error fetchingIdLeakers data:', error);
      }
    }
    if (AppContext.ContentSecurity) {
      fetchData();
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("DocumentID") == null) {
      RDocsDefaultSettingsData();
    } else if (localStorage.getItem("DocumentID") != null) {
      RDocsDataSend();
    }
    //fetchLookupData();

  }, []);
  function handleOnChangeProof(e) {
    dispatch(sethandleTabValues(e == true ? "true" : "false"))
    setProofOfSending(e);
    updateSetting(selectedLanguage.LstLanguageCodes.UI_ProofOfSending, e)
    dispatch(updateFormData({ type: "ProofOfSending", value: e }))
  }
  useEffect(() => {
    if (props.tabValue == "send") {
      setSendVerificationCodeDisable(true);
      // Reset both checkboxes to unchecked when navigating to the Send tab,
      // regardless of the setting value — they stay unchecked until the tab is refreshed
      setVerifyCode(false);
      setProofOfSending(false);
      if (
        document.getElementById("level2").checked ||
        document.getElementById("level3").checked
      ) {
        setSendVerificationCodeDisable(false);
        document.getElementById("emailVerify").disabled = false;
        var second2 = document.getElementsByClassName("user_register");
        for (let t = 0; t < second2.length; t++) {
          second2[t].classList.remove("disable_section");
        }
      }
    } else if (props.tabValue == "create") {
      setSendVerificationCodeDisable(true);
      // Reset both checkboxes to unchecked when entering Generate (Create) tab
      setProofOfSending(false);
      setVerifyCode(false);
      if (securityLevel === "level2" || document.getElementById("level2").checked) {
        setSelectedOptions((prev) => {
          const emailOption = { value: "email", label: selectedLanguage.LstLanguageCodes.UI_Email };
          // if email already exists, just return previous
          if (prev.some((opt) => opt.value === "email")) {
            return prev;
          }
          // otherwise add email
          return [...prev, emailOption];
        });
      }
      if (
        document.getElementById("level2").checked ||
        document.getElementById("level3").checked
      ) {
        setSendVerificationCodeDisable(false);
        document.getElementById("emailVerify").disabled = true;
        var second2 = document.getElementsByClassName("user_register");
        for (let t = 0; t < second2.length; t++) {
          second2[t].classList.remove("disable_section");
        }
      }
    }
    if (!isXLSfileSelected) {
      if (!isPageLevelRestriction && isXLSfileSelected) {
        enablePageLevelRes.current.classList.add("disable_section");
      }
      else {
        enablePageLevelRes.current.classList.remove("disable_section");
      }
    }

    if (!data.onConfirm) {
      setSelectionOfRestriction([]);
      pageLevelResRef.current.checked = false;
      dispatch(updateFormData({ type: "PageLevelRestrictions", value: false }));
      setIsPageLevelRestrictionChecked(false);
      setConstMultipleEmails([]);
      setChailedToParentRecipients([]);
    }
  }, [props.tabValue]);
  useEffect(() => {
    defaultLoginUserAssign(0);
    if (multipleRPDsNoFlag) {
      let totalFileSize = 0;
      let indiviualFileZize = 0;
      inputFields.forEach(file => {
        indiviualFileZize = parseInt(file.file.size);
        totalFileSize += indiviualFileZize;
      });
      if (tabValue === "send" && totalFileSize > AppContext.FileSizeSend * 1024 * 1024) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Themaximumsizelessthan20);
        setAlertType("warning");
      }
    }
    else if (multipleRPDsYesFlag) {
      selectedFile.forEach(file => {
        if (tabValue === "send" && file.size > AppContext.FileSizeSend * 1024 * 1024) {
          setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Themaximumsizelessthan20);
          setAlertType("warning");
        }
      });
    }
  }, [tabValue]);

  function defaultLoginUserAssign(flag) {
    if (document.getElementById("level3").checked && tabValue == "create") {
      //if (!data.onConfirm) {
      let defaultUserData = [localStorage.getItem("UserName"), "", "", [], ""];
      let array = [];
      array.push(defaultUserData);
      //setConstMultipleEmails(array);
      const isArrayPresent = array.some((item) =>
        data.authorizedReaders.some((reader) => reader[0] === item[0])
      );
      if (!isArrayPresent) {
        dispatch(
          retainConfiguredData({
            isConfirm: true,
            authorizedReaders: [...array, ...data.authorizedReaders],
            pageRestrictionData: data.pageLevelRestrictionData,
          })
        );
        setChailedToParentRecipients([...array, ...data.authorizedReaders]);
      }
    } else if (flag == 0) {
      setConstMultipleEmails([]);
    }
  }


  useEffect(() => {
    window.addEventListener("online", () => setOnlineStatus(true));
    window.addEventListener(
      "offline",
      () => setOnlineStatus(false),
      // setOpen(false)
    );
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);
  const fileNameChange = (indexValChange, val) => {
    var arrayTemp = [];
    arrayTemp.push(...inputFields);

    for (let index = 0; index < arrayTemp.length; index++) {
      if (arrayTemp[index].indexVal == indexValChange) {
        arrayTemp[index].mdfFileName = val;
      }
      setInputFields(arrayTemp);
    }
  };

  const deleteFile = (indexValDelete) => {
    let arrayTemp = [];
    arrayTemp.push(...inputFields);

    const fileNames = selectionOfRestriction.map((item) =>
      item.fileName.trim()
    );

    let sliced = false;
    const splicedFiles = [];

    for (let index = 0; index < arrayTemp.length; index++) {
      if (arrayTemp[index].indexVal == indexValDelete && sliced == false) {
        splicedFiles.push(arrayTemp[index].orgFileNameWithoutExt);
        arrayTemp.splice(index, 1);
        index = index - 1;
        sliced = true;
      } else if (sliced == true) {
        arrayTemp[index].indexVal = arrayTemp[index].indexVal - 1;
      }
    }
    // ✅ Check AFTER deletion for Excel files
    const hasExcelFiles = arrayTemp.some((file) =>
      [".xls", ".xlsx"].includes(file.fileFormat?.toLowerCase())
    );
    setIsXLSfileSelected(hasExcelFiles);
    if (!hasExcelFiles) {
      xlsFileSelectedRef.current = false;
    }
    const isPageLevelResChecked = pageLevelResRef.current.checked;
    const hasRestrictions = selectionOfRestriction.length > 0;
    const isFileNameExists = multipleRPDsNoFlag
      ? fileNames.includes(preferredFileName.trim()) || fileNames.length > 0
      : fileNames.some((file) => splicedFiles.includes(file.trim()));

    if (isPageLevelResChecked && hasRestrictions && isFileNameExists) {
      let msg = "";

      if (multipleRPDsNoFlag) {
        msg =
          selectedLanguage.LstLanguageCodes.UI_AllConfiguredRestrictionsRemoved;
      } else {
        msg =
          selectedLanguage.LstLanguageCodes
            .UI_AllConfiguredRestrictionsForDocRemoved;
      }

      unSaveWarnModal.current.open(
        msg,
        () => {
          deleteInputFiles();
        },
        () => { }
      );
    } else {
      deleteInputFiles();
    }

    function deleteInputFiles() {
      if (arrayTemp.length == 1) {
        setIsXlsClass(true);
      } else {
        setIsXlsClass(false);
      }
      if (arrayTemp.length < 2) {
        setPreferredFileName("");
        setMultipleRPDsNoFlag(false);
        setMultipleRPDsYesFlag(true);
      }

      if (arrayTemp.length === 0 || multipleRPDsNoFlag) {
        setSelectionOfRestriction([]);
        pageLevelResRef.current.checked = false;

        dispatch(
          updateFormData({ type: "PageLevelRestrictions", value: false })
        );

        setIsPageLevelRestrictionChecked(false);
        setIsRPDLight(false);
      } else {
        setSelectionOfRestriction((prev) => {
          return prev.filter(
            (record) => record.fileName !== arrayTemp.orgFileName
          );
        });
      }

      setInputFields(arrayTemp);
    }
  };
  useEffect(() => {

    const hasExcelFiles = inputFields.some((file) => {
      const ext = file.fileFormat?.toLowerCase();
      return ext === ".xls" || ext === ".xlsx";
    });

    if (hasExcelFiles) {
      enablePageLevelRes.current.classList.add("disable_section");
      identifyLeakerWrapperRef.current.classList.add("disable_section");
      document.getElementById("chkIdentifyLeakersDiv")?.classList.add("disable_section");
      waterMarkWrapperRef.current.classList.add("disable_section");
      if (identifyLeakersRef.current)
        identifyLeakersRef.current.checked = false;
    } else {
      enablePageLevelRes.current.classList.remove("disable_section");
      if (identifyLeakersSetting.current && securityLevel !== 1) {
        identifyLeakerWrapperRef.current.classList.remove("disable_section");
        document.getElementById("chkIdentifyLeakersDiv")?.classList.remove("disable_section");
      } else {
        identifyLeakerWrapperRef.current.classList.add("disable_section");
        document.getElementById("chkIdentifyLeakersDiv")?.classList.add("disable_section");
        if (identifyLeakersRef.current)
          identifyLeakersRef.current.checked = false;
      }
      waterMarkWrapperRef.current.classList.remove("disable_section");
    }
  }, [inputFields, xlsFileSelectedRef]);
  const dragStart = (e, position) => {
    setDragStartPosition(position);
  };
  const dragOver = (e, position) => {
    e.stopPropagation();
    e.preventDefault();
  };

  const dragDrop = (e, dragEndPosition) => {
    var arrayTemp = [];
    arrayTemp.push(...inputFields);
    for (let index = 0; index < arrayTemp.length; index++) {
      if (dragStartPosition != dragEndPosition) {
        if (dragStartPosition > dragEndPosition) {
          if (
            index < dragStartPosition &&
            index >= dragEndPosition &&
            index != dragStartPosition
          ) {
            arrayTemp[index].indexVal = arrayTemp[index].indexVal + 1;
          } else if (index == dragStartPosition) {
            arrayTemp[index].indexVal = dragEndPosition;
          }
        } else if (dragStartPosition < dragEndPosition) {
          if (
            index > dragStartPosition &&
            index <= dragEndPosition &&
            index != dragStartPosition
          ) {
            arrayTemp[index].indexVal = arrayTemp[index].indexVal - 1;
          } else if (index == dragStartPosition) {
            arrayTemp[index].indexVal = dragEndPosition;
          }
        }
      }
    }
    arrayTemp.sort(function (a, b) {
      return a.indexVal - b.indexVal;
    });
    setInputFields(arrayTemp);
  };

  const fileNameUndo = (indexValCancel) => {
    var arrayTemp = [];
    arrayTemp.push(...inputFields);
    for (let index = 0; index < arrayTemp.length; index++) {
      if (arrayTemp[index].indexVal == indexValCancel) {
        setSelectionOfRestriction((prev) => {
          return prev.map((record) => {
            if (record.fileName === arrayTemp[index].mdfFileName) {
              return {
                ...record,
                fileName: arrayTemp[index].orgFileNameWithoutExt,
              };
            } else {
              return record;
            }
          });
        });
        dispatch(
          retainConfiguredData({
            isConfirm: data.onConfirm,
            authorizedReaders: data.authorizedReaders,
            pageRestrictionData: data.pageLevelRestrictionData.map((record) => {
              if (record.fileName === arrayTemp[index].mdfFileName) {
                return {
                  ...record,
                  fileName: arrayTemp[index].orgFileNameWithoutExt,
                };
              } else {
                return record;
              }
            }),
          })
        );
        arrayTemp[index].mdfFileName = arrayTemp[index].orgFileNameWithoutExt;
        arrayTemp[index].edit = false;
        arrayTemp[index].modified = false;
      }
    }
    setInputFields(arrayTemp);
  };

  const fileNameDeleteAll = () => {
    setIsXLSfileSelected(false);
    if (pageLevelResRef.current.checked && selectionOfRestriction.length > 0) {
      let msg =
        selectedLanguage.LstLanguageCodes.UI_AllConfiguredRestrictionsRemoved;
      unSaveWarnModal.current.open(
        msg,
        () => {
          deleteAllFiles();
        },
        () => { }
      );
    } else {
      deleteAllFiles();
    }
    function deleteAllFiles() {
      setIsXLSfileSelected(false);
      setIsRPDLight(false);
      setInputFields([]);
      setPreferredFileName("");
      setSelectionOfRestriction([]);
      setMultipleRPDsNoFlag(false);
      setMultipleRPDsYesFlag(true);
      setIsPageLevelRestrictionChecked(false);
      pageLevelResRef.current.checked = false;
      dispatch(updateFormData({ type: "PageLevelRestrictions", value: false }));
    }
  };


  // useEffect(() => {
  //   //clearTimeout(timer);
  //   // setTimer(
  //   setTimeout(
  //     () => {
  //       setAlertMsg("");
  //       setAlertType("");
  //       setAlertClass("alertindex");
  //     },
  //     5000 //)
  //   );
  // }, [alertType]);
  useEffect(() => {
    dispatch(languageChange(localStorage.getItem("language")));
    dispatch(setDocumentTemplateName([]));
    SecurityLevel1();
  }, []);
  useEffect(() => { }, [createDownloadLink]);
  useEffect(() => { }, [fileName]);
  useEffect(() => { }, [dragActive]);
  useEffect(() => { }, [inputFields]);
  useEffect(() => {
    refreshToken();
  }, []);
  async function refreshToken() {
    var response = await APIRequest.POSTREFRESH(
      `${process.env.REACT_APP_API + process.env.REACT_APP_API_RefreshToken}`
    );
    if (response && response === "Server maintenance") {
      history("/maintenance");
      return;
    }
    if (response && response !== "Failed to fetch") {
      if (response.errorMessage == undefined || response.errorMessage == "") {
      } else {
        setAlertMsg(response.errorMessage);
        setAlertType("warning");
        return;
      }
    } else {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_SessionisExpiredPlease);
      setAlertType("warning");
      return;
    }
  }
  useEffect(() => {
    if (securityLevel === 1 && isXLSfileSelected == false) {
      identifyLeakerWrapperRef.current.classList.add("disable_section");
    }
  }, [securityLevel])


  function SecurityLevel1() {
    setSendVerificationCodeDisable(true);
    dispatch(updateFormData({ type: "AccessControl", value: "L1" }));
    setSecurityLevel(1);
    document.getElementById("level1").checked = true;
    var level2 = document.getElementById("level2");
    var level3 = document.getElementById("level3");
    var firstone = document.getElementsByClassName("user_register");
    for (let i = 0; i < firstone.length; i++) {
      firstone[i].classList.add("disable_section");
    }
    level2.checked = false;
    level3.checked = false;
    document.getElementById("chkIdentifyLeakersDiv").classList.add("disable_section");
    var ticks = document.getElementsByClassName("done");
    for (let m = 0; m < ticks.length; m++) {
      ticks[m].style.display = "none";
    }
    let elements = document.getElementsByClassName("minimize");
    for (let j = 0; j < elements.length; j++) {
      elements[j].style.display = "block";
    }
    document.getElementById("lv1").style.display = "block";
    document.getElementById("lv2").style.display = "none";
    document.getElementById("maxReads").disabled = true;
    document.getElementById("txtRestrictDomains").disabled = true;
    setMaxReads(0);
    // setMaxViewsPerDocument(0);
    setMaxReadsText("");
    // setMaxViewsPerDocumentText("");
    setDomains("");
    setOpenRecord(true);
    setGeolocation(true);
    setVerifyCode(false);
    setReadTimes(false);
    setReadTiming(false);
    setReaderEmail(false);
    setDistRestriction(false);
    setReadNotification(false);
    setDistributionList(false);
    setVoting(false);
    setVoteSharing(false);
    document.getElementById("readNotify").checked = false;
    document.getElementById("distribution").checked = false;
    document.getElementById("emailVerify").checked = false;
    document.getElementById("voting").checked = false;
    document.getElementById("voteShare").checked = false;
    document.getElementById("chkIdentifyLeakers").checked = false;
    // document.getElementById("txtEDisclosure").checked = false;
    document
      .getElementById("chkIdentifyLeakersDiv")
      .classList.add("disable_section");
  }
  function SecurityLevel2() {
    setSendVerificationCodeDisable(false);
    document.getElementById("level3").checked = false;
    document.getElementById("lv2").style.display = "none";
    document.getElementById("lv1").style.display = "block";
    if (document.getElementById("level2").checked) {
      const isEmailSelected = selectedOptions.some((opt) => opt.value === "email");
      if (isEmailSelected) {
        updateSetting(
          selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeEmail,
          true
        );
      }
      const isTextSelected = selectedOptions.some((opt) => opt.value === "text");
      if (isTextSelected) {
        updateSetting(
          selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeText,
          true
        );
      }
      if (tabValue == "create") {
        const emailOption = {
          value: "email",
          label: selectedLanguage.LstLanguageCodes.UI_Email,
        };

        setSelectedOptions((prev) => {
          const emailOption = { value: "email", label: selectedLanguage.LstLanguageCodes.UI_Email };
          if (prev.some((opt) => opt.value === "email")) {
            return prev;
          }
          return [...prev, emailOption];
        });
      }
      dispatch(updateFormData({ type: "AccessControl", value: "L2" }));
      setSecurityLevel(2);
      var ticks = document.getElementsByClassName("done");
      for (let i = 0; i < ticks.length; i++) {
        ticks[i].style.display = "block";
      }
      let elements = document.getElementsByClassName("minimize");
      for (let j = 0; j < elements.length; j++) {
        elements[j].style.display = "none";
      }
      var second2 = document.getElementsByClassName("user_register");
      for (let t = 0; t < second2.length; t++) {
        second2[t].classList.remove("disable_section");
      }
      //checkbox disabel
      document.getElementById("readNotify").disabled = false;
      document.getElementById("distribution").disabled = false;
      document.getElementById("emailVerify").disabled = false;
      // if (tabValue === "send") {
      //   document.getElementById("emailVerify").checked = true;
      // }
      document.getElementById("voting").disabled = false;
      document.getElementById("maxReads").disabled = false;
      document.getElementById("txtRestrictDomains").disabled = false;
      if (identifyLeakersSetting.current && AppContext.ContentSecurity && isIdentifyLeakersDisabled.current && !isXLSfileSelected) {
        document
          .getElementById("chkIdentifyLeakersDiv")
          .classList.remove("disable_section");
      }
      if (isEDisclosure == true && eDisclosureLevel2 && !isXLSfileSelected) {
        document.getElementById("chkEDisclosureDiv").classList.remove("disable_sectionChailed");
      }
      // document
      // .getElementById("chkEDisclosureDiv")
      // .classList.remove("disable_sectionChailed");
      setOpenRecord(true);
      setGeolocation(true);
      // setVerifyCode(true);
      setReaderEmail(true);
      setDistRestriction(false);
      setReadTimes(true);
      setReadTiming(true);
      pageLevelResRef.current.disabled = isPageLevelRestriction ? false : true;
      if (!isPageLevelRestriction)
        enablePageLevelRes.current.classList.add("disable_section");
      else if (!isXLSfileSelected) { enablePageLevelRes.current.classList.remove("disable_section"); }
      setRetainSecurityLevel("L2");
      if (
        securityLevel === 1 &&
        isNavigatedFromL2L3 &&
        backUpOfConfiguredRestrictions.current.length > 0
      ) {
        let msg =
          selectedLanguage.LstLanguageCodes.UI_IsToRetainNoReadersRestrictions;
        const exceptNoReadersRestrictions =
          backUpOfConfiguredRestrictions.current.filter((item) => {
            if (
              item.category ===
              "Selected Readers" ||
              item.category ===
              "Everyone Except Selected Readers"
            ) {
              return { ...item };
            }
          });
        if (exceptNoReadersRestrictions.length === 0) return;
        unSaveWarnModal.current.open(
          msg,
          () => {
            restoreRestrictions.current = false;
            pageLevelResRef.current.checked = true;
            setIsPageLevelRestrictionChecked(true);
            dispatch(updateFormData({ type: "PageLevelRestrictions", value: true }));
            const backUpId = backUpOfConfiguredRestrictions.current.map(
              (item) => item.id
            );

            const newFilteredRecords = selectionOfRestriction
              .filter((item) => !backUpId.includes(item.id))
              .map((item) => {
                const filteredPages = item.pages.filter(
                  (page) =>
                    !backUpOfConfiguredRestrictions.current.some(
                      (restriction) => restriction.pages.includes(page)
                    )
                );

                console.log(filteredPages);

                return filteredPages.length > 0
                  ? { ...item, pages: filteredPages }
                  : null;
              })
              .filter((item) => item !== null);

            console.log(newFilteredRecords);

            const records = [
              ...newFilteredRecords,
              ...backUpOfConfiguredRestrictions.current,
            ];
            // .sort((a, b) => a.page - b.page);

            setSelectionOfRestriction(records);
            dispatch(
              retainConfiguredData({
                isConfirm: data.onConfirm,
                authorizedReaders: data.authorizedReaders,
                pageRestrictionData: [...records],
              })
            );
          },
          () => {
            setSelectionOfRestriction((prev) => {
              const backUpId = backUpOfConfiguredRestrictions.current
                .filter(
                  (item) =>
                    item.category ===
                    "No Readers"
                )
                .map((item) => item.id);
              const filteredPrevRecords = prev.filter(
                (item) =>
                  item.category ===
                  "No Readers" &&
                  !backUpId.includes(item.id)
              );
              console.log(filteredPrevRecords);
              return [
                ...backUpOfConfiguredRestrictions.current.filter(
                  (item) =>
                    item.category ===
                    "No Readers"
                ),
                ...filteredPrevRecords,
              ];
            });
          }
        );
      }
    } else {
      removeSetting(
        selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeEmail
      );
      removeSetting(
        selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeText
      );
      dispatch(updateFormData({ type: "AccessControl", value: "L1" }));
      setEDisclosure(false);
      setMaxPrintsPerReaderText("");
      document
        .getElementById("chkIdentifyLeakersDiv")
        .classList.add("disable_section");
      if (
        selectionOfRestriction.length > 0 ||
        data.pageLevelRestrictionData?.length > 0
      )
        setIsNavigatedFromL2L3(true);

      const noReadersRestrictions = selectionOfRestriction.filter((item) => {
        if (item.category === "No Readers") {
          return { ...item };
        }
      });
      const exceptNoReadersRestrictions = selectionOfRestriction.filter(
        (item) => {
          if (
            item.category ===
            "Selected Readers" ||
            item.category ===
            "Everyone Except Selected Readers"
          ) {
            return { ...item };
          }
        }
      );
      if (noReadersRestrictions.length > 0)
        noReadersRestrictionsRef.current = true;
      if (exceptNoReadersRestrictions.length > 0)
        selectedOrEveryoneExceptSelectedReadersRef.current = true;

      if (exceptNoReadersRestrictions.length === 0) {
        clearPageLevelRestrictions();
        return;
      }
      let msg =
        selectedLanguage.LstLanguageCodes.UI_AllConfiguredRestrictionsRemoved;
      if (noReadersRestrictions.length > 0) {
        msg =
          selectedLanguage.LstLanguageCodes
            .UI_AllConfiguredRestrictionsRemovedExceptNoReaders;
      }

      if (
        pageLevelResRef.current.checked &&
        (selectionOfRestriction.length > 0 ||
          data.pageLevelRestrictionData.length > 0)
      ) {
        unSaveWarnModal.current.open(
          msg,
          () => {
            clearPageLevelRestrictions();
            //restoreRestrictions.current = true;
            backUpOfConfiguredRestrictions.current = [
              ...selectionOfRestriction,
            ];
          },
          () => {
            if (retainSecurityLevel === "L2") level2Ref.current.checked = true;
            else if (retainSecurityLevel === "L3") {
              level2Ref.current.checked = true;
              level3Ref.current.checked = true;
            }
            restoreRestrictions.current = false;
          }
        );
      } else {
        clearPageLevelRestrictions();
      }
      function clearPageLevelRestrictions() {
        SecurityLevel1();
        setSecurityLevel(1);
        setSteganography(false);
        if (noReadersRestrictions.length === 0) {
          pageLevelResRef.current.disabled = true;
          pageLevelResRef.current.checked = false;
          setIsPageLevelRestrictionChecked(false);
          dispatch(updateFormData({ type: "PageLevelRestrictions", value: false }));
        }
        // if (noReadersRestrictions.length > 0) {

        //   // setSelectionOfRestriction(noReadersRestrictions);
        //   // dispatch(
        //   //   retainConfiguredData({
        //   //     isConfirm: data.onConfirm,
        //   //     authorizedReaders: data.authorizedReaders,
        //   //     pageRestrictionData: noReadersRestrictions,
        //   //   })
        //   // );
        // } else {

        //   setSelectionOfRestriction([]);
        //   dispatch(
        //     retainConfiguredData({
        //       isConfirm: data.onConfirm,
        //       authorizedReaders: data.authorizedReaders,
        //       pageRestrictionData: [],
        //     })
        //   );
        // }
        if (!isXLSfileSelected) {
          if (!isPageLevelRestriction) {
            pageLevelResRef.current.disabled = true;
            enablePageLevelRes.current.classList.add("disable_section");
          } else {
            pageLevelResRef.current.disabled = false;
            enablePageLevelRes.current.classList.remove("disable_section");
          }
        }
      }
    }
  }

  function SecurityLevel3() {
    setSendVerificationCodeDisable(false);
    var cb1 = document.getElementById("level2");
    const opt = selectedOptions.find((opt) => opt.value === "email");
    if (opt && tabValue !== "create") {
      updateSetting(selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeEmail, true);
    }
    const isTextSelected = selectedOptions.some((opt) => opt.value === "text");
    if (isTextSelected) {
      updateSetting(
        selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeText,
        true
      );
    }
    setRetainSecurityLevel(level3Ref.current.checked ? "L3" : "L2");
    if (tabValue == "create") {
      setSelectedOptions((prev) => {
        const emailOption = { value: "email", label: selectedLanguage.LstLanguageCodes.UI_Email };
        if (prev.some((opt) => opt.value === "email")) {
          return prev;
        }
        return [...prev, emailOption];
      });

    }
    document.getElementById("lv2").style.display = "block";
    if (identifyLeakersSetting.current && AppContext.ContentSecurity && isIdentifyLeakersDisabled.current && !isXLSfileSelected) {
      document
        .getElementById("chkIdentifyLeakersDiv")
        .classList.remove("disable_section");
    }
    if (isEDisclosure == true && eDisclosureLevel3 && !isXLSfileSelected) {
      document.getElementById("chkEDisclosureDiv").classList.remove("user_register");
    }
    if (document.getElementById("level3").checked) {
      dispatch(updateFormData({ type: "AccessControl", value: "L3" }));
      setSecurityLevel(3);
      if (eDisclosureLevel3 == false) {
        setEDisclosure(false);
      }
      defaultLoginUserAssign(1);
      cb1.checked = true;
      setOpenRecord(true);
      setGeolocation(true);
      setReaderEmail(true);
      setReadTimes(true);
      setReadTiming(true);
      setAuthorizedEmailId([]);
      document.getElementById("lv1").style.display = "none";
      document.getElementById("maxReads").disabled = false;
      document.getElementById("txtRestrictDomains").disabled = false;
      var ticks = document.getElementsByClassName("done");
      for (let i = 0; i < ticks.length; i++) {
        ticks[i].style.display = "block";
      }

      let elements = document.getElementsByClassName("minimize");
      for (let j = 0; j < elements.length; j++) {
        elements[j].style.display = "none";
      }

      var second = document.getElementsByClassName("user_register");
      for (let t = 0; t < second.length; t++) {
        second[t].classList.remove("disable_section");
      }
      setDistRestriction(true);
      if (
        securityLevel === 1 &&
        isNavigatedFromL2L3 &&
        backUpOfConfiguredRestrictions.current.length > 0
      ) {
        let msg =
          selectedLanguage.LstLanguageCodes.UI_IsToRetainNoReadersRestrictions;
        const exceptNoReadersRestrictions =
          backUpOfConfiguredRestrictions.current.filter((item) => {
            if (
              item.category ===
              "Selected Readers" ||
              item.category ===
              "Everyone Except Selected Readers"
            ) {
              return { ...item };
            }
          });
        if (exceptNoReadersRestrictions.length === 0) return;
        unSaveWarnModal.current.open(
          msg,
          () => {
            restoreRestrictions.current = false;
            pageLevelResRef.current.checked = true;
            setIsPageLevelRestrictionChecked(true);
            dispatch(updateFormData({ type: "PageLevelRestrictions", value: true }));

            const backUpId = backUpOfConfiguredRestrictions.current.map(
              (item) => item.id
            );

            const newFilteredRecords = selectionOfRestriction
              .filter((item) => !backUpId.includes(item.id))
              .map((item) => {
                const filteredPages = item.pages.filter(
                  (page) =>
                    !backUpOfConfiguredRestrictions.current.some(
                      (restriction) => restriction.pages.includes(page)
                    )
                );

                console.log(filteredPages);

                return filteredPages.length > 0
                  ? { ...item, pages: filteredPages }
                  : null;
              })
              .filter((item) => item !== null);

            console.log(newFilteredRecords);

            // const filteredById = backUpOfConfiguredRestrictions.current
            //   .map((item) => {
            //     return selectionOfRestriction.filter((record) => {
            //       if (record.id !== item.id) {
            //         return { ...record };
            //       }
            //     });
            //   })
            //   .flat();

            const records = [
              ...newFilteredRecords,
              ...backUpOfConfiguredRestrictions.current,
            ];
            // .sort((a, b) => a.page - b.page);

            setSelectionOfRestriction(records);
            dispatch(
              retainConfiguredData({
                isConfirm: data.onConfirm,
                authorizedReaders: data.authorizedReaders,
                pageRestrictionData: [...records],
              })
            );
          },
          () => {
            setSelectionOfRestriction((prev) => {
              const backUpId = backUpOfConfiguredRestrictions.current
                .filter(
                  (item) =>
                    item.category ===
                    "No Readers"
                )
                .map((item) => item.id);
              const filteredPrevRecords = prev.filter(
                (item) =>
                  item.category ===
                  "No Readers" &&
                  !backUpId.includes(item.id)
              );
              console.log(filteredPrevRecords);
              return [
                ...backUpOfConfiguredRestrictions.current.filter(
                  (item) =>
                    item.category ===
                    "No Readers"
                ),
                ...filteredPrevRecords,
              ];
            });
            //backUpOfConfiguredRestrictions.current = [];
            //setSelectionOfRestriction([]);
            // pageLevelResRef.current.checked = false;
            // setIsPageLevelRestrictionChecked(false);
            // dispatch(
            //   retainConfiguredData({
            //     isConfirm: data.onConfirm,
            //     authorizedReaders: data.authorizedReaders,
            //     pageRestrictionData: [],
            //   })
            // );
          }
        );
      }
    } else {
      if (eDisclosureLevel2 == false) {
        setEDisclosure(false);
      }
      dispatch(updateFormData({ type: "AccessControl", value: "L2" }));
      restoreRestrictions.current = false;
      setSecurityLevel(2);
      document.getElementById("lv2").style.display = "none";
      document.getElementById("lv1").style.display = "block";
      document.getElementById("level2").checked = true;
      setDistRestriction(false);
      setReaderEmail(true);
      setOpenRecord(true);
      setGeolocation(true);
      // setVerifyCode(true);
      setReadTimes(true);
      setReadTiming(true);
    }
    pageLevelResRef.current.disabled = isPageLevelRestriction ? false : true;
    if (!isXLSfileSelected) {
      if (!isPageLevelRestriction)
        enablePageLevelRes.current.classList.add("disable_section");
      else enablePageLevelRes.current.classList.remove("disable_section");
    }
  }
  function getbrowserlanguage(event) {
    const isChecked = event.target.checked;
    setbrowserLanguage(isChecked);
  }
  function ChangeMaxReadsTexts(textValue) {
    textValue = textValue.replace(/[^0-9]+/g, "");
    if (textValue == "") {
      setMaxReads(0);
      setMaxReadsText(textValue);
      //updateSetting(selectedLanguage.LstLanguageCodes.UI_MaxReadsperReader, false);
    } else if (parseInt(textValue) >= 1 && textValue.length <= 6 && parseInt(textValue) <= 100000) {
      setMaxReadsText(parseInt(textValue));
      setMaxReads(parseInt(textValue));
      //updateSetting(selectedLanguage.LstLanguageCodes.UI_MaxReadsperReader, true);
    }
    dispatch(updateFormData({ type: "MaxReadsperReader", value: textValue }));
  }
  function ChangeMaxViewsPerDocumentTexts(textValue) {
    textValue = textValue.replace(/[^0-9]+/g, "");
    if (textValue == "") {
      setMaxViewsPerDocument(0);
      setMaxViewsPerDocumentText(textValue);
      //updateSetting(selectedLanguage.LstLanguageCodes.UI_MaxviewsPerDocument, false);
    } else if (parseInt(textValue) > 100000) {
      setAlertMsg(
        selectedLanguage.LstLanguageCodes.UI_TheMaximumLimitForMaxViewsPerDoc
      );
      setAlertType("warning");
      return;
    } else if (parseInt(textValue) >= 1 && parseInt(textValue) <= 2147483647) {
      setMaxViewsPerDocumentText(parseInt(textValue));
      setMaxViewsPerDocument(parseInt(textValue));
      //updateSetting(selectedLanguage.LstLanguageCodes.UI_MaxviewsPerDocument, true);
    }
    dispatch(updateFormData({ type: "maxViewsPerDocument", value: textValue }));
  }

  function ChangeMaxPrintsPerReaderTexts(textValue) {
    textValue = textValue.replace(/[^0-9]+/g, "");
    if (textValue == "") {
      setMaxPrintsPerReaderText(textValue);
    } else if (textValue.length <= 4 && parseInt(textValue) >= 1 && parseInt(textValue) <= 9999) {
      setMaxPrintsPerReaderText(parseInt(textValue));
    }
    dispatch(updateFormData({ type: "MaxPrintsPerReader", value: textValue }));
  }


  function ChangeMaxPrintsPerDocumentTexts(textValue) {
    textValue = textValue.replace(/[^0-9]+/g, "");
    if (textValue == "") {
      setMaxPrintsPerDocumentText(textValue);
    } else if (textValue.length <= 4 && parseInt(textValue) >= 1 && parseInt(textValue) <= 9999) {
      setMaxPrintsPerDocumentText(parseInt(textValue));
    }
    dispatch(updateFormData({ type: "MaxPrintsPerDocument", value: textValue }));
  }

  function fileSelection(event, source = 0) {
    var selectedFiles;
    xlsFileSelectedRef.current = true;
    if (event.target != undefined)
      selectedFiles = Array.prototype.slice.call(event.target.files);
    else selectedFiles = event;
    var xlsFilesSelected = false;
    var otherFilesSelected = false;
    var validationSucess = true;
    const currentUser = localStorage.getItem("UserName");
    for (let index = 0; index < selectedFiles.length; index++) {
      const objFile = selectedFiles[index];

      // Get the file name without extension
      const fileNameWithoutExtension = objFile.name.substring(
        0,
        objFile.name.lastIndexOf(".")
      );
      let fileFormat = objFile.name
        .split(".")
      [objFile.name.split(".").length - 1].toLowerCase();
      if ((fileFormat == "xls" || fileFormat == "xlsx")) {
        const currentUser = localStorage.getItem("UserName")?.toLowerCase();

        // Handles large comma-separated string safely
        const readersList = AppContext.ExcelConfigReaders?.[0]
          ?.split(",")
          .map(email => email.trim().toLowerCase())
          .filter(Boolean) || [];

        const isAllowed = readersList.includes(currentUser);
        if (isConfiguredUser) {
          xlsFilesSelected = true;
        } else {
          setAlertMsg(
            selectedLanguage.LstLanguageCodes.UI_UnsupportedFileExtensions +
            " " +
            (isConfiguredUser ? selectedLanguage.LstLanguageCodes.UI_XLSCurrentlySupportedFileExtensions : selectedLanguage.LstLanguageCodes.UI_CurrentlySupportedFileExtensions)
          );
          setAlertType("warning");
          validationSucess = false;
          xlsFilesSelected = false;
        }
      }
      else {
        otherFilesSelected = true;
      }
      // Validate unsupported file extensions
      if (
        "pdf/pptx/docx/jpg/jpeg/png/wps/dwg/xls/xlsx".indexOf(
          objFile.name
            .split(".")
          [objFile.name.split(".").length - 1].toLowerCase()
        ) == -1
      ) {
        document.getElementById("imgFile").value = null;

        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_UnsupportedFileExtensions +
          " " +
          (isConfiguredUser
            ? selectedLanguage.LstLanguageCodes.UI_XLSCurrentlySupportedFileExtensions
            : selectedLanguage.LstLanguageCodes.UI_CurrentlySupportedFileExtensions)
        );
        setAlertType("warning");
        if (validationSucess) validationSucess = false;
      }
      if (fileFormat == "csv" && isConfiguredUser) {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_UnsupportedFileExtensions +
          " " + (selectedLanguage.LstLanguageCodes.UI_XLSCurrentlySupportedFileExtensions)
        );
        setAlertType("warning");
        validationSucess = false;
        xlsFilesSelected = false;
      }
      // Validate file size based on tabValue
      if (tabValue == "send") {
        if (objFile.size > AppContext.FileSizeSend * 1024 * 1024) {
          document.getElementById("imgFile").value = null;
          setAlertMsg(
            selectedLanguage.LstLanguageCodes.UI_Themaximumsizelessthan20
          );
          setAlertType("warning");
          xlsFilesSelected = false;
          validationSucess = false;
        }
      } else {
        if (objFile.size > AppContext.FileSizeCreate * 1024 * 1024) {
          document.getElementById("imgFile").value = null;
          setAlertMsg(
            selectedLanguage.LstLanguageCodes.UI_Themaximumsizelessthan25
          );
          setAlertType("warning");
          xlsFilesSelected = false;
          validationSucess = false;
        }
      }

      // Validate file name length without extension
      if (fileNameWithoutExtension.length > AppContext.FileNameLength) {
        document.getElementById("imgFile").value = null;
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_FileNameShouldNotbegreaterthan200
        );
        setAlertType("warning");
        validationSucess = false;
      }
    }
    if (xlsFilesSelected && isConfiguredUser) {
      setIsXLSfileSelected(true);
      xlsFileSelectedRef.current = true;
      setIsRPDLight(true);
      setIsRPDLightDisabled(true);
      multipleRPDsYes();
    }

    // If validation is successful, add input fields
    if (validationSucess) {
      setSelectedFile(selectedFiles);
      addInputField(selectedFiles, source);
    }
  }
  function fileSelectionClick(event) {
    event.target.value = null;
  }
  function fileDeletion() {
    document.getElementById("imgFile").value = null;
    setFile("");
    setFileName("");
    setFileLength("0 kb");
  }
  function handlerExpirationDays(event) {
    setExpirationDaysFlag(event);
    calcExpirationDays(startTime, expiryTime, event);
  }
  function handleSetVoting(value) {
    setVoting(value);
    if (value == true) {
      document
        .getElementsByClassName("disable_sectionChailedClass")[0]
        .classList.remove("disable_sectionChailed");
    } else {
      document
        .getElementsByClassName("disable_sectionChailedClass")[0]
        .classList.add("disable_sectionChailed");
      setVoteSharing(false);
    }
  }
  function handlerExpirationDaysStartTime(e, OnLoadRDocsDataSend = false) {
    var event = "";
    if (e != null) {
      // if (eflag == true ) {
      //   event = e.toISOString().split('T')[0]+"T"+e.getHours()+":"+e.getMinutes();
      // } else {
      event = e;
      //}
    }

    calcExpirationDays(
      event != "" && event != null
        ? moment(event).format("YYYY-MM-DDTHH:mm")
        : "",
      moment(expiryTime).format("YYYY-MM-DDTHH:mm"),
      expirationDaysFlag
    );
    if (isDatetimeControl == "false") {
      if (event != "" && expiryTime != "" && event > expiryTime) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_TheLaunchDate);
        setAlertType("warning");
        setAlertClass("alerthist-ip");
      }
      setStartTime(event);
    } else {
      if (event != "" && event != undefined) {
        const [startHour, startMinute] = moment(event)
          .format("YYYY-MM-DDTHH:mm")
          .split("T")[1]
          .split(":")
          .map(Number);
        if (
          event != "" &&
          expiryTime != "" &&
          moment(event).format("YYYY-MM-DDTHH:mm").split("T")[0] >
          moment(expiryTime).format("YYYY-MM-DDTHH:mm").split("T")[0]
        ) {
          setAlertMsg(selectedLanguage.LstLanguageCodes.UI_TheLaunchDate);
          setAlertType("warning");
          setAlertClass("alerthist-ip");
        }
        if (
          event != "" &&
          expiryTime != "" &&
          moment(event).format("YYYY-MM-DDTHH:mm").split("T")[0] ==
          moment(expiryTime).format("YYYY-MM-DDTHH:mm").split("T")[0]
        ) {
          const [endHour, endMinute] = moment(expiryTime)
            .format("YYYY-MM-DDTHH:mm")
            .split("T")[1]
            .split(":")
            .map(Number);
          if (
            startHour > endHour ||
            (startHour === endHour && startMinute > endMinute)
          ) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_TheLaunchtime);
            setAlertType("warning");
            setAlertClass("alerthist-ip");
          }
        }
      }
      setStartTime(e);

    }
    dispatch(updateFormData({ type: "Launches", value: e?.toUTCString() }));
    // if (eflag == true) {
    //   e.target.blur();
    // }
  }

  function handlerExpirationDaysExpiryTimeOutlook(e, startTimeoutlook) {
    var tempStartDate = moment(startTimeoutlook).format("YYYY-MM-DD");

    var event = "";
    if (e != null) {
      // if (eflag == true) {
      //   event = e.toISOString().split('T')[0]+"T"+e.getHours()+":"+e.getMinutes();
      // } else {
      event = e;
      //}
    }
    if (isDatetimeControl == "false") {
      if (startTimeoutlook == "" || startTimeoutlook == null)
        tempStartDate = moment().utc().format("YYYY-MM-DD");
      //event = moment(event).format("YYYY-MM-DD");

      if (event != "" && tempStartDate > moment(event).format("YYYY-MM-DD")) {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_TheExpirydateCannotBefore
        );
        setAlertType("warning");
        setAlertClass("alerthist-ip");
      }
      setExpiryTime(event);
      calcExpirationDays(
        startTimeoutlook != "" && startTimeoutlook != null
          ? moment(startTimeoutlook).format("YYYY-MM-DDTHH:mm")
          : "",
        event != "" && event != null
          ? moment(event).format("YYYY-MM-DDTHH:mm")
          : "",
        expirationDaysFlag
      );
    } else {
      if (event != "") {
        const [endHour, endMinute] = moment(event)
          .format("YYYY-MM-DDTHH:mm")
          .split("T")[1]
          .split(":")
          .map(Number);
        if (startTimeoutlook == "" || startTimeoutlook == null)
          tempStartDate = moment().utc().format("YYYY-MM-DDTHH:mm");

        if (
          event != "" &&
          tempStartDate.split("T")[0] >
          moment(event).format("YYYY-MM-DDTHH:mm").split("T")[0]
        ) {
          setAlertMsg(
            selectedLanguage.LstLanguageCodes.UI_TheExpirydateCannotBefore
          );
          setAlertType("warning");
          setAlertClass("alerthist-ip");
        }
        if (
          event != "" &&
          tempStartDate ==
          moment(event).format("YYYY-MM-DDTHH:mm").split("T")[0]
        ) {
          const [startHour, startMinute] = moment(startTimeoutlook)
            .format("YYYY-MM-DDTHH:mm")
            .split("T")[1]
            .split(":")
            .map(Number);
          if (
            startHour > endHour ||
            (startHour === endHour && startMinute > endMinute)
          ) {
            setAlertMsg(
              selectedLanguage.LstLanguageCodes.UI_TheExpirytimeCannotBefore
            );
            setAlertType("warning");
            setAlertClass("alerthist-ip");
          }
        }
      }
      setExpiryTime(e);
      calcExpirationDays(
        startTimeoutlook != "" && startTimeoutlook != null
          ? moment(startTimeoutlook).format("YYYY-MM-DDTHH:mm")
          : "",
        event != "" && event != null
          ? moment(event).format("YYYY-MM-DDTHH:mm")
          : "",
        expirationDaysFlag
      );
    }
    // if (eflag == true) {
    //   e.target.blur();
    // }
  }
  function handleCloseValidationModal() {
    setShowValidationModal(false);
    setIsSendGenerateClick(false);
    isSendGenerateRef.current = false;
    validationShowRef.current = false;
  }
  function onConfirm(e) {
    setShowValidationModal(false);
    setIsSendGenerateClick(false);
    if (template?.idLeakers == true) {
      setSteganography(false);
      identifyLeakersRef.current.checked = false;
    }
    if (template?.sendVerifiCationCodeText == true) {
      setIsSMS(false);
      document.getElementById("emailVerify").checked = false;
    }
    if (template?.eDisclosure == true) {
      setIsEDisclosure(false);
    }
    isSendGenerateRef.current = true;
    validationShowRef.current = false;
    uploadsend(e);
  }
  function handlerExpirationDaysExpiryTimeWithRdocsSend(e, startTime, dateControlFormat) {
    var tempStartDate = moment(startTime).format("YYYY-MM-DD");
    var event = "";
    if (e != null) {
      // if (eflag == true) {
      //   event = e.toISOString().split('T')[0]+"T"+e.getHours()+":"+e.getMinutes();
      // } else {
      event = e;
      //}
    }
    if (dateControlFormat == false) {
      if (startTime == "") tempStartDate = moment().utc().format("YYYY-MM-DD");
      //event = moment(event).format("YYYY-MM-DD");

      if (event != "" && tempStartDate > moment(event).format("YYYY-MM-DD")) {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_TheExpirydateCannotBefore
        );
        setAlertType("warning");
        setAlertClass("alerthist-ip");
      }
      setExpiryTime(event);
      calcExpirationDays(
        startTime != "" && startTime != null
          ? moment(startTime).format("YYYY-MM-DDTHH:mm")
          : "",
        event != "" && event != null
          ? moment(event).format("YYYY-MM-DDTHH:mm")
          : "",
        expirationDaysFlag
      );
    } else {
      if (event != "") {
        const [endHour, endMinute] = moment(event)
          .format("YYYY-MM-DDTHH:mm")
          .split("T")[1]
          .split(":")
          .map(Number);
        if (startTime == "" || startTime == null)
          tempStartDate = moment().utc().format("YYYY-MM-DDTHH:mm");

        if (
          event != "" &&
          tempStartDate.split("T")[0] >
          moment(event).format("YYYY-MM-DDTHH:mm").split("T")[0]
        ) {
          setAlertMsg(
            selectedLanguage.LstLanguageCodes.UI_TheExpirydateCannotBefore
          );
          setAlertType("warning");
          setAlertClass("alerthist-ip");
        }
        if (
          event != "" &&
          tempStartDate ==
          moment(event).format("YYYY-MM-DDTHH:mm").split("T")[0]
        ) {
          const [startHour, startMinute] = moment(startTime)
            .format("YYYY-MM-DDTHH:mm")
            .split("T")[1]
            .split(":")
            .map(Number);
          if (
            startHour > endHour ||
            (startHour === endHour && startMinute > endMinute)
          ) {
            setAlertMsg(
              selectedLanguage.LstLanguageCodes.UI_TheExpirytimeCannotBefore
            );
            setAlertType("warning");
            setAlertClass("alerthist-ip");
          }
        }
      }
      setExpiryTime(e);
      calcExpirationDays(
        startTime != "" && startTime != null
          ? moment(startTime).format("YYYY-MM-DDTHH:mm")
          : "",
        event != "" && event != null
          ? moment(event).format("YYYY-MM-DDTHH:mm")
          : "",
        expirationDaysFlag
      );
    }
    // if (eflag == true) {
    //   e.target.blur();
    // }
  }

  function handlerExpirationDaysExpiryTime(e, OnLoadRDocsDataSend = false) {
    var tempStartDate = moment(startTime).format("YYYY-MM-DD");

    var event = "";
    if (e != null) {
      // if (eflag == true) {
      //   event = e.toISOString().split('T')[0]+"T"+e.getHours()+":"+e.getMinutes();
      // } else {
      event = e;
      //}
    }
    dispatch(updateFormData({ type: "Expires", value: e?.toUTCString() }));
    if (isDatetimeControl == "false") {
      if (startTime == "") tempStartDate = moment().utc().format("YYYY-MM-DD");
      //event = moment(event).format("YYYY-MM-DD");

      if (event != "" && tempStartDate > moment(event).format("YYYY-MM-DD")) {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_TheExpirydateCannotBefore
        );
        setAlertType("warning");
        setAlertClass("alerthist-ip");
      }
      setExpiryTime(event);
      calcExpirationDays(
        startTime != "" && startTime != null
          ? moment(startTime).format("YYYY-MM-DDTHH:mm")
          : "",
        event != "" && event != null
          ? moment(event).format("YYYY-MM-DDTHH:mm")
          : "",
        expirationDaysFlag
      );
    } else {
      if (event != "") {
        const [endHour, endMinute] = moment(event)
          .format("YYYY-MM-DDTHH:mm")
          .split("T")[1]
          .split(":")
          .map(Number);
        if (startTime == "" || startTime == null)
          tempStartDate = moment().utc().format("YYYY-MM-DDTHH:mm");

        if (
          event != "" &&
          tempStartDate.split("T")[0] >
          moment(event).format("YYYY-MM-DDTHH:mm").split("T")[0]
        ) {
          setAlertMsg(
            selectedLanguage.LstLanguageCodes.UI_TheExpirydateCannotBefore
          );
          setAlertType("warning");
          setAlertClass("alerthist-ip");
        }
        if (
          event != "" &&
          tempStartDate ==
          moment(event).format("YYYY-MM-DDTHH:mm").split("T")[0]
        ) {
          const [startHour, startMinute] = moment(startTime)
            .format("YYYY-MM-DDTHH:mm")
            .split("T")[1]
            .split(":")
            .map(Number);
          if (
            startHour > endHour ||
            (startHour === endHour && startMinute > endMinute)
          ) {
            setAlertMsg(
              selectedLanguage.LstLanguageCodes.UI_TheExpirytimeCannotBefore
            );
            setAlertType("warning");
            setAlertClass("alerthist-ip");
          }
        }
      }
      setExpiryTime(e);
      calcExpirationDays(
        startTime != "" && startTime != null
          ? moment(startTime).format("YYYY-MM-DDTHH:mm")
          : "",
        event != "" && event != null
          ? moment(event).format("YYYY-MM-DDTHH:mm")
          : "",
        expirationDaysFlag
      );
    }
    // if (eflag == true) {
    //   e.target.blur();
    // }
  }
  function secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor((d % 3600) / 60);
    var s = Math.floor((d % 3600) % 60);

    var hDisplay = h > 9 ? h : "0" + h;
    var mDisplay = m > 9 ? m : "0" + m;
    var sDisplay = s > 9 ? s : "0" + s;
    return hDisplay + ":" + mDisplay + ":" + sDisplay;
  }
  function daysRemaining(vStartTime, vExpiryTime) {
    var diffDays =
      moment.utc(vExpiryTime).diff(
        moment.utc(
          vStartTime !== "" ? vStartTime : moment.utc(new Date()).startOf("day")
        ), //updated
        "days"
      );
    if (diffDays == 366) {
      diffDays = diffDays - 1;
    }
    var diffSeconds = moment.utc(vExpiryTime).diff(
      moment.utc(vStartTime !== "" ? vStartTime : moment().utc()), //updated
      "seconds"
    );
    var diffTime = secondsToHms(diffSeconds);
    setExpirationDays(
      diffDays > 1
        ? diffDays + " Days"
        : diffDays === 1
          ? diffDays + " Day"
          : diffSeconds > 0
            ? diffTime
            : ""
    );
  }
  function showValidationPopup(selectedTemplate) {
    const validationRows = [];
    if (
      selectedTemplate?.idLeakers === true &&
      identifyLeakersSetting.current == false
    ) {
      validationShowRef.current = true;
      validationRows.push({
        field: selectedLanguage.LstLanguageCodes.UI_IDLeakers,
        issue: selectedLanguage.LstLanguageCodes.UI_Featurenotenabled
      });
    }
    if (
      selectedTemplate?.sendVerifiCationCodeText === true &&
      isSMSAuthentication === false
    ) {
      validationShowRef.current = true;
      validationRows.push({
        field: selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeText,
        issue: selectedLanguage.LstLanguageCodes.UI_Featurenotenabled
      });
    }
    if (
      selectedTemplate?.eDisclosure === true &&
      isEDisclosure === false
    ) {
      validationShowRef.current = true;
      validationRows.push({
        field: selectedLanguage.LstLanguageCodes.UI_EDisclosure,
        issue: selectedLanguage.LstLanguageCodes.UI_Featurenotenabled
      });
    }
    if (validationRows.length > 0) {
      setValidationRows(validationRows);
      setShowValidationModal(true);
      setOpen(false);
      return true;
    } else {
      setShowValidationModal(false);
      return false;
    }
  }
  if (identifyLeakersSetting.current && securityLevel !== 1 && template?.rDocsLevel !== 1 && isXLSfileSelected == false) {
    identifyLeakerWrapperRef.current.classList.remove("disable_section");
  }
  useEffect(() => {
    if (isProofOfSending && tabValue == "send") {
      setProofOfSending(true);
      updateSetting(selectedLanguage.LstLanguageCodes.UI_ProofOfSending, true);
    }
    else updateSetting(selectedLanguage.LstLanguageCodes.UI_ProofOfSending, false);
    if (!template) return;
    if (template?.allowResponsesTo === true) { setConstAllowResFlag(true); }
    else setConstAllowResFlag(false);
    if (template?.notificationOfReading === true) {
      document.getElementById("readNotify").checked = true;
      setReadNotification(true);
    }
    else { document.getElementById("readNotify").checked = false; setReadNotification(false); }
    if (template?.timestamp === true) { setTimestamp(true); }
    else setTimestamp(false);
    if (template?.voting === true) {
      document.getElementById("voting").checked = true;
      document.getElementById("voteShare_id").classList.remove("disable_sectionChailed");
      setVoting(true);
    }
    else {
      document.getElementById("voting").checked = false;
      setVoting(false);
    }
    if (template?.voteSharing === true) { setVoteSharing(true); }
    else setVoteSharing(false);
    if (tabValue == "send") {
      if (template?.proofOfSending === true) {
        document.getElementById("confirmation").checked = true;
        setProofOfSending(true);
      } else {
        document.getElementById("confirmation").checked = false;
        setProofOfSending(false);
      }
    }
    if (template?.canPrint == true) { setPrint(true); }
    else setPrint(false);
    if (template?.distributionList == true) {
      document.getElementById("distribution").checked = true;
      setDistributionList(true);
    }
    else {
      document.getElementById("distribution").checked = false;
      setDistributionList(false);
    }

    if (template?.rDocsLevel == 1) {
      document.getElementById("level1").checked = true;
      SecurityLevel1();
      document.getElementById("chkIdentifyLeakersDiv").classList.add("disable_section");
    }
    if (template?.rDocsLevel == 2) {
      document.getElementById("level2").checked = true;
      SecurityLevel2();
    }
    if (template?.rDocsLevel == 3) {
      document.getElementById("level3").checked = true;
      SecurityLevel3();
    }
    if (template?.sendVerifiCationCodeEmail === true) {
      setIsEmail(true);
      if (tabValue == "send") {
        setVerifyCode(true);
        document.getElementById("emailVerify").checked = true;
      }
      else {
        setVerifyCode(false);
        document.getElementById("emailVerify").checked = false;
      }
    }
    if (template?.sendVerifiCationCodeText == true && template?.sendVerifiCationCodeEmail === false) {
      setIsSMS(true);
      //      updateSetting(
      //   selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeEmail,
      //   false
      // );
      //       updateSetting(
      //   selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeText,
      //   true
      // );
      if (template?.rDocsLevel == 2 && tabValue == "create") {
        setIsEmail(true);

        const emailOption = {
          value: "email",
          label: selectedLanguage.LstLanguageCodes.UI_Email,
        };
        updateSetting(
          selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeEmail,
          true
        );
        setSelectedOptions((prev) => {
          const exists = prev.some((el) => el.value === "email");
          if (exists) return prev;
          return [...prev, emailOption];
        });
      } else {
        setIsEmail(false);
        setSelectedOptions((prev) =>
          prev.filter((el) => el.value !== "email")
        );
      }

    }
    if (template?.eDisclosure === true) {
      if (isEDisclosure == true) { setEDisclosure(true); }
    } else setEDisclosure(false);
    if (validationShowRef.current == false) {
      const hasVerification =
        template?.sendVerifiCationCodeText === true ||
        template?.sendVerifiCationCodeEmail === true;

      if (tabValue == "send" && hasVerification) {
        setVerifyCode(true);
        document.getElementById("emailVerify").checked = true;
        if (template?.sendVerifiCationCodeText === true) setIsSMS(true);
      } else if (tabValue == "create" && template?.rDocsLevel == 2 && hasVerification) {
        setVerifyCode(false);
      } else {
        setVerifyCode(false);
        document.getElementById("emailVerify").checked = false;
      }
      if (template?.eDisclosure === true) { setEDisclosure(true); }
      else setEDisclosure(false);
    }

    if (template?.maxReadsPerReader > 0) {
      setMaxReads(template.maxReadsPerReader);
      setMaxReadsText(template.maxReadsPerReader);
    } else {
      setMaxReads(0);
      setMaxReadsText("");
    }
    if (template?.maxViewsPerDocument > 0) {
      setMaxViewsPerDocument(template.maxViewsPerDocument);
      setMaxViewsPerDocumentText(template.maxViewsPerDocument);
    } else {
      setMaxViewsPerDocument(0);
      setMaxViewsPerDocumentText("");
    }
    if (template?.maxPrintsPerReader > 0 && template?.canPrint == true && template?.rDocsLevel !== 1) {
      setMaxPrintsPerReaderText(template.maxPrintsPerReader);
    } else {
      setMaxPrintsPerReaderText("");
    }
    if (template?.maxPrintsPerDocument > 0) {
      setMaxPrintsPerDocumentText(template.maxPrintsPerDocument);
    } else {
      setMaxPrintsPerDocumentText("");
    }

  }, [template]);
  // useEffect(()=>{
  //         if (template?.rdocsLevel == 2 && tabValue == "create") {
  //       setIsEmail(true);
  //       const emailOption = {
  //         value: "email",
  //         label: selectedLanguage.LstLanguageCodes.UI_Email,
  //       };
  //       updateSetting(
  //         selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeEmail,
  //         true
  //       );
  //       setSelectedOptions((prev) => {
  //         const exists = prev.some((el) => el.value === "email");
  //         if (exists) return prev;
  //         return [...prev, emailOption];
  //       });
  //     } else {
  //       setIsEmail(false);
  //       setSelectedOptions((prev) =>
  //         prev.filter((el) => el.value !== "email")
  //       );
  //     }
  // },[securityLevel])
  function handleTemplateChange(event) {
    const selectedTemplateId = event.target.value;
    const selectedTemplate = TemplatesData.find(
      (template) => template.templateName === selectedTemplateId
    );

    // Always reflect the dropdown's new value first so the controlled <select>
    // stays in sync even when we early-return below.
    setSelectedTemplate(selectedTemplateId);

    // Handle the "Apply Template" placeholder (value === "") explicitly.
    // The previous code had `if (selectedTemplate && !selectedTemplate)` which
    // is always false, and then dereferenced `selectedTemplate.idLeakers`
    // (TypeError on undefined) — silently aborting the rest of the handler
    // and leaving stale state in place.
    if (!selectedTemplate) {
      dispatch(storeIdentifyLeakers({ cipherText: [], floatingText: [] }));
      setTemplate(null);
      return;
    }

    dispatch(storeIdentifyLeakers({
      cipherText: selectedTemplate?.cipherText || [],
      floatingText: selectedTemplate?.floatingText || []
    }));
    // dispatch(storeTemplateIdentifyLeakers({
    //   cipherText: selectedTemplate?.cipherText || [],
    //   floatingText: selectedTemplate?.floatingText || []
    // }));
    if (selectedTemplate.idLeakersType && selectedTemplate.idLeakersType !== idLeakersType && idLeakersType !== "Cipher and Floating Text") {
      setIsIdLeakersTypeMatched(true);
      setText("Some ID Leakers settings configured in this template are currently disabled in account settings. Click Confirm to proceed with the available settings, or Cancel to remove the ID Leakers feature.")
      return;
    }
    if (selectedTemplate.idLeakers == true && identifyLeakersSetting.current == true) {
      setSteganography(true);
      if (identifyLeakersRef.current)
        identifyLeakersRef.current.checked = true;
      if (!lookupData || Object.keys(lookupData).length === 0) {
        fetchLookupData();
      }
    }
    // Spread into a NEW object reference so that re-selecting the same
    // template still triggers the [template]-dependent useEffect. Without
    // this, React bails out (Object.is equal) and the related-field
    // resets in that effect never run.
    setTemplate({ ...selectedTemplate });
    showValidationPopup(selectedTemplate);
    const emailOption = { value: "email", label: selectedLanguage.LstLanguageCodes.UI_Email, };
    const smsOption = { value: "text", label: selectedLanguage?.LstLanguageCodes?.UI_Text, };
    let updated = [];
    const wantsEmail = selectedTemplate?.sendVerifiCationCodeEmail !== false || !selectedTemplate?.sendVerifiCationCodeText;

    if (wantsEmail)
      updated.push(emailOption);

    if (isSMSAuthentication && selectedTemplate?.sendVerifiCationCodeText === true)
      updated.push(smsOption);

    if (updated.length === 0)
      updated.push(emailOption);

    setSelectedOptions(updated);
    const Regions = selectedTemplate?.regions || selectedTemplate?.bannedRegions;
    if (Regions && Regions.length > 0) {
      const regionArray = Array.isArray(Regions)
        ? Regions
        : Regions.replace(/[{}]/g, "").split(",").map((r) => r.trim()).filter(Boolean);
      const matchedOptions = RegionValues.filter((option) =>
        regionArray.includes(option.value)
      );
      const excludedValues = RegionValues.filter(
        (region) => !matchedOptions.includes(region)
      ).map((r) => r.value);
      setConstContinents(excludedValues);
      if (childWorldContinents.current) {
        childWorldContinents.current.setWorldContinents(excludedValues);
      }
    } else {
      const allRegionValues = RegionValues.map((r) => r.value);
      setConstContinents(allRegionValues);
      if (childWorldContinents.current) {
        childWorldContinents.current.setWorldContinents(allRegionValues);
      }
    }
    const AllowedIP = Array.isArray(selectedTemplate?.ips) && selectedTemplate.ips.length > 0
      ? selectedTemplate.ips
      : selectedTemplate?.allowedIP || "";
    if (AllowedIP && AllowedIP.length > 0) {
      const ipArrayList = Array.isArray(AllowedIP)
        ? AllowedIP.map((ip) => ip.trim()).filter(Boolean)
        : AllowedIP.replace(/[{}]/g, "").split(",").map((ip) => ip.trim()).filter(Boolean);
      setConstMultipleIps(ipArrayList);
      if (childIPs.current) {
        childIPs.current.setUserArrayIpList(ipArrayList);
      }
    } else {
      setConstMultipleIps("");
      if (childIPs.current) {
        childIPs.current.setUserArrayIpList([]);
      }
    }
    const Domains =
      selectedTemplate?.domains ||
      selectedTemplate?.restrictToDomains ||
      selectedTemplate?.restrictToDomain ||
      "";
    setDomains(Domains);
    dispatch(updateFormData({ type: "RestrictToDomains", value: Domains }));

  }
  const FEATURE_MAP = {
    [selectedLanguage.LstLanguageCodes.UI_TimeStamp]: timestamp,
    [selectedLanguage.LstLanguageCodes.UI_CanPrint]: canPrint,
    [selectedLanguage.LstLanguageCodes.UI_Voting]: voting,
    [selectedLanguage.LstLanguageCodes.UI_ShareVotes]: voteSharing,
    // [selectedLanguage.LstLanguageCodes.UI_EDisclosure]: isEDisclosure,
    [selectedLanguage.LstLanguageCodes.UI_NotificationofReading]: readNotification,
    [selectedLanguage.LstLanguageCodes.UI_AllowResponsesTo]: constAllowResFlag,
    [selectedLanguage.LstLanguageCodes.UI_DisplayDistributionlist]: distributionList,
    [selectedLanguage.LstLanguageCodes.UI_ProofOfSending]: proofOfSending
  };
  useEffect(() => {
    // Remove stale keys from a previous language so they don't appear as duplicates
    const currentKeys = Object.keys(FEATURE_MAP);
    prevFeatureMapKeys.current.forEach(oldKey => {
      if (!currentKeys.includes(oldKey)) {
        removeSetting(oldKey);
      }
    });
    prevFeatureMapKeys.current = currentKeys;

    Object.entries(FEATURE_MAP).forEach(([key, value]) => {
      updateSetting(key, value);
    });
  }, [
    timestamp,
    canPrint,
    voting,
    voteSharing,
    // isEDisclosure,
    readNotification,
    constAllowResFlag,
    distributionList,
    proofOfSending,
    securityLevel,
    selectedLanguage
  ]);
  // Re-key non-FEATURE_MAP feature entries (ID Leakers, E-Disclosure,
  // Max reads/views) when the language changes, so they are
  // not lost/read as false under the new translated key.
  useEffect(() => {
    const prevLang = prevSelectedLanguageRef.current;
    if (prevLang && prevLang !== selectedLanguage) {
      setSettingsTemplateCreation(prev => {
        if (!prev) return prev;
        const updated = { ...prev };
        AUX_TEMPLATE_KEY_NAMES.forEach(name => {
          const oldKey = prevLang?.LstLanguageCodes?.[name];
          const newKey = selectedLanguage?.LstLanguageCodes?.[name];
          if (
            oldKey && newKey && oldKey !== newKey &&
            Object.prototype.hasOwnProperty.call(updated, oldKey)
          ) {
            updated[newKey] = updated[oldKey];
            delete updated[oldKey];
          }
        });
        return updated;
      });
    }
    prevSelectedLanguageRef.current = selectedLanguage;
  }, [selectedLanguage]);
  // Keep the Send verification code entries in settingsTemplateCreation always keyed
  // by the CURRENT language and derived from the source of truth (selected auth
  // options + security level), so they display in the Create Template popup in every
  // language. Mirrors how FEATURE_MAP re-applies its features on language change.
  useEffect(() => {
    const codes = selectedLanguage?.LstLanguageCodes;
    if (!codes) return;
    const emailKey = codes.UI_SendVerificationcodeEmail;
    const textKey = codes.UI_SendVerificationcodeText;
    const isEmailSel = securityLevel >= 2 && !!selectedOptions?.some(o => (o?.value || o) === "email");
    const isTextSel = securityLevel >= 2 && !!selectedOptions?.some(o => (o?.value || o) === "text");
    setSettingsTemplateCreation(prev => {
      const updated = { ...(prev || {}) };
      const prevEmailKey = prevVerifKeysRef.current.email;
      const prevTextKey = prevVerifKeysRef.current.text;
      if (prevEmailKey && prevEmailKey !== emailKey) delete updated[prevEmailKey];
      if (prevTextKey && prevTextKey !== textKey) delete updated[prevTextKey];
      updated[emailKey] = isEmailSel;
      updated[textKey] = isTextSel;
      return updated;
    });
    prevVerifKeysRef.current = { email: emailKey, text: textKey };
  }, [selectedLanguage, selectedOptions, securityLevel]);
  function calcExpirationDays(vStartTime, vExpiryTime, vExpirationDaysFlag) {
    if (isDatetimeControl == "false") {
      if (vExpirationDaysFlag) {
        daysRemaining(vStartTime, vExpiryTime);
      } else {
        setExpirationDays("");
      }
      var utctimee = moment.utc(new Date()).startOf("day");
      var formattedStartTime = moment.utc(vStartTime).format("YYYY-MM-DD");
      var formattedExpiryTime = moment.utc(vExpiryTime).format("YYYY-MM-DD");
      // if (
      //   formattedStartTime != "Invalid date" &&
      //   formattedExpiryTime != "Invalid date"
      // ) {
      if (
        formattedStartTime === formattedExpiryTime &&
        formattedStartTime > utctimee.format("YYYY-MM-DD")
      ) {
        var startedtime = "00:00:000";
        var expirytoday = "23:59:59";
        var startedtimemoment = moment.utc(startedtime, "HH:mm:ss");
        var expiryTimeMoment = moment.utc(expirytoday, "HH:mm:ss");
        var timeDifference = expiryTimeMoment.diff(startedtimemoment);
        var formattedDifference = moment.utc(timeDifference).format("HH:mm:ss");
        setExpirationDays(formattedDifference);
      }
      if (formattedExpiryTime === utctimee.format("YYYY-MM-DD")) {
        var utctime = moment.utc();
        var expirytoday = "23:59:59";
        var expiryTimeMoment = moment.utc(expirytoday, "HH:mm:ss");
        var timeDifference = expiryTimeMoment.diff(utctime);
        var formattedDifference = moment.utc(timeDifference).format("HH:mm:ss");
        setExpirationDays(formattedDifference);
      }

      if (
        vExpiryTime === vStartTime &&
        formattedStartTime === utctimee.format("YYYY-MM-DD")
      ) {
        var utctime = moment.utc();
        var expirytoday = "23:59:59";
        var expiryTimeMoment = moment.utc(expirytoday, "HH:mm:ss");
        var timeDifference = expiryTimeMoment.diff(utctime);
        var formattedDifference = moment.utc(timeDifference).format("HH:mm:ss");
        setExpirationDays(formattedDifference);
      }
      if (
        utctimee.format("YYYY-MM-DD") > formattedStartTime &&
        formattedExpiryTime === utctimee.format("YYYY-MM-DD") &&
        formattedStartTime != ""
      ) {
        daysRemaining(vStartTime, vExpiryTime);
      }
      if (!vStartTime && !vExpiryTime) {
        setExpirationDays(" ");
      }
      // }
    } else {
      if (vExpirationDaysFlag) {
        vExpiryTime = moment.utc(vExpiryTime + ":59");
        var diffDays = moment.utc(vExpiryTime).diff(
          moment.utc(
            vStartTime != "" && vStartTime != null
              ? moment.utc(vStartTime + ":00")
              : moment.utc(new Date()).startOf("day")
          ), //updated
          "days"
        );
        var diffSeconds = moment.utc(vExpiryTime).diff(
          moment.utc(
            vStartTime !== "" && vStartTime != null
              ? vStartTime + ":00"
              : moment().utc()
          ), //updated
          "seconds"
        );
        var diffTime = calculateDaysHrsMin(
          vStartTime !== "" && vStartTime != null
            ? moment.utc(vStartTime + ":00")
            : moment().utc(),
          vExpiryTime
        );
        setExpirationDays(
          diffDays > 1 && diffSeconds > 0
            ? diffDays + " Days " + diffTime
            : diffDays > 1 && diffSeconds == 0
              ? diffDays + " Days"
              : diffDays === 1 && diffSeconds > 0
                ? diffDays + " Day " + diffTime
                : diffDays === 1 && diffSeconds == 0
                  ? diffDays + " Day"
                  : diffDays == 0 && diffSeconds > 0
                    ? diffTime
                    : ""
        );
      } else {
        setExpirationDays("");
      }
    }
  }
  function calculateDaysHrsMin(vStartTime, vExpiryTime) {
    const startTime = new Date(vStartTime).getTime();
    const endTime = new Date(vExpiryTime).getTime();
    const timeDifference = endTime - startTime;

    const seconds = Math.floor(timeDifference / 1000) % 60;
    const minutes = Math.floor(timeDifference / (1000 * 60)) % 60;
    const hours = Math.floor(timeDifference / (1000 * 60 * 60)) % 24;
    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    var hDisplay = hours > 9 ? hours : "0" + hours;
    var mDisplay = minutes > 9 ? minutes : "0" + minutes;
    var sDisplay = seconds > 9 ? seconds : "0" + seconds;
    return hDisplay + ":" + mDisplay + ":" + sDisplay;
  }
  // function getCookie(name) {
  //   var nameEQ = name + "=";
  //   var ca = document.cookie.split(";");
  //   for (var i = 0; i < ca.length; i++) {
  //     var c = ca[i];
  //     while (c.charAt(0) == " ") c = c.substring(1, c.length);
  //     if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  //   }
  //   return null;
  // }
  function handlerModelCancel() {
    clearControls();
    setModalIsOpen(false);
  }
  function handlerUpdateModelCancel() {
    setIsModelOpenChild(true);
    setModalIsUpdateConfirmOpen(false);
    setShowValidationModal(false);
    setIsConfirmClicked(false);
  }

  const handleManageTemplate = () => {
    setShowManageTemplates(true);
    const defaultData = {
      cipherText: initialIdLeakersData.current?.cipherText,
      floatingText: initialIdLeakersData.current?.floatingText
    };
    dispatch(storeTemplateIdentifyLeakers(defaultData));
  }
  const handleCreateTemplateFromSettings = () => {
    var arrCidrs = [];
    for (let item of document
      .getElementById("multipleips")
      .attributes["constmultipleips"].value.split(",")) {
      arrCidrs.push(item);
    }

    var mapContinets = document.getElementsByClassName(
      "map-selected gContinent"
    );
    var arrMapContinents = [];
    if (mapContinets.length === 0) {
      setAlertMsg(
        selectedLanguage.LstLanguageCodes.UI_AtleastOneRegionShouldbePermitted
      );
      setAlertType("warning");
      return;
    }

    for (let item of mapContinets) {
      arrMapContinents.push(item.id);
    }
    if (maxViewsPerDocumentText !== "")
      updateSetting(selectedLanguage.LstLanguageCodes.UI_MaxviewsPerDocument, true);
    if (maxReadsText !== "")
      updateSetting(selectedLanguage.LstLanguageCodes.UI_MaxReadsperReader, true);
    setContinentsForTemplateC(arrMapContinents);
    //updateSetting(selectedLanguage.LstLanguageCodes.UI_BannedRegions, true);
    setIpsForTemplateC(arrCidrs);
    //updateSetting(selectedLanguage.LstLanguageCodes.UI_AllowedIP, arrCidrs.length > 0 ? true : false);
    setShowCreateTemplateSettings(true);
    if (domains !== "" && domains.split(",").length > 1) {
      if (domains.split(",").length > 10) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Addupto10domainsseparatedbycomma);
        setAlertType("warning");
        return;
      }
    }

  }
  function EdisclosureChanged(e) {
    const checked = e.target.checked;
    setEDisclosure(checked);
    document.getElementById("txtEDisclosure").checked = true;
    updateSetting(
      selectedLanguage.LstLanguageCodes.UI_EDisclosure,
      checked
    );
    dispatch(
      updateFormData({
        type: "EDisclosure",
        value: checked,
      })
    );
  }
  function uploadsendwrapper(e) {
    var mapToEmails = [];
    if (tabValue === "send" || tabValue === "create") {
      mapToEmails = chailedToParentRecipients;
      var validationFlag = false;
      mapToEmails.forEach((item) => {
        if (item[3]?.value != "email" && (item[4]?.length === 0 || item[4]?.value == "+Code" || item[4] === undefined) && (item[5] === '' || item[5] === undefined) && verifyCode && IsSMS) {
          validationFlag = true;
          return;
        }
        if (item[3]?.value == "text" && (item[4]?.length === 0 || item[4]?.value == "+Code" || item[4] === undefined || item[4] == '') && (item[5] === '' || item[5] === undefined)) {
          validationFlag = true;
          return;
        }
      });
      if (validationFlag) {
        setModalIsUpdateConfirmOpen(true);
        setIsConfirmClicked(true);
      } else {
        uploadsend(e);
      }
    } else {
      uploadsend(e);
    }
  }

  async function uploadsend(event) {
    try {
      event && event.preventDefault();
      if (inputFields.length == 0) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_FileisRequired);
        setAlertType("warning");
        return;
      }
      if (!selectedOptions || selectedOptions.length === 0) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_AtleastOneOptionRequired);
        setAlertType("warning");
        return;
      }
      let mapToEmails = [];
      let mapAuthorizeEmails = [];
      setIsSendGenerateClick(true);
      if (!isSendGenerateRef.current) {
        const hasValidationError = showValidationPopup(template);
        if (hasValidationError) {
          return;
        }
      }
      isSendGenerateRef.current = false;
      validationShowRef.current = false;
      if (data.authorizedReaders.length > 0) {
        mapToEmails = [...data.authorizedReaders];
        mapAuthorizeEmails = [...data.authorizedReaders];
      }
      if (mapToEmails.length === 0 && tabValue === "send") {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_ToisRequired);
        setAlertType("warning");
        return;
      }
      if (
        mapAuthorizeEmails.length === 0 &&
        tabValue === "create" &&
        readerEmail === true &&
        distRestriction == true
      ) {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_AutherizedTReadersisRequired
        );
        setAlertType("warning");
        return;
      }

      var recipientdata = [];
      if (tabValue === "send")
        mapToEmails.map((item, i) =>
          recipientdata.push({
            Email: item[0],
            FirstName: item[1],
            LastName: item[2],
            AuthType: item[3]?.value,
            MobileCountryCode: item[4]?.value == "+Code" ? "" : item[4]?.value,
            MobileNumber: item[5],

            reference: item[6],
            CanPrint: ((canPrint && printEnabledType === "everyone") || item[7]) ? true : false,
            MaxPrintsPerReader: ((canPrint && printEnabledType === "everyone") || item[7]) ? (item[9] === true ? (item[8] === "" || item[8] === undefined || item[8] === null ? 0 : item[8]) : (maxPrintsPerReaderText && maxPrintsPerReaderText != 0 && (!item[8]) ? maxPrintsPerReaderText : item[8])) : null,
          })
        );
      else
        mapAuthorizeEmails.map((item, i) =>
          recipientdata.push({
            Email: item[0],
            FirstName: item[1] ? item[1] : "",
            LastName: item[2] ? item[2] : "",
            AuthType: item[3] ? item[3]?.value : "",
            MobileCountryCode: item[4]?.value ? item[4]?.value == "+Code" ? "" : item[4]?.value : "",
            MobileNumber: item[5] ? item[5] : "",

            reference: item[6] ? item[6] : "",
            CanPrint: ((canPrint && printEnabledType === "everyone") || item[7]) ? true : false,
            MaxPrintsPerReader: ((canPrint && printEnabledType === "everyone") || item[7]) ? (item[9] === true ? (item[8] === "" || item[8] === undefined || item[8] === null ? 0 : item[8]) : (maxPrintsPerReaderText && maxPrintsPerReaderText != 0 && (!item[8]) ? maxPrintsPerReaderText : item[8])) : null,
          })
        );
      const numberCounts = {};
      recipientdata.forEach(item => {
        const fullNumber = `${item.MobileCountryCode}${item.MobileNumber}`;
        numberCounts[fullNumber] = (numberCounts[fullNumber] || 0) + 1;
      });

      const duplicates = Object.entries(numberCounts)
        .filter(([number, count]) => count > 1)
        .map(([number]) => number);
      if (duplicates > 0) {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_DuplicateMobileNum
        );
        setAlertType("warning");
        return;
      }
      if (subject === "" && tabValue === "send") {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_SubjectisRequired + "."
        );
        setAlertType("warning");
        return;
      } else if (
        subject !== "" &&
        subject.length > 255 &&
        tabValue === "send"
      ) {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_Subjectmustbelessthanorequal
        );
        setAlertType("warning");
        return;
      } else if (
        subject !== "" &&
        subject.length > 255 &&
        tabValue === "create"
      ) {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_Descriptionmustbelessthanorequal
        );
        setAlertType("warning");
        return;
      }
      if (message !== "" && message.length > 1024 && tabValue === "send") {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_Emailbodymustbelessthanorequal
        );
        setAlertType("warning");
        return;
      }
      if (sideNote.trim() !== "" && sideNote.trim().length > 512) {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_SideNotemustbelessthanorequal
        );
        setAlertType("warning");
        return;
      }
      if (constAllowResFlag && !responseAddress.trim()) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_AllowResponsestoCannotBeEmpty);
        setAlertType("warning");
        return;
      }
      const strictOwnerEmailRegex = /^(?=.{1,254}$)[a-zA-Z0-9._%+\-]{1,64}@(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
      if (constAllowResFlag && responseAddress && !strictOwnerEmailRegex.test(responseAddress.trim())) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseEnterValidEmailintheAllowResponsestoField);
        setAlertType("warning");
        return;
      }
      if (expiryTime == "") {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_ExpiresDateisRequired);
        setAlertType("warning");
        return;
      }
      var calstarttime = "";
      var calexpiryTime = "";

      if (startTime != "" && startTime != null) {
        if (isDatetimeControl == "false") {
          calstarttime = moment(startTime).format("YYYY-MM-DDTHH:mm") + ":00";
        } else {
          calstarttime = moment(startTime).format("YYYY-MM-DDTHH:mm") + ":00";
        }
      }
      if (expiryTime != "" && expiryTime != null) {
        if (isDatetimeControl == "false") {
          calexpiryTime =
            moment(expiryTime).format("YYYY-MM-DD") + "T23:59:59Z";
        } else {
          calexpiryTime = moment(expiryTime).format("YYYY-MM-DDTHH:mm") + ":59";
        }
      }
      var tempStarttime = moment(
        rollbackFinalToLocal(new Date(calstarttime), timeZoneRef.current)
      ).format("YYYY-MM-DDTHH:mm:ss");

      const tempExpiryTime = moment(
        rollbackFinalToLocal(new Date(calexpiryTime), timeZoneRef.current)
      ).format("YYYY-MM-DDTHH:mm:ss");
      if (isDatetimeControl == "false") {
        if (
          startTime != "" &&
          startTime != null &&
          expiryTime != "" &&
          expiryTime != null &&
          new Date(tempStarttime) > new Date(tempExpiryTime)
        ) {
          setAlertMsg(
            selectedLanguage.LstLanguageCodes.UI_TheExpirydateCannotBefore
          );
          setAlertType("warning");
          setAlertClass("alerthist-ip");
          return;
        }
      } else {
        const s = new Date(startTime);
        const e = new Date(expiryTime);
        if (!isNaN(s) && !isNaN(e) && s > e) {
          setAlertMsg(
            selectedLanguage.LstLanguageCodes.UI_TheExpirydateCannotBefore
          );
          setAlertType("warning");
          setAlertClass("alerthist-ip");
          return;
        }

        if (tempStarttime == "Invalid date") {
          tempStarttime = null;
        }
        // if (
        //   startTime != "" &&
        //   startTime != null &&
        //   expiryTime != "" &&
        //   expiryTime != null &&
        //   moment(startTime).format("YYYY-MM-DDTHH:mm").split("T")[0] >
        //   moment(expiryTime).format("YYYY-MM-DDTHH:mm").split("T")[0]
        // ) {
        //   setAlertMsg(
        //     selectedLanguage.LstLanguageCodes.UI_TheExpirydateCannotBefore
        //   );
        //   setAlertType("warning");
        //   setAlertClass("alerthist-ip");
        //   return;
        // }
        if (
          startTime != "" &&
          expiryTime != null &&
          moment(startTime).format("YYYY-MM-DDTHH:mm").split("T")[0] ==
          moment(expiryTime).format("YYYY-MM-DDTHH:mm").split("T")[0]
        ) {
          const [endHour, endMinute] = moment(expiryTime)
            .format("YYYY-MM-DDTHH:mm")
            .split("T")[1]
            .split(":")
            .map(Number);
          const [startHour, startMinute] = moment(startTime)
            .format("YYYY-MM-DDTHH:mm")
            .split("T")[1]
            .split(":")
            .map(Number);
          if (
            startHour > endHour ||
            (startHour === endHour && startMinute > endMinute)
          ) {
            setAlertMsg(
              selectedLanguage.LstLanguageCodes.UI_TheExpirytimeCannotBefore
            );
            setAlertType("warning");
            setAlertClass("alerthist-ip");
            return;
          }
        }
      }

      if (
        domains !== "" &&
        domains.split(",").length == 1 &&
        domains.length > 190
      ) {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_ThedomainmustbelessthanNum
        );
        setAlertType("warning");
        return;
      }
      var domainvalidation = false;
      if (domains !== "" && domains.split(",").length > 1) {
        domains.split(",").forEach((element) => {
          if (element.length > 190 && !domainvalidation) {
            domainvalidation = true;
          }
        });
      }
      if (domainvalidation) {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_ThedomainmustbelessthanNum
        );
        setAlertType("warning");
        return;
      }
      const restrictToDomains = domains !== "" ? domains.split(",").map(d => d.trim()) : [];

      if (restrictToDomains.length >= 1) {
        const uniqueDomains = new Set();
        for (let domain of restrictToDomains) {
          if (uniqueDomains.has(domain.toLowerCase())) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_DuplicateDomain);
            setAlertType("warning");
            return;
          }
          uniqueDomains.add(domain.toLowerCase());
          const regex = /^[A-Za-z0-9-]+(\.[A-Za-z]{2,})+$/;
          if (!regex.test(domain)) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_InvalidDomain);
            setAlertType("warning");
            return;
          }
        }
      }
      const MaxReadsPerReader = parseInt(maxReadsText, 10) || 0;
      const MaxViewsPerDocument = parseInt(maxViewsPerDocumentText, 10) || 0;
      const MaxPrintsPerReader = parseInt(maxPrintsPerReaderText, 10) || 0;
      const MaxPrintsPerDocument = parseInt(maxPrintsPerDocumentText, 10) || 0;
      if (MaxViewsPerDocument > 0 && MaxReadsPerReader > 0 && MaxReadsPerReader > MaxViewsPerDocument) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Readsperreadercannotexceedviewsperdocument);
        setAlertType("warning");
        return;
      }
      if ((MaxPrintsPerDocument > 0 && MaxPrintsPerReader > 0 && MaxPrintsPerReader > MaxPrintsPerDocument)) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Printsperreadercannotexceedprintspersdocument);
        setAlertType("warning");
        return;
      }
      const hasExceededDocumentLimit = mapToEmails.some((reader) => reader[7] === true && Number(reader[8] || 0) > Number(maxPrintsPerDocumentText || 0));
      if (MaxPrintsPerDocument != "" && hasExceededDocumentLimit) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_MaxPrintsPerDocumentLessThanReaderPrintLimit);
        setAlertType("warning");
        return;
      }
      var arrCidrs = [];
      for (let item of document
        .getElementById("multipleips")
        .attributes["constmultipleips"].value.split(",")) {
        arrCidrs.push(item);
      }

      var mapContinets = document.getElementsByClassName(
        "map-selected gContinent"
      );
      var arrMapContinents = [];
      if (mapContinets.length === 0) {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_AtleastOneRegionShouldbePermitted
        );
        setAlertType("warning");
        return;
      }

      for (let item of mapContinets) {
        arrMapContinents.push(item.id);
      }
      setOpen(true);
      const restrictions = selectionOfRestriction.map((item) => {
        return { ...item, id: null };
      });
      var documentOptionsdata = {
        recipients: recipientdata,
        PageRestrictions:
          // restoreRestrictions.current &&
          securityLevel === 1
            ? restrictions.filter((item) => {
              if (item.category === "No Readers") {
                return { ...item };
              }
            })
            : restrictions,
        subject: subject,
        message: tabValue === "send" ? message : "",
        enabled: enabled,
        openRecord: openRecord,
        geolocation: geolocation,
        verifyCode: verifyCode,
        proofOfSending: proofOfSending,
        readNotification: readNotification,
        readerIp: true,
        readerEmail: readerEmail,
        readTimes: true, //readTimes,
        readTiming: true, //readTiming,
        voting: voting,
        voteSharing: voteSharing,
        distRestriction: distRestriction,
        distributionList: distributionList,
        domains: domains,
        watermark: watermark,
        maxReads: maxReads,
        maxViewsPerDocument: maxViewsPerDocument,
        steganography: steganography,
        timestamp: timestamp,
        print: canPrint,
        maxPrintsPerDocument: (maxPrintsPerDocumentText === "" || !canPrint) ? 0 : maxPrintsPerDocumentText,
        maxPrintsPerReader: (maxPrintsPerReaderText === "" || securityLevel === 1 || !canPrint) ? 0 : maxPrintsPerReaderText,
        EDisclosure: eDisclosure,
        termsOfService: termsOfService,
        regions: arrMapContinents,
        ips: arrCidrs,
        startTime: tempStarttime, //startTime,
        expiryTime: tempExpiryTime, //expiryTime,
        sideNote: sideNote.trim(),
        AllowResponsesTo: responseAddress,
        Language: browserLanguage == true ? serviceLanguageCode : languageCodes,
        BrowserLanguage: browserLanguage,
        Source: SourceFrom,
        PageLevelRestriction: pageLevelResRef.current.checked,
        IsWhatsApp: IsWhatsApp,
        IsSMS: IsSMS,
        IsEmail: isEmail,
        DocumentTemplateId: template && template.id,
        IsConfirmClicked: isConfirmClicked,
        IsPrintEnabledForEveryone: (printEnabledType === "everyone" ? true : false)
      };

      const formData = new FormData();
      var arrFiles = [];
      var inputFiles = [];
      var validationEditFlag = false;
      var validationFileSizeText = "";
      var cumilativeFileSize = 0;
      for (let item of inputFields) {
        if (
          multipleRPDsYesFlag &&
          parseInt(item.file.size) > 20971520 &&
          validationFileSizeText == "" &&
          tabValue === "send"
        ) {
          validationFileSizeText =
            selectedLanguage.LstLanguageCodes.UI_Themaximumsizelessthan20;
        } else if (
          multipleRPDsYesFlag &&
          parseInt(item.file.size) > 26214400 &&
          validationFileSizeText == "" &&
          tabValue === "create"
        ) {
          validationFileSizeText =
            selectedLanguage.LstLanguageCodes.UI_Themaximumsizelessthan25;
        } else if (!multipleRPDsYesFlag && validationFileSizeText == "") {
          cumilativeFileSize += parseInt(item.file.size);
        }
      }
      if (
        !multipleRPDsYesFlag &&
        cumilativeFileSize > 20971520 &&
        validationFileSizeText == "" &&
        tabValue === "send"
      ) {
        validationFileSizeText =
          selectedLanguage.LstLanguageCodes.UI_Themaximumsizelessthan20;
      } else if (
        !multipleRPDsYesFlag &&
        cumilativeFileSize > 26214400 &&
        validationFileSizeText == "" &&
        tabValue === "create"
      ) {
        validationFileSizeText =
          selectedLanguage.LstLanguageCodes.UI_Themaximumsizelessthan25;
      }
      if (validationFileSizeText != "") {
        setAlertMsg(validationFileSizeText);
        setAlertType("warning");
        setOpen(false);
        return;
      }
      for (let item of inputFields) {
        formData.append("files", item.file);
        if (item.edit == true && validationEditFlag == false)
          validationEditFlag = true;
        inputFiles.push({
          FileName: item.orgFileName,
          ModifiedFileName: item.mdfFileName + item.fileFormat,
          FileSize: item.fileSize,
          Order: item.indexVal,
        });
      }
      if (validationEditFlag == true) {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_PleaseSavetheEditedfileName
        );
        setAlertType("warning");
        setOpen(false);
        return;
      } else {
        formData.append("inputfiles", JSON.stringify(inputFiles));
        formData.append("filename", preferredFileName);
        formData.append("senderAddress", localStorage.getItem("UserName"));
        formData.append("documentOptions", JSON.stringify(documentOptionsdata));
        formData.append("generateMultipleRPD", multipleRPDsYesFlag);
        formData.append(
          "generateMultipleRPDZip",
          tabValue === "send" ? false : true
        );
        formData.append("IsConfirmClicked", isConfirmClicked);
        formData.append("data", false);
        formData.append("documentID", documentId);
        //formData.append("pageLevelRestriction", JSON.stringify(selectionOfRestriction));
        formData.append("pageLevelRestrictionSetting", isPageLevelRestriction);
        if (AppContext.ContentSecurity && steganography) {
          const identifyLeakersData = {
            cipherText: cipherTextData,
            floatingText: floatingTextData
          };
          formData.append("identifyLeakers", JSON.stringify(identifyLeakersData));
        }
        setSelectedTemplate(selectedLanguage.LstLanguageCodes.UI_SelectedTemplate);

        var response = await APIRequest.POST(
          formData,
          `${process.env.REACT_APP_API + process.env.REACT_APP_API_Send}` +
          (tabValue === "send" ? false : true) +
          "&sendEmail=" +
          (tabValue === "send" ? 1 : 0)
        );
        setOpen(false);
        if (response && response === "Server maintenance") {
          localStorage.removeItem("DocumentID");
          dispatch(removeConfiguredData());
          history("/maintenance");
          return;
        }
        if (response && response !== "Failed to fetch") {
          // setSelectionOfRestriction([]);
          // setIsPageLevelRestrictionChecked(false);
          // pageLevelResRef.current.checked = false;
          if (
            response.errorMessage == undefined ||
            response.errorMessage == ""
          ) {
            dispatch(removeConfiguredData());
            localStorage.removeItem("DocumentID");
            if (tabValue === "send") {
              //savePageLevelRestrictions(response);
              history("/history");
              dispatch(resetFormData());
            } else {
              setModalIsOpen(true);
              if (
                multipleRPDsYesFlag == true &&
                response.rpdData != undefined &&
                response.rpdData.length > 1
              ) {
                var multipleRpds = [];
                multipleRpds.push({
                  CreateDownloadLink:
                    "data:application/zip;base64," + response.rpd,
                  DownloadFileName:
                    (response.rpdData[0].fileName.indexOf(".") > -1
                      ? response.rpdData[0].fileName
                        .split(".")
                        .slice(0, -1)
                        .join(".") == "" ||
                        response.rpdData[0].fileName
                          .split(".")
                          .slice(0, -1)
                          .join(".")
                          .includes(".")
                        ? response.rpdData[0].fileName
                        : response.rpdData[0].fileName
                          .split(".")
                          .slice(0, -1)
                          .join(".")
                      : response.rpdData[0].fileName) + "_Combined.zip",
                  FileName: "",
                  // response[0].fileName.indexOf(".") > -1
                  //     ? response[0].fileName.split(".").slice(0, -1).join(".")
                  //     : response[0].fileName,
                });
                setCreateMultipleRPDs(multipleRpds);
                setCreateMultipleRPDsFlag(true);
                const $link = document.createElement("a");
                $link.href = "data:application/zip;base64," + response.rpd;
                $link.download =
                  (response.rpdData[0].fileName.indexOf(".") > -1
                    ? response.rpdData[0].fileName
                      .split(".")
                      .slice(0, -1)
                      .join(".") == "" ||
                      response.rpdData[0].fileName
                        .split(".")
                        .slice(0, -1)
                        .join(".")
                        .includes(".")
                      ? response.rpdData[0].fileName
                      : response.rpdData[0].fileName
                        .split(".")
                        .slice(0, -1)
                        .join(".")
                    : response.rpdData[0].fileName) + "_Combined.zip";
                $link.click();
              } else {
                const base64 = "data:application/html;base64," + response.rpd;
                setCreateDownloadLink(base64);
                setDownloadFileName(
                  (response.fileName.indexOf(".") > -1
                    ? response.fileName.split(".").slice(0, -1).join(".") ==
                      "" ||
                      response.fileName
                        .split(".")
                        .slice(0, -1)
                        .join(".")
                        .includes(".")
                      ? response.fileName
                      : response.fileName.split(".").slice(0, -1).join(".")
                    : response.fileName) + ".html"
                );

                setCreateMultipleRPDsFlag(false);
                setLanguage(serviceLanguageCode);
                const $link = document.createElement("a");
                $link.href = base64;
                $link.download =
                  (response.fileName.indexOf(".") > -1
                    ? response.fileName.split(".").slice(0, -1).join(".") ==
                      "" ||
                      response.fileName
                        .split(".")
                        .slice(0, -1)
                        .join(".")
                        .includes(".")
                      ? response.fileName
                      : response.fileName.split(".").slice(0, -1).join(".")
                    : response.fileName) + ".html";
                $link.click();
              }
              dispatch(resetFormData());
            }
          } else {
            if (
              response.errorMessage ===
              selectedLanguage.LstLanguageCodes.UI_TheTransactionAlredayBeen
            ) {
              if (tabValue === "send") {
                childRef.current.clearEmails();
              }
              clearControls();
            }
            setAlertMsg(response.errorMessage);
            setAlertType("warning");
            return;
          }
        } else {
          setAlertMsg(
            "Failed to " +
            (tabValue === "send"
              ? selectedLanguage.LstLanguageCodes.UI_Send
              : selectedLanguage.LstLanguageCodes.UI_Create) +
            " a document. Please contact support."
          );
          setAlertType("warning");
          return;
        }
      }
    } catch (error) {
      console.log("error: " + error);
    }
  }
  function handlerSendVerificationCodeFalg(value) {
    //setSendVerificationCodechkbx(value);
    setVerifyCode(value);
    // updateSetting(selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeEmail, value);
    dispatch(updateFormData({ type: "SendVerificationCode", value: value }))
  }
  const handlePageLevelRestrictionCheck = async () => {
    {
      if (pageLevelResRef.current.checked) {
        setIsPageLevelRestrictionChecked(true);
        handlePageLevelRestrictionEdit();
      } else {
        if (
          (selectionOfRestriction.length > 0 ||
            data.pageLevelRestrictionData.length > 0) &&
          !restoreRestrictions.current
        ) {
          let msg =
            selectedLanguage.LstLanguageCodes
              .UI_AllConfiguredRestrictionsRemoved;

          unSaveWarnModal.current.open(
            msg,
            () => {
              setIsPageLevelRestrictionChecked(false);
              setSelectionOfRestriction([]);
              dispatch(
                retainConfiguredData({
                  isConfirm: data.onConfirm,
                  authorizedReaders: data.authorizedReaders,
                  pageRestrictionData: [],
                })
              );
              backUpOfConfiguredRestrictions.current = [];
            },
            () => {
              pageLevelResRef.current.checked = true;
              dispatch(updateFormData({ type: "PageLevelRestrictions", value: true }));
            }
          );
        }
      }
    }
  };

  const handlePageLevelRestrictionEdit = async () => {
    if (inputFields.length == 0) {
      setAlertMsg(
        selectedLanguage.LstLanguageCodes.UI_PleaseUploadDocTosetRestrictions
      );
      setAlertType("warning");
      pageLevelResRef.current.checked = false;
      dispatch(updateFormData({ type: "PageLevelRestrictions", value: false }));
      setIsPageLevelRestrictionChecked(false);
      return;
    }

    setOpen(true);
    if (pageLevelResRef.current.checked) {
      const formData = new FormData();
      const inputLocalFiles = [];
      for (let item of inputFields) {
        formData.append("files", item.file);
        inputLocalFiles.push({
          FileName: item.orgFileName,
          ModifiedFileName: item.mdfFileName + item.fileFormat,
          FileSize: item.fileSize,
          Order: item.indexVal,
        });
      }
      formData.append("inputfiles", JSON.stringify(inputLocalFiles));

      console.log(...formData);
      const pageCount = await getPageCount(formData);
      if (!pageCount) {
        if (selectionOfRestriction.length > 0) {
          pageLevelResRef.current.checked = true;
          setIsPageLevelRestrictionChecked(true);
          dispatch(updateFormData({ type: "PageLevelRestrictions", value: true }));
        }
        return;
      }
      for (let item of inputFields) {
        for (let page of pageCount) {
          if (item.orgFileName === page.documentName) {
            item.pageCount = page.pageCount;
          }
        }
      }
      let pageDetails = [];
      if (multipleRPDsYesFlag) {
        inputFields.forEach((element) => {
          pageDetails.push({
            DocumentName: element.mdfFileName,
            PageCount: element.pageCount,
          });
        });
      } else {
        let pagecount = 0;
        inputFields.forEach((element) => {
          pagecount += element.pageCount;
        });
        let filename =
          preferredFileName.trim() === "" ||
            preferredFileName.trim() === undefined ||
            preferredFileName.trim() === null
            ? inputFields[0].mdfFileName + "_Combined"
            : preferredFileName.trim();
        pageDetails.push({ DocumentName: filename, PageCount: pagecount });
      }
      let recievers = [];
      recievers = chailedToParentRecipients.reduce((acc, i) => {
        return acc.concat(i[0]);
      }, []);
      if (recievers.length === 0) {
        recievers = constmultipleEmails.reduce((acc, i) => {
          return acc.concat(i[0]);
        }, []);
      }

      let isTrackViews = true;
      if (level2Ref.current.checked) {
        isTrackViews = false;
      } else if (level3Ref.current.checked) {
        isTrackViews = false;
      }

      if (data.onConfirm) {
        pageLevelResModalRef.current.handleModal(
          pageLevelResRef.current.checked,
          data.authorizedReaders.reduce((acc, i) => {
            return acc.concat(i[0]);
          }, []),
          pageDetails ? pageDetails : [],
          // restoreRestrictions.current &&
          securityLevel === 1
            ? data.pageLevelRestrictionData.filter((item) => {
              if (item.category === "No Readers") {
                return { ...item };
              }
            })
            : data.pageLevelRestrictionData, [],
          isTrackViews
        );
      } else {
        pageLevelResModalRef.current.handleModal(
          pageLevelResRef.current.checked,
          recievers,
          pageDetails ? pageDetails : [],
          // restoreRestrictions.current &&
          securityLevel === 1
            ? selectionOfRestriction.filter((item) => {
              if (item.category === "No Readers") {
                return { ...item };
              }
            })
            : selectionOfRestriction, [],

          isTrackViews
        );
      }
    } else pageLevelResModalRef.current.handleModal(false, [], [], [], false);

    setOpen(false);
  };
  const onCancelPageLevelRestriction = () => {
    pageLevelResModalRef.current.handleModal(false, [], [], [], false);
    if (selectionOfRestriction.length === 0) {
      setIsPageLevelRestrictionChecked(false);
      pageLevelResRef.current.checked = false;
      dispatch(updateFormData({ type: "PageLevelRestrictions", value: false }));
    } else if (
      selectionOfRestriction.length > 0 &&
      !noReadersRestrictionsRef.current &&
      selectedOrEveryoneExceptSelectedReadersRef.current
    ) {
      setIsPageLevelRestrictionChecked(false);
      pageLevelResRef.current.checked = false;
      dispatch(updateFormData({ type: "PageLevelRestrictions", value: false }));
    } else if (
      selectionOfRestriction.length > 0 &&
      noReadersRestrictionsRef.current &&
      !selectedOrEveryoneExceptSelectedReadersRef.current
    ) {
      setIsPageLevelRestrictionChecked(true);
      pageLevelResRef.current.checked = true;
      dispatch(updateFormData({ type: "PageLevelRestrictions", value: true }));
    }
  };

  const onSavePageLevelRestriction = (restrictionData) => {
    if (restrictionData.length === 0) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Atleastonerule);
      setAlertType("warning");
      return;
    }
    pageLevelResModalRef.current.handleModal(false, [], [], [], false);
    // if (!restoreRestrictions.current) {
    setSelectionOfRestriction(restrictionData);
    dispatch(
      retainConfiguredData({
        isConfirm: data.onConfirm,
        authorizedReaders: data.authorizedReaders,
        pageRestrictionData: restrictionData,
      })
    );
    // }
    const totalReaders = [
      ...new Set(
        restrictionData.reduce(
          (acc, current) => acc.concat(current.readers),
          []
        )
      ),
    ];
    const readers = chailedToParentRecipients.reduce((acc, i) => {
      return acc.concat(i[0]);
    }, []);
    let addedReader = totalReaders.filter((item) => !readers.includes(item));
    console.log(...addedReader);
    addedReader = addedReader.map((str) => [str]);
    setConstMultipleEmails(() => {
      return [...chailedToParentRecipients, ...addedReader];
    });
  };

  const getPageCount = async (formData) => {
    let userName = localStorage.getItem("UserName");
    let multipledocs = multipleRPDsYesFlag == true ? true : false;
    formData.append("UserName", userName); // Add UserName to the formData
    formData.append("MultpleRdocs", multipledocs);
    formData.append("documentID", localStorage.getItem("DocumentID"));
    const response = await APIRequest.POST(
      formData,
      `${process.env.REACT_APP_API + process.env.REACT_APP_API_GetPageNumbers}`
    );
    console.log(response);
    if (response.errorMessage != null) {
      setOpen(false);
      pageLevelResRef.current.checked = false;
      dispatch(updateFormData({ type: "PageLevelRestrictions", value: false }));
      setAlertMsg(response.errorMessage);
      setAlertType("warning");
      return;
    }
    return response.documentPageDetails;
  };

  function bytesToSize(bytes) {
    var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "0 Byte";
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
  }
  function handlerAllowResFlag(value) {
    if (value) {
      if (!isResponseAddressUserEdited.current) {
        setResponseAddress(localStorage.getItem("UserName"));
      }
    } else {
      const defaultUser = localStorage.getItem("UserName");
      setResponseAddress(defaultUser);
      isResponseAddressUserEdited.current = false;
      dispatch(updateFormData({ type: "ResponseAddress", value: defaultUser }));
    }
    setConstAllowResFlag(value);
    dispatch(updateFormData({ type: "AllowResponseTo", value: value }));
  }
  function handlerMultiRPDsYesFlag(value) {
    if (pageLevelResRef.current.checked && selectionOfRestriction.length > 0) {
      let msg =
        selectedLanguage.LstLanguageCodes.UI_AllConfiguredRestrictionsRemoved;
      unSaveWarnModal.current.open(
        msg,
        () => {
          multipleRPDsYes();
        },
        () => { }
      );
    } else {
      multipleRPDsYes();
    }
  }
  function multipleRPDsYes() {
    setMultipleRPDsNoFlag(false);
    setMultipleRPDsYesFlag(true);
    setSelectionOfRestriction([]);
    pageLevelResRef.current.checked = false;
    dispatch(updateFormData({ type: "PageLevelRestrictions", value: false }));
    setIsPageLevelRestrictionChecked(false);
  }

  function handlerMultiRPDsNoFlag(value) {
    let totalSize = 0;
    let indFileZize = 0;
    let validationSucess = true;

    const maxFileSize =
      tabValue === "send"
        ? AppContext.FileSizeSend * 1024 * 1024
        : AppContext.FileSizeCreate * 1024 * 1024;

    for (let index = 0; index < inputFields.length; index++) {
      const objFile = inputFields[index];
      indFileZize = parseInt(objFile.file.size);
      totalSize += indFileZize;

      if (totalSize > maxFileSize) {
        document.getElementById("imgFile").value = null;
        const sizeLimitMsg =
          tabValue === "send"
            ? selectedLanguage.LstLanguageCodes.UI_Themaximumsizelessthan20
            : selectedLanguage.LstLanguageCodes.UI_Themaximumsizelessthan25;
        setAlertMsg(sizeLimitMsg);
        setAlertType("warning");
        return;
      }
    }
    if (pageLevelResRef.current.checked && selectionOfRestriction.length > 0) {
      let msg =
        selectedLanguage.LstLanguageCodes.UI_AllConfiguredRestrictionsRemoved;
      unSaveWarnModal.current.open(
        msg,
        () => {
          multipleRPDsNo();
        },
        () => { }
      );
    } else {
      multipleRPDsNo();
    }

    function multipleRPDsNo() {
      setMultipleRPDsNoFlag(true);
      setMultipleRPDsYesFlag(false);
      setSelectionOfRestriction([]);
      pageLevelResRef.current.checked = false;
      dispatch(updateFormData({ type: "PageLevelRestrictions", value: false }));
      setIsPageLevelRestrictionChecked(false);
    }
  }

  function clearControls() {
    setEmailId([]);
    setSubject("");
    setMessage("");
    setFile("");
    setFileName("");
    setFileLength("0 kb");
    setOpenRecord(true);
    setGeolocation(true);
    setWatermark(0);
    setVerifyCode(false);
    setReaderEmail(false);
    setDomains("");
    setReadTimes(false);
    setReadTiming(false);
    setMaxReads(0);
    setMaxReadsText("");
    setMaxViewsPerDocument(0);
    setMaxViewsPerDocumentText("");
    setVoting(false);
    setVoteSharing(false);
    setReadNotification(false);
    setDistRestriction(false);
    setProofOfSending(false);
    setDistributionList(false);
    setSideNote("");
    setResponseAddress(localStorage.getItem("UserName"));
    setConstMultipleIps("");
    setSteganography(false);
    setEDisclosure(false);
    setTimestamp(false);
    setPrint(false);
    setStartTime("");
    setExpiryTime("");
    setExpirationDays("");
    setAuthorizedEmailId([]);
    setAlertMsg("");
    setAlertType("");
    setOpen(false);
    setConstAllowResFlag(true);
    setModalIsOpen(false);
    setCreateDownloadLink("");
    SecurityLevel1();
    setInputFields([]);
    setPreferredFileName("");
    setCreateMultipleRPDs([]);
    setCreateMultipleRPDsFlag(false);
    setMultipleRPDsNoFlag(false);
    setMultipleRPDsYesFlag(true);
    setSelectedOptions([{ value: 'email', label: 'Email' },]);
    document.getElementById("txtTimestamp").checked = false;
    document.getElementById("txtPrint").checked = false;
    document.getElementById("imgFile").value = null;
    RDocsDefaultSettingsData();
    setSelectionOfRestriction([]);
    setIsPageLevelRestrictionChecked(false);
    pageLevelResRef.current.checked = false;
    dispatch(updateFormData({ type: "PageLevelRestrictions", value: false }));
    setIsNavigatedFromL2L3(false);
    dispatch(removeConfiguredData());
    setIsRPDLight(false);
    setIsXLSfileSelected(false);
    setSelectedTemplate("");
  }
  const handleDragEnter = (e) => {
    setDragActive(true);
  };
  const handleDragOver = (e) => {
    setDragActive(true);
  };
  const handleDragLeave = (e) => {
    setDragActive(false);
  };
  const handleDrop = (e) => {
    setDragActive(false);
  };
  const handleLanguageChange = (e) => {
    const selectedLanguage = e.target.value;
    setLanguage(selectedLanguage);
    if (selectedLanguage == "ca-es1") {
      setbrowserLanguage(true);
    }
    else {
      setbrowserLanguage(false);
    }
    dispatch(updateFormData({ type: "ServiceLanguage", value: selectedLanguage }))
  };
  const handleBrowserLanguageChange = () => {
    setBrowserLanguageDrop(false);
    setbrowserLanguage(false);
  };
  const handleViewerBrowserLanguageChange = (event) => {
    setBrowserLanguageDrop(true);
    setbrowserLanguage(true);
    getbrowserlanguage(event);
    setLanguage(serviceLanguageCode);
  };
  //--Radio buttons---
  function ShowHideTextbox() {
    var chkNo = document.getElementById("chkNo");
    var dvtext = document.getElementById("dvtext");
    dvtext.style.display = chkNo.checked ? "block" : "none";
  }
  const onAddNewReaderHandler = (addedReaders) => {
    const totalReaders = [
      ...new Set(
        addedReaders.reduce((acc, current) => acc.concat(current), [])
      ),
    ];
    const readers = chailedToParentRecipients.reduce((acc, i) => {
      return acc.concat(i[0]);
    }, []);
    let addedReader = totalReaders.filter((item) => !readers.includes(item));
    console.log(...addedReader);
    addedReader = addedReader.map((str) => [str, "", "", [], ""]);
    setConstMultipleEmails(() => {
      return [...chailedToParentRecipients, ...addedReader];
    });
  };
  const handlePreferredFileName = (e) => {
    setPreferredFileName(e.target.value);
    if (
      selectionOfRestriction.length > 0 ||
      data.pageLevelRestrictionData.length > 0
    ) {
      let filename = !e.target.value.trim()
        ? inputFields[0].mdfFileName + "_Combined"
        : e.target.value.trim();
      setSelectionOfRestriction((prev) => {
        return prev.map((record) => {
          return {
            ...record,
            fileName: filename,
          };
        });
      });
      dispatch(
        retainConfiguredData({
          isConfirm: data.onConfirm,
          authorizedReaders: data.authorizedReaders,
          pageRestrictionData: data.pageLevelRestrictionData.map((record) => {
            return {
              ...record,
              fileName: filename,
            };
          }),
        })
      );
    }
  };

  const identifyLeakersModalRef = useRef(null);

  const handleEditClick = async () => {
    if (identifyLeakersModalRef.current) {
      identifyLeakersModalRef.current.showModal();
    }
  };

  const handleClose = (_, idLeakerData) => {
    if (identifyLeakersModalRef.current) {
      identifyLeakersModalRef.current.closeModal();
    }
    if (idLeakerData && !initialIdLeakersData.current) {
      initialIdLeakersData.current = idLeakerData;
    }
  };
  const onIdentifyLeakersHandler = async (e) => {
    try {
      identifyLeakersRef.current.checked = e.target.checked;
      setSteganography(e.target.checked)
      updateSetting(selectedLanguage.LstLanguageCodes.UI_IDLeakers, e.target.checked);
      // updateSetting(selectedLanguage.LstLanguageCodes.UI_IDLeakers, e.target.checked);
      if (e.target.checked)
        setOpen(true);
      if (identifyLeakersModalRef.current && e.target.checked && AppContext.ContentSecurity) {
        identifyLeakersModalRef.current.showModal();
      }
      if (e.target.checked) {
        dispatch(updateFormData({ type: "IDLeakers", value: e.target.checked }));
        if (Object.keys(lookupData).length === 0) {
          await fetchLookupData();
        }
        if (initialIdLeakersData.current) {
          dispatch(storeIdentifyLeakers({
            cipherText: initialIdLeakersData.current.cipherText,
            floatingText: initialIdLeakersData.current.floatingText
          }));
        }
        //return await getContentSecuritySettings();
      } else {
        // dispatch(resetIdentifyLeakers());
        dispatch(updateFormData({ type: "IDLeakers", value: e.target.checked }));
      }
      setOpen(false);
    }
    catch (error) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_FailedtoLoadSetting);
      setAlertType("warning");
      setOpen(false);
    }
  }

  function timeZoneConverter({
    mode,            // "parseOffset" | "utcToLocal" | "localToFinal" | "finalToUtc"
    value,           // string (UTC) or Date object
    offsetString,    // "+05:30"
  }) {
    // --- Parse offset (always needed) ---
    let offsetMinutes = 0;
    if (offsetString) {
      const m = offsetString.match(/([+-])(\d{2}):(\d{2})/);
      if (m) {
        const sign = m[1] === "-" ? -1 : 1;
        const hh = parseInt(m[2], 10);
        const mm = parseInt(m[3], 10);
        offsetMinutes = sign * (hh * 60 + mm);
      }
    }

    // Return offsetMinutes directly
    if (mode === "parseOffset") return offsetMinutes;

    // Convert UTC → Local UI Date
    if (mode === "utcToLocal") {
      if (!value) return "";
      const utcDate = new Date(value);
      return new Date(utcDate.getTime() + offsetMinutes * 60000);
    }

    // Convert Local UI Date → FinalLocal
    if (mode === "localToFinal") {
      if (!value) return "";
      const localDate = value; // Date object
      return new Date(localDate.getTime() - offsetMinutes * 60000);
    }

    // Convert FinalLocal → UTC for backend
    if (mode === "finalToUtc") {
      if (!value) return "";
      const finalLocal = value; // Date object
      return new Date(finalLocal.getTime() + offsetMinutes * 60000).toISOString();
    }

    return "";
  }

  // Add this helper function to handle time zone conversions
  function handleTimeZoneConversion(date, mode, offsetString) {
    if (!date) return "";

    const offsetMinutes = timeZoneConverter({
      mode: "parseOffset",
      offsetString
    });

    switch (mode) {
      case "utcToLocal":
        return timeZoneConverter({
          mode: "utcToLocal",
          value: date,
          offsetString
        });

      case "localToFinal":
        return timeZoneConverter({
          mode: "localToFinal",
          value: date,
          offsetString
        });

      case "finalToUtc":
        return timeZoneConverter({
          mode: "finalToUtc",
          value: date,
          offsetString
        });

      default:
        return date;
    }
  }

  function rollbackFinalToLocal(finalDate, offsetString) {
    if (!finalDate) return "";

    const offsetMinutes = timeZoneConverter({
      mode: "parseOffset",
      offsetString
    });

    // Explicit logic:
    if (offsetMinutes > 0) {
      // +14:00 → subtract
      return new Date(finalDate.getTime() - offsetMinutes * 60000);
    } else {
      // -14:00 → add
      return new Date(finalDate.getTime() + Math.abs(offsetMinutes) * 60000);
    }
  }
  const deepCopyArray = arr => {
    return arr.map(item => {
      if (Array.isArray(item)) {
        return deepCopyArray(item); // If item is an array, recursively copy it
      } else if (typeof item === 'object' && item !== null) {
        // If item is an object, create a shallow copy
        // You might need to implement a deep copy if object properties are also arrays or objects
        return { ...item };
      } else {
        return item; // Base case: return primitive values
      }
    });
  };


  const handleRecipientPrintEdit = () => {
    const readers = deepCopyArray(data.authorizedReaders || []);

    recipientPrintData.forEach(printReader => {
      const index = readers.findIndex(
        reader => reader[0]?.toLowerCase() === printReader[0]?.toLowerCase()
      );

      if (index !== -1) {
        readers[index][7] = printReader[7];
        readers[index][8] = printReader[8];
        readers[index][9] = printReader[9];
      }
    });
    setOriginalRecipientPrintData(JSON.parse(JSON.stringify(readers)));
    setOriginalPrintEnabledType(printEnabledType);
    if ((tabValue === 'create' && securityLevel === 3) || (tabValue === 'send')) {
      setRecipientPrintData(readers);
      setAllRecipientPrintData(readers);
    } else
      setRecipientPrintData([]);

    setShowRecipientPrintPopup(true);
  };

  const saveRecipientPrintSettings = () => {
    setRecipientPrintSearch("");
    const updatedRecipients = deepCopyArray(recipientPrintData);
    updatedRecipients.forEach((reader) => {
      if (printEnabledType === "everyone") {
        reader[7] = true;
        if ((reader[8] === undefined || reader[8] === null) && reader[9] !== true) {
          reader[8] = maxPrintsPerReaderText;
        }
      }
    });
    const invalidRecipient = updatedRecipients.find((recipient) => {
      if (!recipient[7]) { recipient[8] = ""; }
      return (maxPrintsPerDocumentText !== 0 && maxPrintsPerDocumentText !== "" && recipient[8] > maxPrintsPerDocumentText);
    });
    if (invalidRecipient) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Printsperreadercannotexceedprintspersdocument);
      setAlertType("warning");
      return;
    }
    dispatch(retainConfiguredData({ ...data, authorizedReaders: updatedRecipients, pageRestrictionData: data.pageLevelRestrictionData }));
    setRecipientPrintData(updatedRecipients);
    setAllRecipientPrintData(deepCopyArray(updatedRecipients));
    setOriginalRecipientPrintData(deepCopyArray(updatedRecipients));
    setOriginalPrintEnabledType(printEnabledType);
    setShowRecipientPrintPopup(false);
  };

  const handleRecipientPrintSearch = () => {
    const searchText = recipientPrintSearch?.trim().toLowerCase();
    if (!searchText) {
      setRecipientPrintData(allRecipientPrintData);
      return;
    }
    const filteredReaders = allRecipientPrintData.filter((reader) => {
      const email = (reader[0] || "").toLowerCase();
      const firstName = (reader[1] || "").toLowerCase();
      const lastName = (reader[2] || "").toLowerCase();
      const fullName = `${firstName} ${lastName}`.trim();
      return (email.includes(searchText) || firstName.includes(searchText) || lastName.includes(searchText) || fullName.includes(searchText));
    });
    setRecipientPrintData(filteredReaders);
  };

  const clearRecipientPrintSearch = () => {
    setRecipientPrintSearch("");
    setRecipientPrintData(originalRecipientPrintData);
  };

  const handleCheckAllPrints = (checked) => {
    setIsPrintHeaderChecked(checked);
    const temp = deepCopyArray(recipientPrintData);
    temp.forEach(reader => {
      reader[7] = checked;
    });
    setRecipientPrintData(temp);
    setAllRecipientPrintData(JSON.parse(JSON.stringify(temp)));
  };

  const onClosePrintRestriction = () => {
    setRecipientPrintSearch("");
    setRecipientPrintData(JSON.parse(JSON.stringify(originalRecipientPrintData)));
    setPrintEnabledType(originalPrintEnabledType);
    setShowRecipientPrintPopup(false);
  };

  return (
    // <!--    Main Content-->
    <>
      {openLoader ? <LoadingSpinner /> : null}
      {onlineStatus === false && (
        <div
          className="rpdFont modal pagemodal z-index-for-no-internet"
          id="PagewModel">
          <div className="modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content noInternetpopup">
              <div className="modal-body p-4">
                <div className="text-center mb-3">
                  <img
                    className="h-100px"
                    src={`data:image/png;base64,${noInternetImg}`}
                  />
                </div>
                <div className="mt-3">
                  <h6 className="font-22 mb-1 pt-2 text-center">
                    {" "}
                    {selectedLanguage.LstLanguageCodes.UI_NoInternetConnection}
                  </h6>
                  <p className="my-1 modal-text">
                    {
                      selectedLanguage.LstLanguageCodes
                        .UI_PleaseMakeSureYouHaveInternet
                    }
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Header
        pageRestrictionData={
          selectionOfRestriction.length > 0
            ? selectionOfRestriction
            : data.pageLevelRestrictionData || []
        }
        securitylevelvalue={securityLevel}
        authorizedReaders={
          data.authorizedReaders.length > 0 ? data.authorizedReaders : []
        }
        inputFields={inputFields}
      ></Header>
      {/* alerts */}
      <Alert
        alertType={alertType}
        alertMsg={alertMsg}
        setAlertMsg={setAlertMsg}
        setAlertType={setAlertType}
        className={alertClass}></Alert>
      {/* end */}
      <section className="pt-5 pb-3 mb-1 mysection sendCreate-section">
        <div className="container-fluid ">
          <div
            className="d-flex align-items-end justify-content-end header"
            id="myHeader">
            <button
              className={
                tabValue === "send" ? "res-w1 mt-2 send " : "res-w1 mt-2 create"
              }
              data-bs-toggle="modal"
              data-bs-target="#myModal"
              onClick={uploadsendwrapper} >


              {tabValue === "send"
                ? selectedLanguage.LstLanguageCodes.UI_Send
                : selectedLanguage.LstLanguageCodes.UI_Create}
            </button>
            {/* <!-- <a className="btn my-btn btn-danger hover-top btn-glow" href="#">Get Started </a>  --> */}
          </div>
          <div className="row pt-2 px-3 res-px0">
            {/* -------Multi file upload design------- */}
            <div className="col-sm-12 col-md-12 col-lg-4 col-xl-4 pe-1 res-pe0">
              <div className="card box-shadow-light pb-0 res-card h-475 sendCreate-card">
                <div className="card-header card-headercustome pe-1 pb-1 border-bottomNone">
                  {/* <h5 className="mt-1"> original design */}
                  <h5 className="mt-1 upload-file">
                    {/* <span className="colorChange">Step 1:</span>{" "}   */}
                    {selectedLanguage.LstLanguageCodes.UI_UploadFiles}
                    {/* - Step 1 */}

                    <div className="d-none d-md-block">
                      {inputFields.length > 0 && (
                        <label className="d-flex align-items-center clearall mb-0">
                          <span
                            className=""
                            onClick={() => fileNameDeleteAll()}>
                            {selectedLanguage.LstLanguageCodes.UI_DeleteAll}
                          </span>
                          <img
                            src={"assets/img/icons/bin.png"}
                            className="h-15p ms-1"
                            alt="Delete All"
                            onClick={() => fileNameDeleteAll()}
                          />
                        </label>
                      )}
                    </div>
                  </h5>
                </div>

                <div
                  className={
                    inputFields.length > 0
                      ? "d-none"
                      : "drag multi-drag upload form-control ms-2 d-grid"
                  }>
                  <p className="d-flex flex-column justify-content-center font-w600 font-14 mb-0">
                    <span className="material-icons mt-2 upload-icon">cloud_upload</span>
                    <div className="row row-height">
                      <div
                        className={
                          inputFields.length > 0
                            ? "d-flex flex-column align-items-center justify-content-center col-md-12 ps-1 pe-2"
                            : "d-flex flex-column align-items-center justify-content-center col-md-12 ps-1 pe-2 pt-12Moz"
                        }>
                        <input
                          type="file"
                          multiple
                          id="imgFile"
                          title={fileName}
                          onClick={(e) => fileSelectionClick(e)}
                          onChange={(e) => fileSelection(e)}></input>
                        <span className="light font-16 mb-2">
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_DragandDropfilesHere
                          }
                        </span>
                        <span className="pb-0 font-14">
                          {selectedLanguage.LstLanguageCodes.UI_or}
                        </span>
                        <span className="light underline font-16 my-2">
                          {" "}
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_ClickAndSelectFiles
                          }
                        </span>
                        <p className="mb-0 mt-1 fontSize-12">
                          {" "}
                          <b className="font-w600">
                            {
                              selectedLanguage.LstLanguageCodes
                                .UI_SupportedFileExtensions
                            }
                            :
                          </b>{" "}
                          {isConfiguredUser ? selectedLanguage.LstLanguageCodes.UI_XlsPdfdocdox : selectedLanguage.LstLanguageCodes.UI_Pdfdocdox}
                        </p>
                      </div>

                    </div>
                  </p>

                </div>
                {inputFields.length == 1 && (
                  <div
                    className="drag multi-drag upload form-control ms-2 darg-secondType"
                    style={{}}>
                    <p className="d-flex flex-column justify-content-center font-w600 font-14 mb-0">
                      <span className="material-icons mt-1 upload-icon2">cloud_upload</span>
                      <div className="row row-height">
                        <div
                          className={
                            inputFields.length > 0
                              ? "d-flex flex-column align-items-center justify-content-center col-md-12 ps-1 pe-2"
                              : "d-flex flex-column align-items-center justify-content-center col-md-12 ps-1 pe-2 pt-12Moz"
                          }>
                          <input
                            type="file"
                            multiple
                            id="imgFile"
                            title={fileName}
                            onClick={(e) => fileSelectionClick(e)}
                            onChange={(e) => fileSelection(e)}></input>
                          <span className="light">
                            {
                              selectedLanguage.LstLanguageCodes
                                .UI_DragandDropfilesHere
                            }
                          </span>
                          <span className="pb-0">
                            {selectedLanguage.LstLanguageCodes.UI_or}
                          </span>
                          <span className="light underline">
                            {" "}
                            {
                              selectedLanguage.LstLanguageCodes
                                .UI_ClickAndSelectFiles
                            }
                          </span>
                          <p className="mb-0 mt-1 fontSize-12">
                            {" "}
                            <b className="font-w600">
                              {
                                selectedLanguage.LstLanguageCodes
                                  .UI_SupportedFileExtensions
                              }
                              :
                            </b>{" "}
                            {isConfiguredUser ? selectedLanguage.LstLanguageCodes.UI_XlsPdfdocdox : selectedLanguage.LstLanguageCodes.UI_Pdfdocdox}
                          </p>
                        </div>

                      </div>
                    </p>

                  </div>
                )}
                {inputFields.length >= 2 && (
                  <div
                    className={
                      dragActive == true
                        ? "active-drop drag multi-drag resize-drag upload form-control ms-2 d-grid"
                        : "drag multi-drag resize-drag upload form-control ms-2 d-grid"
                    }
                  >
                    <p className="d-flex flex-column justify-content-center font-w600 font-14 mb-0">
                      <div className="row row-height">
                        <div
                          className={
                            inputFields.length > 0
                              ? "d-flex flex-column align-items-center justify-content-center col-md-12 ps-1 pe-2"
                              : "d-flex flex-column align-items-center justify-content-center col-md-12 ps-1 pe-2 pt-12Moz"
                          }>
                          <input
                            type="file"
                            multiple
                            id="imgFile"
                            title={fileName}
                            onClick={(e) => fileSelectionClick(e)}
                            onChange={(e) => fileSelection(e)}></input>
                          <div className="d-flex align-items-center justify-content-center w-100 px-3">
                            <div className="d-flex align-items-center mb-0">
                              <span className="material-icons me-2 upload-icon3">cloud_upload</span>
                              <span className="light font-13 text-black">
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_DragandDropfilesHere
                                }
                              </span>
                            </div>
                            <div className="mx-1">
                              <span className="pb-0 or-text" >
                                ({selectedLanguage.LstLanguageCodes.UI_or})
                              </span>
                            </div>
                            <div>
                              <span className="light underline font-13 text-black">
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_ClickAndSelectFiles
                                }
                              </span>
                            </div>

                          </div>

                          <p className="mb-0 mt-0 fontSize-12">
                            {" "}
                            <b className="font-w600">
                              {
                                selectedLanguage.LstLanguageCodes
                                  .UI_SupportedFileExtensions
                              }
                              :
                            </b>{" "}
                            {isConfiguredUser ? selectedLanguage.LstLanguageCodes.UI_XlsPdfdocdox : selectedLanguage.LstLanguageCodes.UI_Pdfdocdox}
                          </p>
                        </div>

                      </div>
                    </p>

                  </div>
                )}

                <div className={
                  inputFields.length > 0
                    ? "col-md-12 col-sm-12 ps-1 pe-2 mt-2"
                    : "col-md-12 col-sm-12 ps-1 pe-2 mt-2 d-none"
                }
                >
                  <div className="file-scrollbar d-none d-md-block">
                    {/*{isVisible && (*/}
                    <div className="d-flex align-items-center mb-3 d-none" id="totalFileSize">
                      <div className="me-1 top-15">
                        <img src={"assets/img/icons/upload2.png"} className="img-H35p" alt="Document" />
                      </div>
                      <div className="skill-main mt-3">
                        <div className="skill-wrrap">
                          <div className="skill-name">Uploaded Files</div>
                          <div className="skill-bar">
                            <div id="skill-per" className="skill-per" per="70"></div>
                          </div>
                        </div>
                      </div>
                      <span className="material-icons ms-2 fileColse" > close </span>
                      {/*onClick={fileSizeClose}*/}
                    </div>
                    {/*)}*/}
                    {inputFields.map((data, index) => {

                      return (

                        <aside
                          className={
                            data.edit == true
                              ? "d-flex align-items-center pb-1 row mt-2 w-100 ml-5px"
                              : "d-flex align-items-center pb-0 row mt-2 w-100 ml-5px"
                          }
                          draggable
                          onDragStart={(e) => dragStart(e, index)}
                          onDragOver={(e) => dragOver(e, index)}
                          onDrop={(e) => dragDrop(e, index)}
                          key={index}>
                          <div
                            className={
                              data.edit == true
                                ? "d-flex align-items-center box-width col-sm-10 ps-0"
                                : "d-flex align-items-center  box-width col-sm-8 ps-0"
                            }>
                            {/* <span className="material-icons font-20">
                                  task
                                </span> */}
                            {data.edit == false && (
                              <label className="font-14 mb-0 w-100 d-flex" style={{}}
                                title={data.orgFileName}>
                                <img
                                  src={"assets/img/icons/pdf1.png"}
                                  className="img-H35p"
                                  alt="Document"
                                  style={{ height: '32px', width: '29px' }}
                                  title={
                                    selectedLanguage.LstLanguageCodes
                                      .UI_RecetFileName
                                  }

                                />
                                {/* <i className="fa fa-file-text-o me-2 font-30" style={{marginTop:'5px'}}></i> */}
                                <div className="d-flex flex-column w-100">
                                  <span className="font-w600 font-12 filename-text">{data.mdfFileName + data.fileFormat}</span>
                                  <span className="mb-1 font-10 text-nowrap font-w400">
                                    {data.fileSize} </span>
                                </div>
                              </label>
                            )}
                            {data.edit == true && (
                              <>
                                <input
                                  className="edit-box file-edit"
                                  type="text"
                                  placeholder={
                                    selectedLanguage.LstLanguageCodes
                                      .UI_EnterFilename
                                  }
                                  value={data.mdfFileName}
                                  onDragStart={(e) => {
                                    e.preventDefault();
                                  }}
                                  onChange={(event) =>
                                    fileNameChange(
                                      data.indexVal,
                                      event.target.value
                                    )
                                  }></input>
                                {/* {data.fileFormat} */}
                              </>
                            )}
                          </div>
                          <div
                            className={
                              data.edit == true
                                ? "d-flex align-items-center justify-content-end col-sm-2 pe-0"
                                : "d-flex align-items-center justify-content-end col-sm-4 pe-0"
                            }>
                            {data.edit == false && (
                              <>
                                {data.modified == true && (
                                  <img
                                    src={"assets/img/icons/undo-black.png"}
                                    className="h-18p"
                                    alt="Document"
                                    title={
                                      selectedLanguage.LstLanguageCodes
                                        .UI_RecetFileName
                                    }
                                    onClick={() =>
                                      fileNameUndo(data.indexVal)
                                    }
                                  />
                                )}
                              </>
                            )}
                            {data.edit == true && (
                              <>
                                <span
                                  className="material-icons mx-1 font-20 top2 save-icon"
                                  style={{}}
                                  title={
                                    selectedLanguage.LstLanguageCodes
                                      .UI_Save
                                  }
                                  onClick={() =>
                                    fileNameSave(data.indexVal)
                                  }>
                                  save
                                </span>
                                <span
                                  title={
                                    selectedLanguage.LstLanguageCodes
                                      .UI_Cancel
                                  }
                                  className="material-icons text-danger top-5 deleteHover font-20"
                                  onClick={() =>
                                    fileNameCancel(data.indexVal)
                                  }>
                                  cancel
                                </span>
                                <span className={
                                  data.edit == true
                                    ? "d-none"
                                    : "material-icons mx-1 top-5 font-w600 font-20 text-success1"
                                } > done </span>
                                {/* color: '#18d432', */}
                              </>
                            )}
                            {data.edit == false && (
                              <>
                                <span
                                  className="material-icons mx-1 font-20 top1 pointer"
                                  title={
                                    selectedLanguage.LstLanguageCodes
                                      .UI_Rename
                                  }
                                  onClick={() =>
                                    fileNameEdit(data.indexVal)
                                  }>
                                  edit
                                </span>
                                <span
                                  title={
                                    selectedLanguage.LstLanguageCodes
                                      .UI_Delete
                                  }
                                  className="material-icons text-danger top-5 deleteHover font-20 me-1"
                                  onClick={() => deleteFile(data.indexVal)}>
                                  delete
                                </span>
                              </>
                            )}
                          </div>
                        </aside>
                      );
                    })}
                    {/* <aside className="d-flex align-items-center justify-content-between mt-1 pb-1">
                          <div className="d-flex align-items-center ">
                            <input
                              className="border-r4 edit-box"
                              type="text"
                              placeholder="Enter file name"
                            ></input>
                          </div>
                          <div className="d-flex align-items-center">
                            <label className="pb-0 mb-0 font-12 text-nowrap mx-1">
                              20kb
                            </label>
                            <span
                              className="material-icons mx-1 font-20 top2 text-success1"
                              title="Save"
                            >
                              check_circle
                            </span>
                            <span
                              title="Cancel"
                              className="material-icons text-danger top-5 deleteHover font-20"
                              onClick={fileDeletion}
                            >
                              cancel
                            </span>
                          </div>
                        </aside>
                        <aside className="d-flex align-items-center justify-content-between mt-1 pb-1">
                          <div className="d-flex align-items-center ">
                            <span className="material-icons font-20">task</span>
                            <span
                              className="ms-1 font-14 font-w400 filename-text"
                              title="sample"
                            >
                              Sample file used data must beused.ppt
                            </span>
                          </div>
                          <div className="d-flex align-items-center">
                            <label className="pb-0 mb-0 font-12 text-nowrap mx-1">
                              20kb
                            </label>
                            <span
                              className="material-icons mx-1 font-20 top1"
                              title="Rename"
                            >
                              edit
                            </span>
                            <span
                              title="Delete"
                              className="material-icons text-danger top-5 deleteHover font-20"
                              onClick={fileDeletion}
                            >
                              delete
                            </span>
                          </div>
                        </aside>
                        <aside className="d-flex align-items-center justify-content-between mt-1 pb-1">
                          <div className="d-flex align-items-center ">
                            <span className="material-icons font-20">task</span>
                            <span
                              className="ms-1 font-14 font-w400 filename-text"
                              title="sample"
                            >
                              Sample file used2 .pdf
                            </span>
                          </div>
                          <div className="d-flex align-items-center">
                            <label className="pb-0 mb-0 font-12 text-nowrap mx-1">
                              20kb
                            </label>
                            <span
                              className="material-icons mx-1 font-20 top1"
                              title="Rename"
                            >
                              edit
                            </span>
                            <span
                              title="Delete"
                              className="material-icons text-danger top-5 deleteHover font-20"
                              onClick={fileDeletion}
                            >
                              delete
                            </span>
                          </div>
                        </aside> */}
                  </div>
                </div>
                {/* ----Mobile responsive */}
                <div className="d-block d-md-none mt-3">
                  <div className="w-100 pb-1 d-flex justify-content-end">
                    {inputFields.length > 0 && (
                      <label className="d-flex align-items-center clearall">
                        <span
                          className="top2"
                          onClick={() => fileNameDeleteAll()}>
                          {selectedLanguage.LstLanguageCodes.UI_DeleteAll}
                        </span>
                        <img
                          src={"assets/img/icons/bin.png"}
                          className="h-15p"
                          alt="Delete All"
                          onClick={() => fileNameDeleteAll()}
                        />
                      </label>
                    )}
                  </div>
                  <div className="file-scrollbar">
                    {inputFields.map((data, index) => {
                      return (
                        <aside
                          className="d-flex align-items-center row mt-1 pb-2 w-100"
                          draggable
                          onDragStart={(e) => dragStart(e, index)}
                          onDragOver={(e) => dragOver(e, index)}
                          onDrop={(e) => dragDrop(e, index)}
                          key={index}>
                          <div className="d-flex align-items-center col-sm-8 col-8 ps-2">
                            {data.edit == false && (
                              <span
                                className="ms-1 font-14 font-w400 filename-text"
                                title={data.orgFileName}>
                                {data.mdfFileName + data.fileFormat}
                              </span>
                            )}
                            {data.edit == true && (
                              <>
                                <input
                                  className="edit-box file-edit"
                                  type="text"
                                  placeholder={
                                    selectedLanguage.LstLanguageCodes
                                      .UI_EnterFilename
                                  }
                                  value={data.mdfFileName}
                                  onDragStart={(e) => {
                                    e.preventDefault();
                                  }}
                                  onChange={(event) =>
                                    fileNameChange(
                                      data.indexVal,
                                      event.target.value
                                    )
                                  }></input>
                                {/* {data.fileFormat} */}
                              </>
                            )}
                          </div>
                          <div className="d-flex align-items-center justify-content-end col-4 col-sm-4 pe-2">
                            {data.edit == false && (
                              <>
                                {data.modified == true && (
                                  <img
                                    src={"assets/img/icons/undo-black.png"}
                                    className="h-18p"
                                    alt="Document"
                                    title={
                                      selectedLanguage.LstLanguageCodes
                                        .UI_RecetFileName
                                    }
                                    onClick={() => fileNameUndo(data.indexVal)}
                                  />
                                )}
                                <label className="pb-0 mb-0 font-12 text-nowrap mx-1">
                                  {data.fileSize}
                                </label>
                              </>
                            )}
                            {data.edit == true && (
                              <>
                                <span
                                  className="material-icons mx-1 font-20 top2 text-success1 pointer"
                                  title={
                                    selectedLanguage.LstLanguageCodes.UI_Save
                                  }
                                  onClick={() => fileNameSave(data.indexVal)}>
                                  check_circle
                                </span>
                                <span
                                  title={
                                    selectedLanguage.LstLanguageCodes.UI_Cancel
                                  }
                                  className="material-icons text-danger top-5 deleteHover font-20"
                                  onClick={() => fileNameCancel(data.indexVal)}>
                                  cancel
                                </span>
                              </>
                            )}
                            {data.edit == false && (
                              <>
                                <span
                                  className="material-icons mx-1 font-20 top1 pointer"
                                  title={
                                    selectedLanguage.LstLanguageCodes.UI_Rename
                                  }
                                  onClick={() => fileNameEdit(data.indexVal)}
                                >
                                  edit
                                </span>
                                <span
                                  title={
                                    selectedLanguage.LstLanguageCodes.UI_Delete
                                  }
                                  className="material-icons text-danger top-5 deleteHover font-20"
                                  onClick={() => deleteFile(data.indexVal)}>
                                  delete
                                </span>
                              </>
                            )}
                          </div>
                        </aside>
                      );
                    })}
                  </div>
                </div>
                <div className="row mt-2 ms-3 res-ml2r mb-2">

                  {/* Send / Create Multiple RDocs */}
                  {inputFields.length > 1 && (
                    <div className="col-6 col-sm-4 col-lg-5 col-md-4 px-0 d-flex align-items-center widthclass" style={{ width: '54% !important' }}>
                      {tabValue === "send" ? (
                        <label
                          className="font-w600 control font-14 textColor-gray me-2"
                          style={{ whiteSpace: "nowrap" }}
                        >
                          {selectedLanguage.LstLanguageCodes.UI_SendMultipleRdocs}:
                        </label>
                      ) : (
                        <label className="font-w600 control font-14 textColor-gray me-2" style={{ whiteSpace: "nowrap" }}>
                          {selectedLanguage.LstLanguageCodes.UI_CreateMultipleRdocs}:
                        </label>
                      )}

                      <div
                        className="switch"
                        onClick={() => {
                          if (multipleRPDsYesFlag) {
                            handlerMultiRPDsNoFlag(true);
                          } else {
                            handlerMultiRPDsYesFlag(true);
                          }
                        }}
                      >
                        <input type="checkbox" checked={multipleRPDsYesFlag} readOnly />
                        <label className="slider"></label>
                      </div>
                    </div>
                  )}

                  {/* RPD Light */}
                  {isRPDLight && (
                    <div className={`col-6 col-sm-4 col-lg-4 col-md-4 px-0 d-flex align-items-center ${isXLSfileSelected == true && isXlsClass == false && inputFields.length > 1 ? "ms-auto" : ""}`}>
                      <label className="font-w600 control font-14 textColor-gray me-2">
                        {selectedLanguage.LstLanguageCodes.UI_RPDLight}:
                      </label>

                      <div className={isRPDLightDisabled ? "switch disabled" : "switch"}>
                        <input type="checkbox" checked={true} readOnly />
                        <label className="slider"></label>
                      </div>
                      <span
                        className="material-icons info-tooltip-f authinfo me-1"
                        id="rpdlight"
                        data-toggle="tooltip"
                        data-html="true"
                        style={{ marginLeft: "2px", marginTop: '-5px' }}>
                        {" "}
                        info{" "}
                      </span>
                      <ReactTooltip
                        className="viewerLanguage-tooltip"
                        style={{ opacity: 1 }}
                        anchorId="rpdlight"
                        place="bottom">
                        <table className="tooltip-table">
                          <tr>
                            <td>
                              <div className="d-flex flex-column p-1">
                                {/* <h6 className="tooltip-head">

                                       Viewer language
                                    </h6> */}
                                <p className="tooltip-text mb-0">
                                  {" "}
                                  {
                                    selectedLanguage.LstLanguageCodes.UI_EnablingRPDLiteallowstheRDocssystemtoretainacopyofyouroriginalfile
                                  }
                                </p>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </ReactTooltip>
                    </div>

                  )}

                </div>
                {inputFields.length > 1 && multipleRPDsYesFlag != true && (
                  <div
                    id="dvtext"
                    className="pref-multi"
                    style={{}}>
                    <div className="row mt-1 ms-3 d-flex align-items-center res-ml0">
                      <div className="col-12 col-sm-12 col-md-7 col-xl-5 ps-0 res-pl8 ">
                        <label
                          title={
                            selectedLanguage.LstLanguageCodes
                              .UI_PrefferedDocumentname
                          }
                          className="font-w600 control res-w nowrap-text float-start w-200px truncate font-14"
                          htmlFor="username" style={{ color: '#2b2b2b' }}>
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_PrefferedDocumentname
                          }
                          :
                        </label>
                      </div>
                      <div className="col-12 col-sm-12 col-md-5 col-xl-7 ps-2 pe-0 res-p3re">
                        <input
                          name="filename"
                          type="text"
                          className="w-90 red-shadow border-r4 res-ml36 custom-inputBorder h-30px"
                          value={preferredFileName}
                          onChange={handlePreferredFileName}
                          tabIndex={2}
                        />
                      </div>
                    </div>
                  </div>
                )}
                <div className="row mt-2 d-flex align-items-center w-100"></div>
              </div>
            </div>
            {/* ----------------------end------------------------ */}

            {tabValue === "send" && (
              <div className="col-sm-12 col-md-12 col-lg-8 col-xl-8">
                <div className="card box-shadow-light pb-0 res-card h-475 rsmt-5re sendCreate-card">
                  <div className="row d-flex align-items-center">
                    <div className="">
                      <h5 className="step2 mails d-flex align-items-center">
                        {/* <span className="colorChange pe-1">Step 2:</span>{" "} Address Envelope
                      <button style={{padding:"8px 2rem"}}
              className={
                tabValue === "send" ? "res-w1 mt-2 send ms-auto" : "res-w1 mt-2 create ms-auto"
              }
              data-bs-toggle="modal"
              data-bs-target="#myModal"
              onClick={uploadsendwrapper} >


              {tabValue === "send"
                ? selectedLanguage.LstLanguageCodes.UI_Send
                : selectedLanguage.LstLanguageCodes.UI_Create}
            </button> */}
                      </h5>


                      {/* <!-- <a className="btn my-btn btn-danger hover-top btn-glow" href="#">Get Started </a>  --> */}


                    </div>
                    <div className="col-sm-12 col-md-12 sendCreate-multiemail">
                      <MultipleEmails
                        id="multipleEmails"
                        type="text"
                        placeholder={selectedLanguage.LstLanguageCodes.UI_To}
                        constmultipleemails={
                          constmultipleEmails.length > 0
                            ? constmultipleEmails
                            : ""
                        }
                        tabindex="1"
                        tabValue={tabValue}
                        value={constmultipleEmails}
                        ref={childRef}
                        recipientDetailsFromChaild={
                          recipientDetailsFromChaild
                        }
                        isPageLevelRestriction={
                          isPageLevelRestrictionChecked &&
                          selectionOfRestriction.length > 0
                        }
                        RestrictionReaders={
                          selectionOfRestriction.length > 0
                            ? selectionOfRestriction
                              .map((item) => {
                                return [...item.readers];
                              })
                              .flat()
                            : []
                        }
                        IsModelOpenChild={isModelOpenChild}
                        setIsModelOpenChild={setIsModelOpenChild}
                        selectedOptions={selectedOptions}
                        securityLevel={securityLevel}
                        defaultCanPrint={(canPrint) ? true : false}
                        defaultMaxPrintsPerReader={maxPrintsPerReaderText}
                        defaultMaxPrintsPerDocument={maxPrintsPerDocumentText}
                        printEnabledType={printEnabledType}
                        docLevelCanPrint={canPrint}
                        recipientPrintData={recipientPrintData}
                        onRecipientPrintDataUpdate={handleRecipientPrintDataUpdate}
                      ></MultipleEmails>
                    </div>
                  </div>

                  <div className="row mt-2 d-flex align-items-center">
                    <div className="col-md-12 col-sm-12">
                      <input
                        name="subject"
                        placeholder={selectedLanguage.LstLanguageCodes.UI_Subject}
                        type="text"
                        className="w-100 red-shadow border-r4 sendCreate-field"
                        value={subject}
                        tabIndex={2}
                        onChange={(e) => {
                          setSubject(e.target.value);
                          dispatch(updateFormData({ type: "Subject", value: e.target.value }))
                          dispatch(updateFormData({ type: "Description", value: e.target.value }))
                        }}
                      />
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col-md-12 col-sm-12">
                      <textarea placeholder={selectedLanguage.LstLanguageCodes.UI_EmailBody}
                        name="message"
                        rows="5"
                        className="w-100 red-shadow border-r4 sendCreate-field"
                        value={message}
                        onChange={(e) => {
                          setMessage(e.target.value);
                          dispatch(updateFormData({ type: "EmailBody", value: e.target.value }))
                        }}
                        tabIndex="3"></textarea>
                    </div>
                  </div>
                  <div className="row d-flex align-items-center mb-2 mt-2" style={{ marginLeft: '-16px' }}>
                    <div className="col-md-8 col-sm-8 col-12 d-flex align-items-center">
                      <label className="ms-3 readerlang" style={{ whiteSpace: 'nowrap' }}>
                        {selectedLanguage.LstLanguageCodes.UI_ReaderLanguage}:
                      </label>
                      <div className="ms-3 d-flex align-items-center res-radiowidth">
                        <div className="radio" style={{ border: '1px solid #dbdada', borderRadius: '3px' }}>
                          <select
                            id="ServiceLanguage"
                            value={languageCodes}
                            style={{
                              width: "230px",
                              color: '#000',
                              border: "2px solid #bc272e !important",
                            }}
                            className="form-select fw-400 form-control select-border rounded h-32p language-borderr"
                            onChange={(e) => handleLanguageChange(e)}
                            aria-label="Default select example"
                          >
                            <option value="ca-es1">{selectedLanguage.LstLanguageCodes.UI_ReaderBrowserLanguage}</option>
                            {ServiceLanguageOptions
                              .slice()
                              .sort((a, b) => a.keyValue.localeCompare(b.keyValue))
                              .map((option) => (
                                <option key={option.key.toLowerCase()} value={option.key.toLowerCase()}>
                                  {option.keyValue}
                                </option>
                              ))}
                          </select>
                        </div>
                        <span
                          className="material-icons info-tooltip-f authinfo me-1"
                          id="Viewer-language"
                          data-toggle="tooltip"
                          data-html="true"
                          style={{ marginLeft: "2px" }}>
                          {" "}
                          info{" "}
                        </span>
                        <ReactTooltip
                          className="viewerLanguage-tooltip"
                          style={{ opacity: 1 }}
                          anchorId="Viewer-language"
                          place="bottom">
                          <table className="tooltip-table">
                            <tr>
                              <td>
                                <div className="d-flex flex-column p-1">
                                  {/* <h6 className="tooltip-head">

                                       Viewer language
                                    </h6> */}
                                  <p className="tooltip-text mb-0">
                                    {" "}
                                    {
                                      selectedLanguage.LstLanguageCodes
                                        .UI_TheEmailnotificationsSentSelectedLang
                                    }
                                  </p>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </ReactTooltip>
                      </div>
                      <span className="ms-1306">
                        <select
                          value={selectedTemplate}
                          onChange={(e) => handleTemplateChange(e)}
                          className="form-select"
                          placeholder={selectedLanguage.LstLanguageCodes.UI_ApplyTemplate}
                          style={{ width: '190px' }}
                        >
                          <option value="">{selectedLanguage.LstLanguageCodes.UI_ApplyTemplate}</option>

                          {templateOptions && templateOptions?.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                      </span>
                      <span>
                        <img
                          src="/assets/img/Templatemanage.png"
                          alt="Create Template"
                          onClick={handleManageTemplate}
                          title={selectedLanguage.LstLanguageCodes.UI_ManageTemplates}
                          className="manageTemplate-btn ms-2"
                          style={{ cursor: "pointer", fontSize: '20px', height: '42px' }}
                        />
                      </span>

                      <span>
                        <img
                          src="/assets/img/createTemplate.png"
                          alt="Create Template"
                          title={selectedLanguage.LstLanguageCodes.UI_SaveAsaTemplate}
                          onClick={handleCreateTemplateFromSettings}
                          className="manageTemplate-btn ms-2"
                          style={{ cursor: "pointer", fontSize: '20px', height: '42px' }}
                        />
                      </span>                    </div>


                    <div className="col-md-6 col-sm-6 col-12 res-radiowidth1 d-none">
                      <span className="radio me-1 res-radio ">
                        <input
                          id="chkYesViewerBrowserLanguage"
                          name="viewerLanguageGroup"
                          type="radio"
                          onClick={(e) => handleViewerBrowserLanguageChange(e)}
                          checked={browserLanguageDrop}></input>
                        <label
                          htmlFor="chkYesViewerBrowserLanguage"
                          className="radio-label control"
                          style={{ paddingTop: "9px", color: '#5a626f' }}>
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_ViewerBrowserLanguage
                          }
                        </label>
                      </span>
                      <span
                        className="material-icons info-tooltip-f authinfo me-1 res-info"
                        id="viewerBrowserLanguage"
                        data-toggle="tooltip"
                        data-html="true"
                        style={{ top: "5px" }}>
                        {" "}
                        info{" "}
                      </span>
                      <ReactTooltip
                        className="viewerLanguage-tooltip"
                        style={{ opacity: 1 }}
                        anchorId="viewerBrowserLanguage"
                        place="bottom">
                        <table className="tooltip-table">
                          <tr>
                            <td>
                              <div className="d-flex flex-column p-1">
                                {/* <h6 className="tooltip-head">

                                       Viewer browser language
                                    </h6> */}
                                <p className="tooltip-text mb-0">
                                  {" "}
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_TheEmailNoticationssentRportalLang
                                  }
                                </p>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </ReactTooltip>
                    </div>


                  </div>
                </div>
              </div>
            )}
            {tabValue === "create" && (
              <div className="col-sm-12 col-md-12 col-lg-8 col-xl-8">
                <div className="card box-shadow-light pb-0 res-card h-475 rsmt-5re sendCreate-card">
                  <div className="row mt-2">
                    <div className="col-md-12 col-sm-12 px-4">
                      <textarea
                        name="message"
                        rows={tabValue === "create" && readerEmail === true && distRestriction == true ? "7" : "9"
                        }
                        // rows="6"
                        placeholder={
                          selectedLanguage.LstLanguageCodes.UI_DescribeThisContent
                        }
                        className="w-100 red-shadow border-r4 ps-0 sendCreate-field"
                        // className="w-100 custom-inputBorder"
                        value={subject}
                        onChange={(e) => {
                          setSubject(e.target.value)
                          dispatch(updateFormData({ type: "Description", value: e.target.value }))
                          dispatch(updateFormData({ type: "Subject", value: e.target.value }))
                        }}
                        tabIndex="2"></textarea>
                    </div>
                  </div>
                  {tabValue === "create" &&
                    readerEmail === true &&
                    distRestriction == true && (
                      <div className="row mt-2">

                        <div className="col-md-12 col-sm-12 px-4 user-inputBorder sendCreate-multiemail">
                          <MultipleEmails
                            id="multipleAuthorizedEmails"
                            type="text"
                            // placeholder={
                            //   selectedLanguage.LstLanguageCodes.UI_Emails + "..."
                            // }
                            placeholder={`${selectedLanguage.LstLanguageCodes.UI_AuthorizedReadersEmails}..`}
                            constmultipleemails={
                              constmultipleEmails.length > 0
                                ? constmultipleEmails
                                : ""
                            }
                            tabindex="3"
                            tabValue={tabValue}
                            ref={childRef}
                            RestrictionReaders={
                              selectionOfRestriction.length > 0
                                ? selectionOfRestriction
                                  .map((item) => {
                                    return [...item.readers];
                                  })
                                  .flat()
                                : []
                            }
                            value={constmultipleEmails}
                            recipientDetailsFromChaild={
                              recipientDetailsFromChaild
                            }
                            isPageLevelRestriction={
                              isPageLevelRestrictionChecked &&
                              selectionOfRestriction.length > 0
                            }
                            IsModelOpenChild={isModelOpenChild}
                            setIsModelOpenChild={setIsModelOpenChild}
                            selectedOptions={selectedOptions}
                            securityLevel={securityLevel}
                            defaultCanPrint={(canPrint && printEnabledType === "everyone") ? true : false}
                            defaultMaxPrintsPerReader={maxPrintsPerReaderText}
                            defaultMaxPrintsPerDocument={maxPrintsPerDocumentText}
                            printEnabledType={printEnabledType}
                            docLevelCanPrint={canPrint}
                            recipientPrintData={recipientPrintData}
                            onRecipientPrintDataUpdate={handleRecipientPrintDataUpdate}
                          ></MultipleEmails>
                        </div>
                      </div>
                    )}
                  {/*------ Language of create */}
                  {/* <div className="row mt-3 d-flex align-items-center">
                  <div className="col-md-3 col-sm-12">
                    <label className="font-w600 control res-w float-end res-left12 res-createLeft">
                      {selectedLanguage.LstLanguageCodes.UI_ViewerLanguage}:
                    </label>
                  </div>
                  <div className="col-md-3 col-sm-12 d-flex align-items-center res-radiowidth">
                    <span
                      className="radio me-1"
                      style={{ paddingTop: "12px", marginLeft: "-1px" }}>
                      <input
                        id="chkYesViewerLanguage"
                        name="viewerLanguageGroup"
                        type="radio"
                        defaultChecked={true}
                        onClick={handleBrowserLanguageChange}></input>
                      <label
                        htmlFor="chkYesViewerLanguage"
                        className="radio-label"></label>
                    </span>
                    <div className="radio">
                      <select
                        className="form-select form-control select-border rounded h-31p language-borderr"
                        aria-label="Default select example"
                        onChange={handleLanguageChange}
                        value={languageCodes}
                        tabIndex="31"
                        style={{
                          width: "150px",
                          border: "2px solid #bc272e !important",
                        }}
                        disabled={browserLanguageDrop}>
                        <option value="ca-es">Catalan</option>
                        <option value="cs-cz">Czech</option>
                        <option value="da-dk">Danish</option>
                        <option value="nl-nl">Dutch</option>
                        <option value="en-us">English</option>
                        <option value="fi-fi">Finnish</option>
                        <option value="fr-fr">French</option>
                        <option value="de-de">German</option>
                        <option value="el-gr">Greek</option>
                        <option value="hu-hu">Hungarian</option>
                        <option value="it-it">Italian</option>
                        <option value="nb-no">Norwegian</option>
                        <option value="pl-pl">Polish</option>
                        <option value="pt-pt">Portuguese</option>
                        <option value="ro-ro">Romanian</option>
                        <option value="ru-ru">Russian</option>
                        <option value="es-es">Spanish</option>
                        <option value="sv-se">Swedish</option>
                        <option value="tr-tr">Turkish</option>
                      </select>
                    </div>
                    <span
                      className="material-icons info-tooltip-f authinfo me-1"
                      id="Viewer-language"
                      data-toggle="tooltip"
                      data-html="true"
                      style={{ marginLeft: "0px" }}>
                      {" "}
                      info{" "}
                    </span>
                    <ReactTooltip
                      className="viewerLanguage-tooltip"
                      style={{ opacity: 1 }}
                      anchorId="Viewer-language"
                      place="bottom">
                      <table className="tooltip-table">
                        <tr>
                          <td>
                            <div className="d-flex flex-column p-1">
                              <p className="tooltip-text mb-0">
                                {" "}
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_TheEmailnotificationsSentSelectedLang
                                }
                              </p>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </ReactTooltip>
                  </div>
                  <div className="col-md-6 col-sm-12 res-radiowidth1">
                    <span className="radio me-1 res-radio">
                      <input
                        id="chkYesViewerBrowserLanguage"
                        name="viewerLanguageGroup"
                        type="radio"
                        onClick={(e) => handleViewerBrowserLanguageChange(e)}
                        checked={browserLanguageDrop}></input>
                      <label
                        htmlFor="chkYesViewerBrowserLanguage"
                        className="radio-label font-w600 control res-w  res-left12"
                        style={{ paddingTop: "9px" }}>
                        {
                          selectedLanguage.LstLanguageCodes
                            .UI_ViewerBrowserLanguage
                        }
                      </label>
                    </span>
                    <span
                      className="material-icons info-tooltip-f authinfo res-info"
                      id="viewerBrowserLanguage"
                      data-toggle="tooltip"
                      data-html="true"
                      style={{ top: "5px" }}>
                      {" "}
                      info{" "}
                    </span>
                    <ReactTooltip
                      className="viewerLanguage-tooltip"
                      style={{ opacity: 1 }}
                      anchorId="viewerBrowserLanguage"
                      place="bottom">
                      <table className="tooltip-table">
                        <tr>
                          <td>
                            <div className="d-flex flex-column p-1">
                              <p className="tooltip-text mb-0">
                                {" "}
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_TheEmailNoticationssentRportalLang
                                }
                              </p>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </ReactTooltip>
                  </div>
                </div> */}
                  <div className="row d-flex align-items-center mb-2 mt-2">
                    <div className="col-md-8 col-sm-8 col-12 d-flex align-items-center">
                      <label className="ms-3 readerlang" style={{ whiteSpace: 'nowrap' }}>
                        {selectedLanguage.LstLanguageCodes.UI_ReaderLanguage}:
                      </label>
                      <div className="ms-3 d-flex align-items-center res-radiowidth">
                        {/* <span
                      className="radio me-1"
                      style={{ paddingTop: "12px", marginLeft: "-1px" }}>
                      <input
                        id="chkYesViewerLanguage"
                        name="viewerLanguageGroup"
                        type="radio"
                        defaultChecked={true}
                        onClick={handleBrowserLanguageChange}></input>
                      <label
                        htmlFor="chkYesViewerLanguage"
                        className="radio-label"></label>
                    </span> */}
                        <div className="radio" style={{ border: '1px solid #dbdada' }}>
                          {/* <select
                            className="form-select fw-400 form-control select-border rounded h-32p language-borderr"
                            aria-label="Default select example"
                            onChange={handleLanguageChange}
                            value={languageCodes}
                            tabIndex="31"
                            style={{
                              width: "230px",
                              color:'#000',
                              border: "2px solid #bc272e !important",
                            }}
                          >
                            <option value="ca-es1">{selectedLanguage.LstLanguageCodes.UI_ReaderBrowserLanguage}</option>
                            <option value="ca-es">Catalan</option>
                            <option value="cs-cz">Czech</option>
                            <option value="da-dk">Danish</option>
                            <option value="nl-nl">Dutch</option>
                            <option value="en-us">English</option>
                            <option value="fi-fi">Finnish</option>
                            <option value="fr-fr">French</option>
                            <option value="de-de">German</option>
                            <option value="el-gr">Greek</option>
                            <option value="hu-hu">Hungarian</option>
                            <option value="it-it">Italian</option>
                            <option value="nb-no">Norwegian</option>
                            <option value="pl-pl">Polish</option>
                            <option value="pt-pt">Portuguese</option>
                            <option value="ro-ro">Romanian</option>
                            <option value="ru-ru">Russian</option>
                            <option value="es-es">Spanish</option>
                            <option value="sv-se">Swedish</option>
                            <option value="tr-tr">Turkish</option>
                          </select> */}
                          <select
                            // id="ServiceLanguage"
                            value={languageCodes}
                            style={{
                              width: "230px",
                              color: '#000',
                              border: "2px solid #bc272e !important",
                            }}
                            className="form-select fw-400 form-control select-border rounded h-32p language-borderr"
                            onChange={(e) => handleLanguageChange(e)}
                            aria-label="Default select example"
                          >
                            <option value="ca-es1">{selectedLanguage.LstLanguageCodes.UI_ReaderBrowserLanguage}</option>
                            {ServiceLanguageOptions
                              .slice()
                              .sort((a, b) => a.keyValue.localeCompare(b.keyValue)) // Sort alphabetically
                              .map((option) => (
                                <option key={option.key.toLowerCase()} value={option.key.toLowerCase()}>
                                  {option.keyValue}
                                </option>
                              ))}
                          </select>
                        </div>
                        <span
                          className="material-icons info-tooltip-f authinfo me-1"
                          id="Viewer-language"
                          data-toggle="tooltip"
                          data-html="true"
                          style={{ marginLeft: "2px" }}>
                          {" "}
                          info{" "}
                        </span>
                        <ReactTooltip
                          className="viewerLanguage-tooltip"
                          style={{ opacity: 1 }}
                          anchorId="Viewer-language"
                          place="bottom">
                          <table className="tooltip-table">
                            <tr>
                              <td>
                                <div className="d-flex flex-column p-1">
                                  {/* <h6 className="tooltip-head">

                                       Viewer language
                                    </h6> */}
                                  <p className="tooltip-text mb-0">
                                    {" "}
                                    {
                                      selectedLanguage.LstLanguageCodes
                                        .UI_TheEmailnotificationsSentSelectedLang
                                    }
                                  </p>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </ReactTooltip>
                      </div>
                      <span className="ms-1306">
                        <select
                          value={selectedTemplate}
                          onChange={(e) => handleTemplateChange(e)}
                          className="form-select"
                          placeholder={selectedLanguage.LstLanguageCodes.UI_ApplyTemplate}
                          style={{ width: '190px' }}
                        >
                          <option value="">{selectedLanguage.LstLanguageCodes.UI_ApplyTemplate}</option>

                          {templateOptions && templateOptions?.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                      </span>
                      <span>
                        <img
                          src="/assets/img/Templatemanage.png"
                          alt="Create Template"
                          onClick={handleManageTemplate}
                          title={selectedLanguage.LstLanguageCodes.UI_ManageTemplates}
                          className="manageTemplate-btn ms-2"
                          style={{ cursor: "pointer", fontSize: '20px', height: '42px' }}
                        />
                      </span>

                      <span>
                        <img
                          src="/assets/img/createTemplate.png"
                          alt="Create Template"
                          title={selectedLanguage.LstLanguageCodes.UI_SaveAsaTemplate}
                          onClick={handleCreateTemplateFromSettings}
                          className="manageTemplate-btn ms-2"
                          style={{ cursor: "pointer", fontSize: '20px', height: '42px' }}
                        />
                      </span>
                    </div>


                    <div className="col-md-6 col-sm-6 col-12 res-radiowidth1 d-none">
                      <span className="radio me-1 res-radio ">
                        <input
                          id="chkYesViewerBrowserLanguage"
                          name="viewerLanguageGroup"
                          type="radio"
                          onClick={(e) => handleViewerBrowserLanguageChange(e)}
                          checked={browserLanguageDrop}></input>
                        <label
                          htmlFor="chkYesViewerBrowserLanguage"
                          className="radio-label control"
                          style={{ paddingTop: "9px", color: '#5a626f' }}>
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_ViewerBrowserLanguage
                          }
                        </label>
                      </span>
                      <span
                        className="material-icons info-tooltip-f authinfo me-1 res-info"
                        id="viewerBrowserLanguage"
                        data-toggle="tooltip"
                        data-html="true"
                        style={{ top: "5px" }}>
                        {" "}
                        info{" "}
                      </span>
                      <ReactTooltip
                        className="viewerLanguage-tooltip"
                        style={{ opacity: 1 }}
                        anchorId="viewerBrowserLanguage"
                        place="bottom">
                        <table className="tooltip-table">
                          <tr>
                            <td>
                              <div className="d-flex flex-column p-1">
                                {/* <h6 className="tooltip-head">

                                       Viewer browser language
                                    </h6> */}
                                <p className="tooltip-text mb-0">
                                  {" "}
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_TheEmailNoticationssentRportalLang
                                  }
                                </p>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </ReactTooltip>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="content sendCreate-content">
              <div className="row pt-0 px-3 res-pr0">
                <div
                  className="col-sm-12 col-md-12 col-lg-12 col-xl-7 ps-3 mt-1 pl-10p"
                  style={{ display: "contents" }}></div>
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-7 ps-2 mt-1">
                  <div className="card box-shadow-light pb-0 res-card h-475 sendCreate-card">
                    <div className="card-header card-headercustome">
                      {/* <h5 className="mt-1 mails d-flex align-items-center mb-0">
                       Step 3
                      </h5> */}
                      <h5 className="mt-1 mails d-flex align-items-center mb-1">
                        {/* <span className="colorChange pe-1">Step 3:</span>{" "} */}
                        <img
                          className="img-fluid user me-2"
                          src="assets/img/icons/project-management.png"
                          height=""
                          alt=""
                        />
                        {selectedLanguage.LstLanguageCodes.UI_AccessControl}
                        {/* - Step 3 */}
                      </h5>
                    </div>
                    <div className="card-body sendCreate-pt-12 res-p3">
                      <div className="row ">
                        <div className="col-12 col-sm-6 col-md-4 pt-12px d-flex align-items-start flex-column justify-content-start res-form col-rb">
                          <ul className="ks-cboxtags ps-0 mx-margin ms-2" id="track">
                            <li>
                              <input
                                className="btn-check"
                                // onClick={SecurityLevel1}
                                type="checkbox"
                                defaultChecked
                                name="securitylevels"
                                id="level1"
                                defaultValue="level1"
                                disabled
                              />
                              <label
                                className="views pb-3p"
                                htmlFor="level1"
                                title={
                                  selectedLanguage.LstLanguageCodes
                                    .UI_TrackViews
                                }>
                                <span className="w-106px truncate">
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_TrackViews
                                  }{" "}
                                </span>
                              </label>
                              <span
                                className="font-14"
                                style={{
                                  marginLeft: "12px",
                                  color: "#bc272e",
                                  fontWeight: "600",
                                }}></span>
                            </li>
                          </ul>

                          {/* Level one points */}

                          <div className="text-start pl-16px">
                            <div className="box__line ">
                              <span className="material-icons font22 text-s1">
                                done
                              </span>

                              <label
                                className={`mb-0 ms-1 font-14 toolltipModified ${position}`}
                                name="ck2"
                                onMouseEnter={handleMouseEnter}>
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_Openingtimesrecorded
                                }
                                <span className="ModToollTips">
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_RecordsthetimeofFirstRead
                                  }
                                </span>
                              </label>
                            </div>
                            <div className="box__line">
                              <span className="material-icons font22 text-s1">
                                done
                              </span>

                              <label
                                className={`mb-0 ms-1 font-14 toolltipModified ${position}`}
                                name="ck2"
                                onMouseEnter={handleMouseEnter}>
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_GeoLocation
                                }
                                <span className="ModToollTips">
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_RecordstheGeoLocationof
                                  }
                                </span>
                              </label>
                            </div>
                            <div className="box__line">
                              <span className="material-icons font22 text-s1">
                                done
                              </span>

                              <label
                                className={`mb-0 ms-1 font-14 toolltipModified ${position}`}
                                name="ck2"
                                onMouseEnter={handleMouseEnter}>
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_ReaderIPrecorded
                                }
                                <span className="ModToollTips">
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_RecordstheIPadressof
                                  }
                                </span>
                              </label>
                            </div>

                            <div className="box__line">
                              <span className="material-icons font22 text-s1">
                                done
                              </span>

                              <label
                                className={`mb-0 ms-1 font-14 toolltipModified ${position}`}
                                name="ck2"
                                onMouseEnter={handleMouseEnter}>
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_RestrictAccessbyIP
                                }
                                <span className="ModToollTips">
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_RestrictsAccesstoArange
                                  }
                                </span>
                              </label>
                            </div>

                            <div className="box__line">
                              <span className="material-icons font22 text-s1">
                                done
                              </span>

                              <label
                                className={`mb-0 ms-1 font-14 toolltipModified ${position}`}
                                name="ck2"
                                onMouseEnter={handleMouseEnter}>
                                {selectedLanguage.LstLanguageCodes.UI_Watermark}
                                <span className="ModToollTips">
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_AddsawatermarkstoRdoc
                                  }
                                </span>
                              </label>
                            </div>
                            <div className="box__line">
                              <span className="material-icons font22 text-s1">
                                done
                              </span>

                              <label
                                className={`mb-0 ms-1 font-14 toolltipModified ${position}`}
                                name="ck2"
                                onMouseEnter={handleMouseEnter}>
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_TimeToExpiration
                                }
                                <span className="ModToollTips">
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_DisplaysTheTimeleft
                                  }
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-sm-6 col-md-4 pt-12px d-flex align-items-start flex-column justify-content-start res-form col-rb">
                          <ul className="ks-cboxtags ps-0 mx-margin ms-12px">
                            <li>
                              <input
                                className="btn-check"
                                type="checkbox"
                                onClick={SecurityLevel2}
                                name="securitylevels"
                                id="level2"
                                defaultValue="level2"
                                ref={level2Ref}
                              />
                              <label
                                className="readers pb-3p"
                                htmlFor="level2"
                                title={
                                  selectedLanguage.LstLanguageCodes
                                    .UI_TrackReaders
                                }>
                                <span className="w-118px truncate">
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_TrackReaders
                                  }
                                </span>
                              </label>
                              <p
                                className="font-14"
                                style={{
                                  marginLeft: "27px",
                                  color: "#eda719",
                                  fontWeight: "600",
                                  marginBottom: "0px",
                                }}>
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_AllTrackViewsFeaturesPlus
                                }
                              </p>
                            </li>
                          </ul>

                          {/* Level two points */}

                          <div className="text-start ms-15px">
                            <div className="box__line">
                              <span className="material-icons lineh-5p font22 minimize">
                                {" "}
                                minimize{" "}
                              </span>
                              <span className="material-icons font22 text-s2 done">
                                {" "}
                                done{" "}
                              </span>

                              <label
                                className={`mb-0 ms-1 font-14 toolltipModified ${position}`}
                                name="ck2"
                                onMouseEnter={handleMouseEnter}>
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_AutherizationwithVerification
                                }
                                <span className="ModToollTips">
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_ProtectstheRdocsWith
                                  }
                                </span>
                              </label>
                            </div>
                            <div className="box__line">
                              <span className="material-icons lineh-5p font22 minimize">
                                {" "}
                                minimize{" "}
                              </span>
                              <span className="material-icons font22 text-s2 done">
                                {" "}
                                done{" "}
                              </span>

                              <label
                                className={`mb-0 ms-1 font-14 toolltipModified ${position}`}
                                name="ck2"
                                onMouseEnter={handleMouseEnter}>
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_ReaderEmailaddressesRecorded
                                }
                                <span className="ModToollTips">
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_RecordsEachReadersEmail
                                  }
                                </span>
                              </label>
                            </div>
                            <div className="box__line">
                              <span className="material-icons lineh-5p font22 minimize">
                                {" "}
                                minimize{" "}
                              </span>
                              <span className="material-icons font22 text-s2 done">
                                {" "}
                                done{" "}
                              </span>

                              <label
                                className={`mb-0 ms-1 font-14 toolltipModified ${position}`}
                                name="ck2"
                                onMouseEnter={handleMouseEnter}>
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_RestrictAccessbydomain
                                }
                                <span className="ModToollTips">
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_RestrictsAccessToSpecific
                                  }
                                </span>
                              </label>
                            </div>
                            <div className="box__line ">
                              <span className="material-icons lineh-5p font22 minimize">
                                {" "}
                                minimize{" "}
                              </span>
                              <span className="material-icons font22 text-s2 done">
                                {" "}
                                done{" "}
                              </span>
                              <label
                                className={`mb-0 ms-1 font-14 toolltipModified ${position}`}
                                name="ck2"
                                onMouseEnter={handleMouseEnter}>
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_TimesReadperRecipient
                                }
                                <span className="ModToollTips">
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_RecordsthenumofReadsPerReader
                                  }
                                </span>
                              </label>
                            </div>
                            <div className="box__line ">
                              <span className="material-icons lineh-5p font22 minimize">
                                {" "}
                                minimize{" "}
                              </span>
                              <span className="material-icons font22 text-s2 done">
                                {" "}
                                done{" "}
                              </span>

                              <label
                                className={`mb-0 ms-1 font-14 toolltipModified ${position}`}
                                name="ck2"
                                onMouseEnter={handleMouseEnter}>
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_TimeSpentReadingperRecipient
                                }
                                <span className="ModToollTips">
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_Recordsthetotalreadtime
                                  }
                                </span>
                              </label>
                            </div>
                            <div className="box__line ">
                              <span className="material-icons lineh-5p font22 minimize">
                                {" "}
                                minimize{" "}
                              </span>
                              <span className="material-icons font22 text-s2 done">
                                {" "}
                                done{" "}
                              </span>
                              <label
                                className={`mb-0 ms-1 font-14 toolltipModified ${position}`}
                                name="ck2"
                                onMouseEnter={handleMouseEnter}>
                                {" "}
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_LimitNumberofReadsperRecipient
                                }
                                <span className="ModToollTips">
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_OptionTosetAmaximumnum
                                  }
                                </span>
                              </label>
                            </div>
                            <div className="box__line">
                              <span className="material-icons lineh-5p font22 minimize">
                                {" "}
                                minimize{" "}
                              </span>
                              <span className="material-icons font22 text-s2 done">
                                {" "}
                                done{" "}
                              </span>

                              <label
                                className={`mb-0 ms-1 font-14 toolltipModified top `}
                                name="ck2"
                                onMouseEnter={handleMouseEnter}>
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_VotingVoteSharing
                                }
                                <span className="ModToollTips">
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_OptionToallowReadersTovote
                                  }
                                </span>
                              </label>
                            </div>
                            <div className="box__line border-0">
                              <span className="material-icons lineh-5p font22 minimize">
                                {" "}
                                minimize{" "}
                              </span>
                              <span className="material-icons font22 text-s2 done">
                                {" "}
                                done{" "}
                              </span>
                              <label
                                className={`mb-0 ms-1 font-14 toolltipModified top`}
                                name="ck2"
                                onMouseEnter={handleMouseEnter}>
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_NotificationofReading
                                }
                                {
                                  <span className="ModToollTips">
                                    {
                                      selectedLanguage.LstLanguageCodes
                                        .UI_AbilityToReceiveAnotification
                                    }
                                  </span>
                                }
                              </label>
                            </div>
                          </div>
                        </div>
                        <div
                          className={
                            tabValue === "send"
                              ? "col-12 col-sm-6 col-md-4 pt-12px d-flex align-items-start flex-column justify-content-start res-form res-ml6"
                              : "col-12 col-sm-6 col-md-4 pt-12px d-flex align-items-start flex-column justify-content-start res-form res-ml6"
                          }>
                          <ul className="ks-cboxtags ps-0 mx-margin ms-12px">
                            <li>
                              <input
                                className="btn-check"
                                type="checkbox"
                                name="securitylevels"
                                onClick={SecurityLevel3}
                                id="level3"
                                defaultValue="level3"
                                ref={level3Ref}
                              />
                              <label
                                className="restrict pb-3p"
                                htmlFor="level3"
                                title={
                                  selectedLanguage.LstLanguageCodes
                                    .UI_LimitReaders
                                }>
                                <span className="w-120px truncate">
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_LimitReaders
                                  }
                                </span>
                              </label>
                              <p
                                className="font-14"
                                style={{
                                  marginLeft: "27px",
                                  color: "#bc272e",
                                  fontWeight: "600",
                                  marginBottom: "0px",
                                }}>
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_AllTrackReadersFeaturesPlus
                                }
                              </p>
                            </li>
                          </ul>

                          {/* Level Three points */}
                          <div className="text-start">
                            <div className="box__line ms-15px res-ml5">
                              <span
                                className="material-icons lineh-5p font22"
                                id="lv1">
                                {" "}
                                minimize{" "}
                              </span>
                              <span
                                className="material-icons font22 text-danger"
                                id="lv2">
                                {" "}
                                done{" "}
                              </span>
                              <label
                                className={`mb-0 ms-1 font-14 toolltipModified ${position}`}
                                name="ck2"
                                onMouseEnter={handleMouseEnter}>
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_RestrictedDistribution
                                }
                                <span className="ModToollTips MarginLeft65">
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_OptiontorestrictaccessToRdoc
                                  }
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="table-responsive sendcreatetable d-none">
                        <table className="table tablesend">
                          <thead className="">
                            <tr className="border-0">
                              <th className="border-0 ps-1 bg-body text-start">
                                <ul
                                  className="ks-cboxtags mb-n1 ps-1"
                                  id="track">
                                  <li>
                                    <input
                                      className="btn-check"
                                      onClick={SecurityLevel1}
                                      type="checkbox"
                                      defaultChecked
                                      name="securitylevels"
                                      id="level1"
                                      defaultValue="level1"
                                    />
                                    <label
                                      className="views pb-3p"
                                      htmlFor="level1"
                                      title={
                                        selectedLanguage.LstLanguageCodes
                                          .UI_TrackViews
                                      }>
                                      <span className="w-106px truncate">
                                        {
                                          selectedLanguage.LstLanguageCodes
                                            .UI_TrackViews
                                        }{" "}
                                      </span>
                                    </label>
                                  </li>
                                </ul>
                              </th>
                              <th className="border-0 text-start bg-body">
                                <ul className="ks-cboxtags w-83 mb-n1">
                                  <li>
                                    <input
                                      className="btn-check"
                                      type="checkbox"
                                      onClick={SecurityLevel2}
                                      name="securitylevels"
                                      id="level2"
                                      defaultValue="level2"
                                    />
                                    <label
                                      className="readers"
                                      htmlFor="level2"
                                      title={
                                        selectedLanguage.LstLanguageCodes
                                          .UI_TrackReaders
                                      }>
                                      <span className="w-118px truncate">
                                        {
                                          selectedLanguage.LstLanguageCodes
                                            .UI_TrackReaders
                                        }
                                      </span>
                                    </label>
                                  </li>
                                </ul>
                              </th>
                              <th className="border-0 text-start bg-body">
                                <ul className="ks-cboxtags w-90 mb-n1 ps-1">
                                  <li>
                                    <input
                                      className="btn-check"
                                      type="checkbox"
                                      name="securitylevels"
                                      onClick={SecurityLevel3}
                                      id="level3"
                                      defaultValue="level3"
                                    />
                                    <label
                                      className="restrict"
                                      htmlFor="level3">
                                      <span className="w-118px truncate">
                                        {
                                          selectedLanguage.LstLanguageCodes
                                            .UI_LimitReaders
                                        }
                                      </span>
                                    </label>
                                  </li>
                                </ul>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="border-0">
                              <td>
                                <div className="text-start">
                                  <div className="box__line ">
                                    <span className="material-icons font22 text-s1">
                                      done
                                    </span>

                                    <label
                                      className="mb-0 ms-1 font-14"
                                      name="ck2">
                                      {
                                        selectedLanguage.LstLanguageCodes
                                          .UI_Openingtimesrecorded
                                      }
                                    </label>
                                  </div>
                                  <div className="box__line">
                                    <span className="material-icons font22 text-s1">
                                      done
                                    </span>

                                    <label
                                      className="mb-0 ms-1 font-14"
                                      name="ck5">
                                      {
                                        selectedLanguage.LstLanguageCodes
                                          .UI_GeoLocation
                                      }
                                    </label>
                                  </div>
                                  <div className="box__line">
                                    <span className="material-icons font22 text-s1">
                                      done
                                    </span>

                                    <label
                                      className="mb-0 ms-1 font-14"
                                      name="ck3">
                                      {
                                        selectedLanguage.LstLanguageCodes
                                          .UI_ReaderIPrecorded
                                      }
                                    </label>
                                  </div>

                                  <div className="box__line">
                                    <span className="material-icons font22 text-s1">
                                      done
                                    </span>

                                    <label
                                      className="mb-0 ms-1 font-14"
                                      name="ck3">
                                      {
                                        selectedLanguage.LstLanguageCodes
                                          .UI_RestrictAccessbyIP
                                      }
                                    </label>
                                  </div>

                                  <div className="box__line">
                                    <span className="material-icons font22 text-s1">
                                      done
                                    </span>

                                    <label
                                      className="mb-0 ms-1 font-14"
                                      name="ck3">
                                      {
                                        selectedLanguage.LstLanguageCodes
                                          .UI_Watermark
                                      }
                                    </label>
                                  </div>
                                  <div className="box__line">
                                    <span className="material-icons font22 text-s1">
                                      done
                                    </span>

                                    <label
                                      className="mb-0 ms-1 font-14"
                                      name="ck3">
                                      {
                                        selectedLanguage.LstLanguageCodes
                                          .UI_TimeToExpiration
                                      }
                                    </label>
                                  </div>
                                </div>
                              </td>
                              <td className="w-50">
                                <div className="text-start">
                                  <div className="box__line">
                                    <span className="material-icons lineh-5p font22 minimize">
                                      {" "}
                                      minimize{" "}
                                    </span>
                                    <span className="material-icons font22 text-s2 done">
                                      {" "}
                                      done{" "}
                                    </span>

                                    <label
                                      className="mb-0 ms-1 font-14"
                                      name="ck1">
                                      {
                                        selectedLanguage.LstLanguageCodes
                                          .UI_AutherizationwithVerification
                                      }
                                    </label>
                                  </div>
                                  <div className="box__line">
                                    <span className="material-icons lineh-5p font22 minimize">
                                      {" "}
                                      minimize{" "}
                                    </span>
                                    <span className="material-icons font22 text-s2 done">
                                      {" "}
                                      done{" "}
                                    </span>

                                    <label
                                      className="mb-0 ms-1 font-14"
                                      name="ck6">
                                      {
                                        selectedLanguage.LstLanguageCodes
                                          .UI_ReaderEmailaddressesRecorded
                                      }
                                    </label>
                                  </div>
                                  <div className="box__line">
                                    <span className="material-icons lineh-5p font22 minimize">
                                      {" "}
                                      minimize{" "}
                                    </span>
                                    <span className="material-icons font22 text-s2 done">
                                      {" "}
                                      done{" "}
                                    </span>

                                    <label
                                      className="mb-0 ms-1 font-14"
                                      name="ck6">
                                      {
                                        selectedLanguage.LstLanguageCodes
                                          .UI_RestrictAccessbydomain
                                      }
                                    </label>
                                  </div>
                                  <div className="box__line ">
                                    <span className="material-icons lineh-5p font22 minimize">
                                      {" "}
                                      minimize{" "}
                                    </span>
                                    <span className="material-icons font22 text-s2 done">
                                      {" "}
                                      done{" "}
                                    </span>
                                    <label
                                      className="mb-0 ms-1 font-14"
                                      name="ck7">
                                      {
                                        selectedLanguage.LstLanguageCodes
                                          .UI_TimesReadperRecipient
                                      }
                                    </label>
                                  </div>
                                  <div className="box__line ">
                                    <span className="material-icons lineh-5p font22 minimize">
                                      {" "}
                                      minimize{" "}
                                    </span>
                                    <span className="material-icons font22 text-s2 done">
                                      {" "}
                                      done{" "}
                                    </span>

                                    <label
                                      className="mb-0 ms-1 font-14"
                                      name="ck8">
                                      {
                                        selectedLanguage.LstLanguageCodes
                                          .UI_TimeSpentReadingperRecipient
                                      }
                                    </label>
                                  </div>
                                  <div className="box__line ">
                                    <span className="material-icons lineh-5p font22 minimize">
                                      {" "}
                                      minimize{" "}
                                    </span>
                                    <span className="material-icons font22 text-s2 done">
                                      {" "}
                                      done{" "}
                                    </span>
                                    <label className="mb-0 ms-1 font-14">
                                      {" "}
                                      {
                                        selectedLanguage.LstLanguageCodes
                                          .UI_LimitNumberofReadsperRecipient
                                      }
                                    </label>
                                  </div>
                                  <div className="box__line">
                                    <span className="material-icons lineh-5p font22 minimize">
                                      {" "}
                                      minimize{" "}
                                    </span>
                                    <span className="material-icons font22 text-s2 done">
                                      {" "}
                                      done{" "}
                                    </span>

                                    <label
                                      className="mb-0 ms-1 font-14"
                                      name="ck10">
                                      {
                                        selectedLanguage.LstLanguageCodes
                                          .UI_VotingVoteSharing
                                      }
                                    </label>
                                  </div>
                                  <div className="box__line">
                                    <span className="material-icons lineh-5p font22 minimize">
                                      {" "}
                                      minimize{" "}
                                    </span>
                                    <span className="material-icons font22 text-s2 done">
                                      {" "}
                                      done{" "}
                                    </span>
                                    <label
                                      className="mb-0 ms-1 font-14"
                                      name="ck11">
                                      {
                                        selectedLanguage.LstLanguageCodes
                                          .UI_NotificationofReading
                                      }
                                    </label>
                                  </div>
                                </div>
                              </td>
                              <td className="text-start">
                                <div className="text-center">
                                  <div className="box__line">
                                    <span
                                      className="material-icons lineh-5p font22"
                                      id="lv1">
                                      {" "}
                                      minimize{" "}
                                    </span>
                                    <span
                                      className="material-icons font22 text-danger"
                                      id="lv2">
                                      {" "}
                                      done{" "}
                                    </span>
                                    <label
                                      className="mb-0 ms-1 font-14"
                                      name="ck9">
                                      {
                                        selectedLanguage.LstLanguageCodes
                                          .UI_RestrictedDistribution
                                      }
                                    </label>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-5 mt-1 pl-10p ps-1">
                  <div className="card box-shadow-light h-475 sendCreate-card">
                    <div className="card-header card-headercustome align-items-center justify-content-between">
                      {/* <h5 className=" mails d-flex align-items-center ">
                        Step 4
                      </h5>                       */}
                      <h5 className=" mails d-flex align-items-center pt-5px">
                        {/* <span className="colorChange pe-1" >Step 4:</span>{" "} */}
                        <span className="material-icons me-2">schedule</span>{" "}
                        {
                          selectedLanguage.LstLanguageCodes
                            .UI_RealTimeInteractivity
                        }{" "}
                        {/* - Step 4 */}
                      </h5>
                    </div>
                    <div className="card-body pt-1">
                      <div className="d-flex flex-column mt-2">
                        <div className="field">
                          <label
                            className={`sidenote d-flex align-items-center control ps-0 toolltipModified ${position}`}
                            name="username" style={{
                              color: '#4b5d68 !important',
                              fontWeight: '500 !important'
                            }}
                            onMouseEnter={handleMouseEnter}>
                            {selectedLanguage.LstLanguageCodes.UI_SideNote}
                            <super className="superfont-10">®</super>
                            <span className="ModToollTips width380">
                              {
                                selectedLanguage.LstLanguageCodes
                                  .UI_AddsanoteAccessible
                              }
                            </span>
                          </label>
                          <textarea
                            className="w-100 custom-inputBorder"
                            name="message"
                            rows="4"
                            placeholder={
                              selectedLanguage.LstLanguageCodes
                                .UI_ThisNotewillbeIncluded
                            }
                            onChange={(e) => {
                              setSideNote(e.target.value.trimStart());
                              dispatch(updateFormData({ type: "SideNote", value: e.target.value.trimStart() }))
                            }}
                            value={sideNote}
                            tabIndex="4"></textarea>
                        </div>
                        <div className="input-group field mt-3 res-column custom-inputBorder">
                          <div className="checkbox control usercheck min-width40 sendCreate-bg text-wrap response-group-container">
                            <label className="ps-0 control">
                              <input
                                type="checkbox"
                                value={constAllowResFlag}
                                checked={constAllowResFlag}
                                onChange={(e) => handlerAllowResFlag(e.target.checked)}
                              />
                              <span className="cr" tabIndex="5">
                                <i className="cr-icon material-icons">check</i>
                              </span>
                              <span className={`toolltipModified ${position}`} onMouseEnter={handleMouseEnter}>
                                {selectedLanguage.LstLanguageCodes.UI_AllowResponsesTo}
                                <span className="ModToollTips">
                                  {selectedLanguage.LstLanguageCodes.UI_AllowsTheDocOwnerToRoute}
                                </span>
                              </span>
                            </label>
                          </div>
                          {responseAddress && !constAllowResFlag ? (
                            <div className="form-control border-Left address-display-box">
                              <div title={responseAddress} className="address-pill">
                                <span className="address-text-truncate">
                                  {responseAddress}
                                </span>
                              </div>
                            </div>
                          ) : (
                            <div className="position-relative d-flex flex-grow-1">
                              <input
                                ref={responseAddressRef}
                                className={`form-control border-Left response-input ${!constAllowResFlag ? 'disabled' : 'enabled'}`}
                                name="username"
                                type="email"
                                autoComplete="off"
                                value={responseAddress}
                                disabled={!constAllowResFlag}
                                tabIndex="6"
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (value.includes(" ") || value.includes(",")) return;
                                  if ((value.match(/@/g) || []).length > 1) return;
                                  isResponseAddressUserEdited.current = value !== localStorage.getItem("UserName");
                                  setResponseAddress(value);
                                  dispatch(updateFormData({ type: "ResponseAddress", value }));
                                }}
                                onBlur={(e) => {
                                  const value = e.target.value.trim();
                                  if (!value) return;

                                  const strictOwnerEmailRegex = /^(?=.{1,254}$)[a-zA-Z0-9._%+\-]{1,64}@(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;

                                  if (!strictOwnerEmailRegex.test(value)) {
                                    setAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseEnterValidEmailintheAllowResponsestoField);
                                    setAlertType("warning");
                                    return;
                                  }
                                }}
                              />

                              {responseAddress && constAllowResFlag && (
                                <span
                                  className="clear-address-btn"
                                  onMouseDown={(e) => {         // ← onMouseDown prevents blur firing
                                    e.preventDefault();
                                    setResponseAddress("");
                                    isResponseAddressUserEdited.current = true;
                                    dispatch(updateFormData({ type: "ResponseAddress", value: "" }));
                                    setTimeout(() => responseAddressRef.current?.focus(), 0);
                                  }}
                                >
                                  ×
                                </span>
                              )}
                            </div>
                          )}
                        </div>
                        {/* Send Verification code */}
                        <div className="input-group field mt-2 res-column reactCustome-select custom-inputBorder">
                          <div
                            id="sendVerification_id"
                            className={
                              tabValue === "create"
                                ? "disable_section checkbox control usercheck min-width40 sendCreate-bg text-wrap"
                                : "disable_section user_register checkbox control usercheck min-width40 sendCreate-bg text-wrap"
                            }
                            style={{ padding: "0.29rem 0.8rem" }}>
                            <label className="ps-0 control">
                              <input
                                type="checkbox"
                                id="emailVerify"
                                checked={verifyCode}
                                // disabled={sendVerificationCodeDisable}
                                onChange={(e) =>
                                  handlerSendVerificationCodeFalg(e.target.checked)
                                }
                              />
                              <span className="cr" tabIndex="5">
                                <i className="cr-icon material-icons">check</i>
                              </span>
                              <span
                                className={`toolltipModified ${position}`}
                                onMouseEnter={handleMouseEnter}>
                                {
                                  selectedLanguage.LstLanguageCodes.UI_SendVerificationCode
                                }
                                <span className="ModToollTips">
                                  {
                                    selectedLanguage.LstLanguageCodes.UI_SendersCanChoose
                                  }
                                </span>
                              </span>
                            </label>
                          </div>
                          <Select
                            classNamePrefix="select"
                            id="select-method"
                            isDisabled={sendVerificationCodeDisable}
                            onChange={(newValue, actionMeta) => {
                              if (actionMeta.action === "clear" || (Array.isArray(newValue) && newValue.length === 0)) {
                                setAlertMsg(selectedLanguage.LstLanguageCodes.UI_AtleastOneOptionRequired);
                                setAlertType("warning");
                                return; // stop clearing
                              }
                              if (tabValue === "create" && securityLevel === 2) {
                                const incomingValues = (newValue || []).map((opt) => opt.value);
                                if (!incomingValues.includes("email")) {
                                  setAlertMsg("Email is mandatory for Control Readers Generate RPDs");
                                  setAlertType("warning");
                                  return;
                                }
                              }
                              handleSelectionChange(newValue);
                            }}
                            value={selectedOptions}
                            isMulti
                            name="methods"
                            options={filteredOptions}
                            isSearchable={false}
                            styles={{
                              control: (provided, state) => ({
                                ...provided,
                                width: '100%',
                                height: 'auto',
                                minHeight: '47px',
                                borderRadius: '0',
                                borderLeft: '1px',
                                cursor: 'pointer',
                                borderLeft: '1px solid #adadad',
                                boxShadow: 'none',
                                border: state.isFocused
                                  ? '1px solid #adadad'
                                  : provided.border,
                                '&:hover': {
                                  border: '1px solid #adadad',
                                },
                              }),
                              menu: (provided) => ({
                                ...provided,
                                width: '23.7rem',
                              }),
                              option: (provided) => ({
                                ...provided,
                                padding: '7px',
                                fontSize: '16px',
                                paddingRight: '5px',
                              }),
                              multiValue: (provided) => ({
                                ...provided,
                                fontSize: '14px',
                                paddingRight: '5px',
                              }),
                              multiValueLabel: (provided) => ({
                                ...provided,
                                fontSize: '14px',
                                paddingRight: '5px',
                              }),
                            }}
                            placeholder="Select a method"
                            components={{
                              ClearIndicator: (props) =>
                                selectedOptions.length > 1 ? (
                                  <components {...props} />
                                ) : null,
                              MultiValueRemove,
                            }}
                            noOptionsMessage={() => null}
                          />
                        </div>

                        <div className="row align-items-center mt-3 res-flex  res-mb0">
                          <div
                            className={
                              tabValue === "create"
                                ? "checkbox col-sm-12 col-md-6 disable_section "
                                : "checkbox col-sm-12 col-md-6"
                            }>
                            <label className="ps-3 res-pl-0p">
                              {/* proof-sending pl-0p*/}
                              <input
                                className="form-check-input "
                                type="checkbox"
                                id="confirmation"
                                checked={proofOfSending}
                                onChange={(e) => handleOnChangeProof(e.target.checked)
                                }
                              />
                              <span className="cr" tabIndex="11">
                                <i className="cr-icon material-icons">check</i>
                              </span>
                              <span
                                className={`toolltipModified ${position}`}
                                onMouseEnter={handleMouseEnter}>
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_ProofOfSending
                                }
                                <span className="ModToollTips">
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_Whenenabledthesenderof
                                  }
                                </span>
                              </span>
                            </label>
                          </div>
                          <div
                            id="distribution_id"
                            className={
                              "checkbox col-sm-12 col-md-6 user_register "
                            }
                          >                            <label className="ps-0 res-pl3">
                              {/* distributionList */}
                              <input
                                className="form-check-input notLevelOne "
                                type="checkbox"
                                id="distribution"
                                onChange={(e) => {
                                  setDistributionList(e.target.checked)
                                  dispatch(updateFormData({ type: "DisplayDistributionList", value: e.target.checked }))
                                }
                                }
                                value={distributionList}
                              />
                              <span className="cr" tabIndex="12">
                                <i className="cr-icon material-icons">check</i>
                              </span>
                              <span
                                className={`toolltipModified ${position}`}
                                onMouseEnter={handleMouseEnter}>
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_DisplayDistributionlist
                                }{" "}
                                <span className="ModToollTips">
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_Allowsreaderstosee
                                  }
                                </span>
                              </span>
                            </label>
                          </div>
                        </div>
                        <div className="row align-items-center mt-2 pt-1 res-flex user_register res-mt0">
                          <div
                            id="voting_id"
                            className={
                              "checkbox col-sm-12 col-md-6 "
                            }
                          >                            <label className="ps-3 res-pl-0p voti ng">
                              {/* pl-0p ipad-mini */}
                              <input
                                className="form-check-input notLevelOne "
                                type="checkbox"
                                id="voting"
                                onChange={(e) => {
                                  handleSetVoting(e.target.checked)
                                  dispatch(updateFormData({ type: "Voting", value: e.target.checked }))
                                }
                                }
                                value={voting}
                              />
                              <span className="cr" tabIndex="14">
                                <i className="cr-icon material-icons">check</i>
                              </span>
                              <span
                                className={`toolltipModified ${position}`}
                                onMouseEnter={handleMouseEnter}>
                                {selectedLanguage.LstLanguageCodes.UI_Voting}
                                <span className="ModToollTips">
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_AllowsreadersTovote
                                  }
                                </span>
                              </span>
                            </label>
                          </div>
                          <div
                            id="voteShare_id"
                            className={
                              "checkbox col-sm-12 col-md-6 disable_sectionChailed disable_sectionChailedClass "
                            }
                          >
                            <label className="ps-0 res-pl3">
                              <input
                                className="form-check-input notLevelOne "
                                type="checkbox"
                                id="voteShare"
                                onChange={(e) => {
                                  setVoteSharing(e.target.checked)
                                  dispatch(updateFormData({ type: "VoteSharing", value: e.target.checked }))
                                }
                                }
                                value={voteSharing}
                                checked={voteSharing}
                              />
                              <span className="cr" tabIndex="15">
                                <i className="cr-icon material-icons">check</i>
                              </span>
                              <span
                                className={`toolltipModified ${position}`}
                                onMouseEnter={handleMouseEnter}>
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_ShareVotes
                                }
                                <span className="ModToollTips">
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_Allowsreaderstoseehow
                                  }
                                </span>
                              </span>
                            </label>
                          </div>
                        </div>
                        <div
                          className=" row pt-1 mt-2 align-items-center res-flex"
                        >
                          {/* ${!isPageLevelRestriction ? "disable_section" : ""} */}
                          <div className={`checkbox col-sm-12 col-md-6 `} ref={enablePageLevelRes}>
                            <label className="ps-3 res-pl-0p page-level">
                              {/* pl-0p ipad-mini */}
                              <input
                                className="form-check-input notLevelOne "
                                type="checkbox"
                                id="pagelevelrestriction"
                                ref={pageLevelResRef}
                                onChange={handlePageLevelRestrictionCheck}
                              />
                              <span className="cr" tabIndex="14">
                                <i className="cr-icon material-icons">check</i>
                              </span>
                              <span
                                className={`toolltipModified top`}
                                onMouseEnter={handleMouseEnter}>
                                {selectedLanguage.LstLanguageCodes.UI_Pagelevelrestrictions}
                                <span className="ModToollTips">
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_ThisFeature
                                  }
                                </span>
                              </span>

                            </label>
                            {(isPageLevelRestrictionChecked && pageLevelResRef && pageLevelResRef.current && pageLevelResRef.current.checked) ? (
                              <span
                                className={"material-icons top3"}
                                title={""}
                                style={{
                                  marginLeft: "4pt",
                                  fontWeight: 500,
                                  cursor: "pointer",
                                  fontSize: "20px",
                                }}
                                onClick={handlePageLevelRestrictionEdit}>
                                edit
                              </span>
                            ) : ""}
                          </div>
                          <div
                            id="notification_id"
                            className={
                              "checkbox col-sm-12 col-md-6 user_register "
                            }
                          >  <label className="ps-0 res-pl3 notification">
                              <input
                                className="form-check-input notLevelOne"
                                type="checkbox"
                                id="readNotify"
                                onChange={(e) => {
                                  setReadNotification(e.target.checked)
                                  dispatch(updateFormData({ type: "NotificationOfReading", value: e.target.checked }))
                                }
                                }
                                value={readNotification}
                              />
                              <span className="cr" tabIndex="11">
                                <i className="cr-icon material-icons">done</i>
                              </span>
                              <span
                                className={`toolltipModified top`}
                                onMouseEnter={handleMouseEnter}>
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_NotificationofReading
                                }
                                <span className="ModToollTips">
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_AbilityToReceiveAnotification
                                  }
                                </span>
                              </span>
                            </label>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row pt-1 px-3 res-pr0">
                <div
                  className={
                    tabValue === "create"
                      ? "col-sm-12 col-md-12 col-lg-12 col-xl-5 mt-3 ps-2  pe-1 createContenents"
                      : "col-sm-12 col-md-12 col-lg-12 col-xl-5 mt-3 ps-2  pe-1"
                  }>
                  <div
                    className={
                      tabValue === "create"
                        ? "card box-shadow-light p-0 createpage-hr sendCreate-card"
                        : "card box-shadow-light p-0 create-hr sendCreate-card"
                    }>
                    {" "}
                    {/* h-490 className="card box-shadow-light p-0  create-hr"  */}



                    <div className="card-header card-headercustome  align-items-center">
                      {/* <h5 className="mt-2 mails d-flex align-items-center" style={{marginLeft:"5px"}}>
                       Step 5
                      </h5> */}
                      <h5 className="mt-2 mails d-flex align-items-center">
                        {/* <span className="colorChange pe-1">Step 5:</span>{" "}                    */}
                        <span className="material-icons me-2">place</span>{" "}
                        {
                          selectedLanguage.LstLanguageCodes
                            .UI_LocationProtection
                        }
                        {/* - Step 5 */}
                      </h5>
                    </div>
                    <div className="card-body">
                      <div className="p-3 pb-0 pt-0">
                        <div className=" mt-n1">
                          <div className="d-flex align-items-center justify-content-between">
                            <span
                              className={`toolltipModified region ${position} `}
                              onMouseEnter={handleMouseEnter}>
                              <h6 className="font-1rem byRegionColor">
                                {selectedLanguage.LstLanguageCodes.UI_ByRegion}
                              </h6>
                              <span className="ModToollTips">
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_AllowsthesenderofanRdoc
                                }
                              </span>
                            </span>
                          </div>
                          <div className="mt-40">
                            {/* <WorldMap
                              selected={selectedValue}
                              multiple={'true'}
                              onSelect={onSelectValue}
                            /> */}
                            {/* <img
                              src="assets/img/map.PNG"
                              alt=""
                              className="map-hw"
                            /> */}
                            <WorldContinents
                              tabValue={tabValue}
                              regions={constContinents}
                              ref={childWorldContinents}></WorldContinents>
                          </div>
                        </div>

                        {/* <ReactMultiIP></ReactMultiIP> */}
                        {/* <input
                            type="text"
                            className=" form-control"
                            placeholder="Enter CIDR list"
                            id="startIP"
                          /> */}
                        <MultipleIps
                          id="multipleips"
                          type="text"
                          display="show"
                          constmultipleips={constmultipleips}
                          onChange={(constmultipleips) => {
                            setConstMultipleIps({ ...constmultipleips });
                          }}
                          ref={childIPs}></MultipleIps>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-7 mt-3 pl-10p res-mindesktop">
                  <div className="card box-shadow-light moz-card sendCreate-card">


                    <div className="card-header card-headercustome  align-items-center justify-content-between">
                      {/* <h5 className=" mails d-flex align-items-center">
                        Step 6
                      </h5> */}
                      <h5 className=" mails d-flex align-items-center">
                        {/* <span className="colorChange pe-1">Step 6:</span>{" "} */}
                        <span className="material-icons me-2">security</span>
                        {selectedLanguage.LstLanguageCodes.UI_ContentProtection}
                        {/* - Step 6 */}
                      </h5>
                    </div>
                    <div className="card-body pt-3">
                      <div className="row ms-0">
                        <div className="col-sm-6 ps-1 res-pr2 res-pr2px">
                          <div className="input-group res-datepicker custom-inputBorder">
                            <span
                              className={`min-width58 input-group-text toolltipModified start-date ${position}`}
                              style={{ height: "48px" }}
                              onMouseEnter={handleMouseEnter}>
                              {selectedLanguage.LstLanguageCodes.UI_Launches}
                              <span className="ModToollTips">
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_AllowsthesenderofRdocToSet
                                }
                              </span>
                            </span>
                            <div className="form-control h-50p clander-style border-Left">
                              {isDatetimeControl == "true" ? (
                                <DatePicker
                                  selected={startTime}
                                  onChange={(date) =>
                                    handlerExpirationDaysStartTime(date)
                                  }
                                  onFocus={(e) => IntiateTime(e, 0)}
                                  id="dtstart"
                                  showTimeSelect
                                  timeCaption="Time"
                                  //  isClearable
                                  timeIntervals={1}
                                  timeFormat="HH:mm"
                                  dateFormat={dateFormatValue + " HH:mm"}
                                  className="form-control textAlignment DateCalendarSend"
                                  placeholderText={`${dateFormatValue.toLocaleLowerCase()} --:--`}>
                                  {/* <div style={{ color: "red" }}>Don't forget to check the weather!</div> */}
                                </DatePicker>
                              ) : (
                                <DatePicker
                                  selected={startTime}
                                  onChange={(date) =>
                                    handlerExpirationDaysStartTime(date)
                                  }
                                  onFocus={(e) => IntiateTime(e, 0)}
                                  id="dtstart1"
                                  //  isClearable

                                  dateFormat={dateFormatValue}
                                  className="form-control textAlignment DateCalendarSend"
                                  placeholderText={dateFormatValue.toLocaleLowerCase()}>
                                  {/* <div style={{ color: "red" }}>Don't forget to check the weather!</div> */}
                                </DatePicker>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 res-pr2 pl-6p">
                          <div className="input-group res-datepicker custom-inputBorder expire-date">
                            <span
                              className={`min-width20 input-group-text toolltipModified ${position}`}
                              style={{ height: "48px" }}
                              onMouseEnter={handleMouseEnter}>
                              {selectedLanguage.LstLanguageCodes.UI_Expires}
                              <span className="ModToollTips">
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_AllowssenderofRdocTosetdate
                                }
                              </span>
                            </span>
                            <div className="form-control h-50p clander-style border-Left">
                              {isDatetimeControl == "true" ? (
                                <DatePicker
                                  selected={expiryTime}
                                  onChange={(date) =>
                                    handlerExpirationDaysExpiryTime(date)
                                  }
                                  onFocus={(e) => IntiateTime(e, 1)}
                                  showTimeSelect
                                  timeCaption="Time"
                                  timeIntervals={1}
                                  id="dtexpiry"
                                  timeFormat="HH:mm"
                                  dateFormat={dateFormatValue + " HH:mm"}
                                  className="form-control textAlignment DateCalendarSend"
                                  placeholderText={`${dateFormatValue.toLocaleLowerCase()} --:--`}
                                />
                              ) : (
                                <DatePicker
                                  selected={expiryTime}
                                  onChange={(date) =>
                                    handlerExpirationDaysExpiryTime(date)
                                  }
                                  onFocus={(e) => IntiateTime(e, 1)}
                                  id="dtexpiry1"
                                  //  isClearable

                                  dateFormat={dateFormatValue}
                                  className="form-control textAlignment DateCalendarSend"
                                  placeholderText={dateFormatValue.toLocaleLowerCase()}>
                                  {/* <div style={{ color: "red" }}>Don't forget to check the weather!</div> */}
                                </DatePicker>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 ps-1 res-pr2 res-pr2px">
                          <div className="input-group field mt-3 res-column res-pr2 custom-inputBorder">
                            <div
                              className="checkbox control usercheck min-width28 res-min-width h-48p"
                              style={{ padding: "0.8rem 0.8rem", color: "black" }}>
                              <span
                                className={`input-group-text res-width ps-0 control toolltipModified time-expiration-label ${position} ${localStorage.getItem("language") !== "en-us" ? " truncate ellipsis-text" : ""}`}
                                onMouseEnter={handleMouseEnter}
                                title={selectedLanguage.LstLanguageCodes.UI_TimeToExpiration}>
                                {
                                  selectedLanguage.LstLanguageCodes.UI_TimeToExpiration
                                } {""}
                              </span>
                              <span className="ModToollTips">
                                {
                                  selectedLanguage.LstLanguageCodes.UI_DisplaysTheTimeleft
                                }
                              </span>
                            </div>
                            <input
                              className="form-control h-48p border-Left"
                              name="username"
                              type="text"
                              value={expirationDays}
                              disabled
                              tabIndex="26"
                            />
                          </div>
                        </div>
                        <div className="col-sm-6 res-pr2 pl-6p">
                          <div ref={waterMarkWrapperRef} className="input-group field mt-3 res-nowwrap res-pr2 custom-inputBorder">
                            <span
                              className={`input-group-text h-48p min-width28 res-min-width toolltipModified ${position}`}
                              onMouseEnter={handleMouseEnter}>
                              {" "}
                              {
                                selectedLanguage.LstLanguageCodes.UI_Watermark
                              }{" "}
                              <span className="ModToollTips">
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_OptionToAddWatermark
                                }
                              </span>
                            </span>
                            <select
                              className="form-select form-control select-border h-47p border-Left"
                              aria-label="Default select example"
                              onChange={(e) => {
                                setWatermark(e.target.value)
                                dispatch(updateFormData({ type: "Watermark", value: e.target.value }));
                              }}
                              value={watermark}
                              tabIndex="31">
                              <option value="0" defaultValue="None">
                                {selectedLanguage.LstLanguageCodes.UI_None}
                              </option>
                              <option value="1">
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_Confidential
                                }
                              </option>
                              <option value="2">
                                {selectedLanguage.LstLanguageCodes.UI_Draft}
                              </option>
                              {/* <option value="3" disabled>
                              {selectedLanguage.LstLanguageCodes.UI_MyLogo}
                            </option> */}
                            </select>
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-12 ps-1">
                          <div className="input-group field mt-3 res-pr2 custom-inputBorder">
                            <span
                              className={`input-group-text res-width min-width28 res-min-width toolltipModified ${position}`}
                              onMouseEnter={handleMouseEnter}>
                              {
                                selectedLanguage.LstLanguageCodes
                                  .UI_RestrictToDomains
                              }{" "}
                              <span className="ModToollTips">
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_Onlyreaderswithinthesedomains
                                }
                              </span>
                            </span>
                            <input
                              type="text"
                              className="form-control h-50p border-Left"
                              placeholder={
                                selectedLanguage.LstLanguageCodes
                                  .UI_ExampleORGExample
                              }
                              id="txtRestrictDomains"
                              onChange={(e) => {
                                setDomains(e.target.value.replace(/\s/g, ""));
                                dispatch(updateFormData({ type: "RestrictToDomains", value: e.target.value.trimStart() }));
                              }}
                              value={domains}
                              tabIndex="30"
                            />
                          </div>

                        </div>

                        <div className="col-sm-6 mt-3 res-pr2 ps-1">
                          <div className="input-group field mt-1 res-nowwrap control-height custom-inputBorder">
                            <span
                              className={`input-group-text res-width toolltipModified min-width58 truncate ellipsis-text ellipsis-text-max-keys ${position}`}
                              onMouseEnter={handleMouseEnter}
                              title={selectedLanguage.LstLanguageCodes.UI_MaxReadsperReader}
                            >
                              {
                                selectedLanguage.LstLanguageCodes
                                  .UI_MaxReadsperReader
                              }{" "}
                              <span className="ModToollTips">
                                {
                                  selectedLanguage.LstLanguageCodes
                                    .UI_Allowssendertosetmaximumnumof
                                }
                              </span>
                            </span>
                            <input
                              type="text"
                              placeholder={
                                selectedLanguage.LstLanguageCodes.UI_Unlimited
                              }
                              title={maxReadsText === "" ? selectedLanguage.LstLanguageCodes.UI_Unlimited : ""}
                              className=" control form-control h-47p border-Left"
                              id="maxReads"
                              onChange={(e) =>
                                ChangeMaxReadsTexts(e.target.value)
                              }
                              value={maxReadsText}
                              tabIndex="35"
                            />
                          </div>
                        </div>
                        <div className="col-sm-6 mt-3 res-pr2 pl-6p res-pl2">
                          <div className="input-group field mt-1 res-nowwrap control-height custom-inputBorder">
                            <span
                              title={
                                selectedLanguage.LstLanguageCodes
                                  .UI_MaxviewsPerDocument
                              }
                              className={`input-group-text toolltipModified res-width min-width20 res-minWidth${localStorage.getItem("language") !== "en-us" ? " truncate ellipsis-text" : ""}`}>
                              {
                                selectedLanguage.LstLanguageCodes
                                  .UI_MaxviewsPerDocument
                              }{" "}
                            </span>
                            <input
                              type="text"
                              placeholder={
                                selectedLanguage.LstLanguageCodes.UI_Unlimited
                              }
                              title={
                                maxViewsPerDocumentText === ""
                                  ? selectedLanguage.LstLanguageCodes
                                    .UI_Unlimited
                                  : ""
                              }
                              className=" control form-control h-47p border-Left"
                              id="maxViewsPerDocument"
                              onChange={(e) =>
                                ChangeMaxViewsPerDocumentTexts(e.target.value)
                              }
                              value={maxViewsPerDocumentText}
                              tabIndex="36"
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 mt-2 res-pr2 ps-1">
                          <div className="d-flex align-items-center" style={{ borderRadius: "0.25rem" }}>
                            <div className="checkbox mt-0 mb-0 d-flex align-items-center" style={{ border: "1px solid #ced4da", padding: "11px", whiteSpace: "nowrap" }}>
                              <label className="ps-0 mb-0">
                                <input
                                  type="checkbox"
                                  onChange={(e) => {
                                    if (securityLevel !== 1 && e.target.checked === true) handleRecipientPrintEdit();
                                    setPrint(e.target.checked)
                                    if (e.target.checked === false) {
                                      setMaxPrintsPerReaderText("");
                                      setMaxPrintsPerDocumentText("");
                                      dispatch(updateFormData({ type: "MaxPrintsPerReader", value: "" }));
                                      dispatch(updateFormData({ type: "MaxPrintsPerDocument", value: "" }));
                                      const updatedRecipients = deepCopyArray(recipientPrintData);
                                      updatedRecipients.forEach((reader) => { reader[7] = false; });
                                      setRecipientPrintData(updatedRecipients);
                                      setAllRecipientPrintData(deepCopyArray(updatedRecipients));
                                      const updatedAuthorizedReaders = deepCopyArray(data.authorizedReaders || []);
                                      updatedAuthorizedReaders.forEach(reader => {
                                        reader[7] = false;
                                        reader[8] = "";
                                      });
                                      dispatch(retainConfiguredData({ ...data, authorizedReaders: updatedAuthorizedReaders, pageRestrictionData: data.pageLevelRestrictionData, }));
                                    }
                                    dispatch(updateFormData({ type: "CanPrint", value: e.target.checked }));
                                  }}
                                  value={canPrint}
                                  id="txtPrint"
                                  checked={canPrint}
                                />
                                <span className="cr" tabIndex="42">
                                  <i className="cr-icon material-icons">check</i>
                                </span>
                                <span
                                  className={`toolltipModified  top`}
                                  onMouseEnter={handleMouseEnter}>
                                  {selectedLanguage.LstLanguageCodes.UI_CanPrint}
                                  <span className="ModToollTips left0">
                                    {
                                      selectedLanguage.LstLanguageCodes
                                        .UI_WhenenabledthereaderWillbe
                                    }
                                  </span>
                                </span>
                              </label>
                              {securityLevel !== 1 && canPrint && (<span className={"material-icons top3"}
                                style={{
                                  marginLeft: "4pt", fontWeight: 500,
                                  cursor: (securityLevel === 1) ? "not-allowed" : "pointer", fontSize: "20px", marginBottom: "7px",
                                  opacity: (securityLevel === 1) ? 0.5 : 1
                                }}
                                onClick={() => { if (securityLevel === 1) return; handleRecipientPrintEdit(); }}
                              > edit
                              </span>)}
                            </div>

                            <div className="d-flex flex-grow-1 align-items-center">
                              <div className="input-group field mt-0 res-nowwrap control-height custom-inputBorder me-3" style={{ flex: 1, minWidth: "150px" }}>
                                <span className="input-group-text toolltipModified res-width forced-label-style truncate ellipsis-text ellipsis-text-max-keys" style={{ minWidth: "175px" }} title={selectedLanguage.LstLanguageCodes.UI_MaxPrintsPerReader}>
                                  {selectedLanguage.LstLanguageCodes.UI_MaxPrintsPerReader}
                                </span>
                                <input
                                  type="text"
                                  placeholder={selectedLanguage.LstLanguageCodes.UI_Unlimited}
                                  title={maxPrintsPerReaderText === "" ? selectedLanguage.LstLanguageCodes.UI_Unlimited : ""}
                                  className="control form-control h-47p border-Left"
                                  value={(securityLevel === 1 || !canPrint) ? "" : maxPrintsPerReaderText}
                                  onChange={(e) => ChangeMaxPrintsPerReaderTexts(e.target.value)}
                                  disabled={securityLevel === 1 || !canPrint}
                                />
                              </div>

                              <div className="input-group field res-nowwrap control-height custom-inputBorder" style={{ flex: 1, minWidth: "150px" }}>
                                <span className={`input-group-text res-width forced-label-style toolltipModified${localStorage.getItem("language") !== "en-us" ? " truncate ellipsis-text" : ""}`} style={{ minWidth: "175px" }}
                                  title={selectedLanguage.LstLanguageCodes.UI_MaxPrintsPerDocument}>
                                  {selectedLanguage.LstLanguageCodes.UI_MaxPrintsPerDocument}
                                </span>
                                <input
                                  type="text"
                                  placeholder={selectedLanguage.LstLanguageCodes.UI_Unlimited}
                                  title={maxPrintsPerDocumentText === "" ? selectedLanguage.LstLanguageCodes.UI_Unlimited : ""}
                                  className="control form-control h-47p border-Left"
                                  value={!canPrint ? "" : maxPrintsPerDocumentText}
                                  onChange={(e) => ChangeMaxPrintsPerDocumentTexts(e.target.value)}
                                  disabled={!canPrint}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-12 mt-1 mb-1 res-pr2 ps-1">
                          <div className="d-flex align-items-center flex-wrap">
                            <div
                              className={"checkbox mt-2 "}
                              id="chkIdentifyLeakersDiv"
                              ref={identifyLeakerWrapperRef}>
                              <label className="ps-0">
                                <input
                                  type="checkbox"
                                  id="chkIdentifyLeakers"
                                  ref={identifyLeakersRef}
                                  onChange={onIdentifyLeakersHandler}
                                />
                                <span className="cr" tabIndex="40">
                                  <i className="cr-icon material-icons">check</i>
                                </span>
                                <span
                                  className={`toolltipModified top`}
                                  onMouseEnter={handleMouseEnter}>
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_IDLeakers
                                  }
                                  <span className="ModToollTips">
                                    {
                                      selectedLanguage.LstLanguageCodes
                                        .UI_Addsthereadersemailadress
                                    }
                                  </span>
                                </span>
                              </label>
                              {AppContext.ContentSecurity && identifyLeakersRef.current?.checked && <>
                                <span
                                  className={"material-icons top3"}
                                  title={""}
                                  style={{
                                    marginLeft: "4pt",
                                    fontWeight: 500,
                                    cursor: "pointer",
                                    fontSize: "20px",
                                  }} onClick={handleEditClick}>
                                  edit
                                </span>
                                {/* Render modal conditionally */}

                              </>}
                              <IdentifyLeakersModal
                                ref={identifyLeakersModalRef}
                                onClose={handleClose}
                              />


                            </div>
                            <div className={`checkbox mt-2 res-mt0 ${localStorage.getItem("language") === "es-es" ? "mx-2" : "mx-5"}`}>
                              <label className="ps-0">
                                <input
                                  type="checkbox"
                                  onChange={(e) => {
                                    setTimestamp(e.target.checked)
                                    dispatch(updateFormData({ type: "TimeStamp", value: e.target.checked }));
                                  }}
                                  value={timestamp}
                                  id="txtTimestamp"
                                  checked={timestamp}
                                />
                                <span className="cr" tabIndex="41">
                                  <i className="cr-icon material-icons">check</i>
                                </span>
                                <span
                                  className={`toolltipModified top`}
                                  onMouseEnter={handleMouseEnter}>
                                  {selectedLanguage.LstLanguageCodes.UI_TimeStamp}
                                  <span className="ModToollTips">
                                    {
                                      selectedLanguage.LstLanguageCodes
                                        .UI_AddsaTimestampinside
                                    }
                                  </span>
                                </span>
                              </label>
                            </div>

                            <div id="chkEDisclosureDiv" className={`checkbox mt-2 res-mt0   ${localStorage.getItem("language") === "es-es" ? "ms-2" : "ms-2"} ${(securityLevel == 1 && eDisclosureLevel1 === false) ? "disable_sectionChailed" : securityLevel == 2 && eDisclosureLevel2 == false ? "disable_sectionChailed" : securityLevel == 3 && eDisclosureLevel3 == false ? "disable_sectionChailed" : isEDisclosure == false ? "disable_sectionChailed" : ""}`}>
                              <label className="ps-0">
                                <input
                                  type="checkbox"
                                  id="txtEDisclosure"
                                  checked={eDisclosure}
                                  onChange={(e) => { EdisclosureChanged(e) }}
                                />

                                <span className="cr" tabIndex="42">
                                  <i className="cr-icon material-icons">check</i>
                                </span>
                                <span
                                  className={`toolltipModified  top`}
                                  onMouseEnter={handleMouseEnter}>
                                  {selectedLanguage.LstLanguageCodes.UI_EDisclosure}
                                  <span className="ModToollTips left0">
                                    {
                                      selectedLanguage.LstLanguageCodes.UI_ThisFeatureAllowsSenderTo}
                                  </span>
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {modalIsOpen && (
            <div className="modalCus" id="myModal">
              <div className="modal-dialog modal-dialog-centered justify-content-center">
                <div className="modal-content createModalContent">
                  <div className="modal-header pb-1">
                    <h4
                      className="d-flex align-items-center text-danger fw-bold "
                      htmlFor="">
                      {selectedLanguage.LstLanguageCodes.UI_Download}
                    </h4>
                    <button
                      type="button"
                      className="btn btn-outline-danger modalclose download"
                      onClick={(e) => handlerModelCancel()}>
                      <span className="material-icons font-20">
                        highlight_off
                      </span>
                    </button>
                  </div>
                  <div
                    className="modal-body"
                    style={{ maxHeight: "40vh", overflowY: "auto" }}>
                    {createMultipleRPDs.map((rpddata, ind) => (
                      <>
                        <p className="text-center f-w550">
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_WaitforthedocDownload
                          }
                        </p>
                        <p className="text-center f-w550">
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_DocumentDoesNotDownload
                          }
                          ,
                        </p>
                        <p className=" f-w550 mb-1 mt-2  text-center">
                          {selectedLanguage.LstLanguageCodes.UI_Click}&nbsp;
                          <a
                            href={rpddata.CreateDownloadLink}
                            download={rpddata.DownloadFileName}
                            target="_blank"
                            rel="noreferrer">
                            {selectedLanguage.LstLanguageCodes.UI_Here}
                          </a>
                          &nbsp;
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_ToDownloadyourdoc
                          }
                        </p>
                      </>
                    ))}
                    {createMultipleRPDsFlag == false && (
                      <>
                        <p className="text-center f-w550">
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_WaitforthedocDownload
                          }
                        </p>
                        <p className="text-center f-w550">
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_DocumentDoesNotDownload
                          }
                          ,
                        </p>

                        <p className=" f-w550 mb-1 mt-2  text-center">
                          {selectedLanguage.LstLanguageCodes.UI_Click}&nbsp;
                          <a
                            href={createDownloadLink}
                            download={downloadFileName}
                            target="_blank"
                            rel="noreferrer">
                            {selectedLanguage.LstLanguageCodes.UI_Here}
                          </a>
                          &nbsp;
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_ToDownloadyourdoc
                          }
                        </p>
                      </>
                    )}
                  </div>

                  <div
                    className="d-flex justify-content-center pt-2 mb-3"
                    style={{ borderTop: "solid 0.12rem #d3d3d369" }}>
                    <button
                      type="button"
                      className="btn btn-danger px-4 me-1"
                      data-bs-dismiss="modal"
                      onClick={(e) => handlerModelCancel()}>
                      {selectedLanguage.LstLanguageCodes.UI_Close}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {showValidationModal && (
            <div className="modalCus documentversion-history" id="myModal">
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="card-body pt-1">
                    <div
                      className="mb-2 mt-3 justify-content-between d-flex"
                      style={{ borderBottom: "2px solid #918d8d4d" }}
                    >
                      <h4 htmlFor="">
                        <p className="fw-bold">
                          {"Template Issues"}
                        </p>
                      </h4>
                      <button
                        type="button"
                        className="btn btn-outline-danger modalclose download"
                        onClick={(e) => handleCloseValidationModal()}
                      >
                        <span className="material-icons font-20">
                          highlight_off
                        </span>
                      </button>
                    </div>
                    <div className="row">
                      <div>
                        <p className="IssuesUploadMsg">
                          {isSendGenerateClick === true
                            ? "The template you selected has the following issues. Click \"Confirm\" to remove the selected template and send the RPD, or click \"Cancel\" to review and resolve the issues."
                            : "The Template you selected has the following issues. Please address them to proceed with sending or generating the RPD."}
                        </p>
                      </div>
                    </div>
                    <div
                      className="card-body pt-0 recipent-scroll"
                      style={{
                        display: "block"
                      }}
                    >
                      <div className="table-responsive res-card">
                        <table
                          className="fold-table table tablelayoutValidation "
                          cellPadding="0"
                          cellSpacing="0"
                        >
                          <thead className="bg-lightblue">
                            <tr className="">
                              <th className="" style={{ width: "19%" }}>
                                {selectedLanguage.LstLanguageCodes.UI_Sno}
                              </th>
                              <th className="" style={{ width: "33%" }}>
                                {selectedLanguage.LstLanguageCodes.UI_Inputvalue}
                              </th>
                              <th className="">{selectedLanguage.LstLanguageCodes.UI_Issue}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {validationRows.map((row, index) => (
                              <tr className="borderrow" key={index}>
                                <td>{index + 1}</td>
                                <td>{row.field}</td>
                                <td>{row.issue}</td>
                              </tr>
                            ))}
                          </tbody>

                        </table>
                        {isSendGenerateClick && (
                          <div className="d-flex justify-content-end mb-4">
                            <button
                              type="button"
                              className="btn btn-danger px-4 me-1"
                              onClick={(e) => handleCloseValidationModal()}
                            >
                              {selectedLanguage?.LstLanguageCodes?.UI_Cancel || "Cancel"}
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary px-4 ms-3"
                              onClick={(e) => onConfirm(e)}
                            >
                              {"Confirm"}
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* {confirmPopup.open && (
     <div className="child-popup" id="myModal">
          <div className="Settingmodal-dialog  modal-dialog-centered">
            <div className="modal-content">
              <div className="mleft15 justify-content-center mb-3 modalheaederleft" style={{marginLeft:'9px', marginRight:'0px'}}>
                <h4 className="mb-2 mt-2 text-danger fw-bold" htmlFor="">
                {selectedLanguage.LstLanguageCodes.UI_Update}
                </h4>
              </div>
              <hr className="modalhorizontal" />
              <div
                className="d-flex justify-content-center flex-column mb-3 text-center"
                style={{ marginTop: "20px" }}>
                <p
                  className="w-100 f-w550"
                  style={{ display: "content", fontSize: "18px" }}>
                  {"Selecting this feature will remove the currently applied template, as it is not included in the template settings. Click Confirm to proceed with the new selection, or Cancel to keep the current template settings. "}
                </p>
              </div>
              <div className="d-flex justify-content-center mb-4 ">
                <button
                  type="button"
                  className="btn btn-danger px-4 me-1"
                  data-bs-dismiss="modal"
                  onClick={handleCancelPopup}>
                  {selectedLanguage.LstLanguageCodes.UI_Cancel}
                </button>
                <button
                  type="button"
                  className="btn btn-primary px-4 ms-3"
                  onClick={handleConfirmPopup}>
                  {selectedLanguage.LstLanguageCodes.UI_Confirm}
                </button>
              </div>
            </div>
          </div>
        </div>
)} */}


        </div>
      </section>
      <UpdatePopup
        isOpenModal={isTextRemovePopup}
        onCancel={onCancelUpdatePopup}
        onConfirm={onConfirmUpdatePopup}
        message={istext}
        selectedLanguage={selectedLanguage}
      />
      {isIdLeakersTypeMatched && (
        <UpdatePopup
          isOpenModal={isIdLeakersTypeMatched}
          onCancel={onCancelUpdatePopup1}
          onConfirm={onConfirmUpdatePopup1}
          message={istext}
          selectedLanguage={selectedLanguage}
        />
      )}
      <PageRestrictions
        addNewReaders={onAddNewReaderHandler}
        documents={inputFields}
        ref={pageLevelResModalRef}
        onCancel={onCancelPageLevelRestriction}
        onSave={onSavePageLevelRestriction}
      />
      <ModalPopUp ref={unSaveWarnModal} headerText={"Update"} />
      { }
      <ManageTemplate
        isOpen={showManageTemplates}
        handleCancel={() => setShowManageTemplates(false)}
        maxReadsText={maxReadsTextForManageTemplate}
        maxViewsPerDocumentText={maxViewsPerDocumentTextForManageTemplate}
        maxPrintsPerReaderText={maxPrintsPerReaderTextForManageTemplate}
        maxPrintsPerDocumentText={maxPrintsPerDocumentTextForManageTemplate}
        Domains={domainsForManageTemplate}
        ConstContinents={constContinents}
        ConstMultipleIps={constmultipleips}
      />

      {showCreateTemplateSettings && (
        <CreateTemplate
          isOpen={showCreateTemplateSettings}
          template={settingsTemplateCreation}
          handleCancel={() => setShowCreateTemplateSettings(false)}
          sortedColumns={""}
          LEVEL1_ALLOWED={""}
          LEVEL2_ALLOWED={""}
          isFromSettings={true}
          securityLevelValue={securityLevel}
          showManagePopup={handleManageTemplate}
          maxReadsText={maxReadsText}
          maxViewsPerDocumentText={maxViewsPerDocumentText}
          maxPrintsPerReaderText={maxPrintsPerReaderText}
          maxPrintsPerDocumentText={maxPrintsPerDocumentText}
          Domains={domains}
          ConstContinents={continentsForTemplateC ?? constContinents}
          ConstMultipleIps={ipsForTemplateC ?? constmultipleips} />
      )}
      {ModalIsUpdateConfirmOpen && (
        <div
          className="modal modal-style"
          id="MoveFolder" >
          <div className="modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content">
              <div className="modal-header pb-1">
                <h4
                  className="d-flex align-items-center text-danger fw-bold "
                  htmlFor=""
                >
                  {selectedLanguage.LstLanguageCodes.UI_Update}
                </h4>
              </div>
              <div
                className="d-flex justify-content-center flex-column mb-3 text-center mt-26">
                <p className="w-100 f-w550 font-18">
                  {" "}
                  {"Entered recipients don't have a mobile number, Click 'Confirm' to send or 'Cancel' to edit the recipients."}{" "}
                  {""}
                </p>
              </div>
              <div className="d-flex justify-content-center mb-4 ">
                {template?.eDisclosure === false && !isConfirmClicked ? (
                  <button
                    type="button"
                    className="btn btn-secondary px-4"
                    onClick={() => setShowValidationModal(false)}
                  >
                    {selectedLanguage.LstLanguageCodes.UI_Close || 'Close'}
                  </button>
                ) : (
                  <>
                    <button
                      type="button"
                      className="btn btn-danger px-4 me-1"
                      data-bs-dismiss="modal"
                      onClick={(e) => handlerUpdateModelCancel()}
                    >
                      {selectedLanguage.LstLanguageCodes.UI_Cancel}
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary px-4 ms-3"
                      onClick={uploadsend}
                    >
                      {selectedLanguage.LstLanguageCodes.UI_Confirm}
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {showRecipientPrintPopup && (
        <div className="modal pagemodal d-block">
          <div className="modal-dialog modal-dialog-centered modal-customelg" style={{ width: "70vw", maxWidth: "62.5rem" }}>
            <div className="modal-content card-body pt-0">
              <div className="modal-header pb-1 ps-1">
                <h4 className="d-flex align-items-center text-danger fw-bold">
                  {selectedLanguage.LstLanguageCodes.UI_PrintRestrictions}
                </h4>
                <span className="material-icons" style={{ cursor: "pointer", fontSize: "24px", marginLeft: "auto" }}
                  onClick={() => onClosePrintRestriction()}
                >close
                </span>
              </div>
              <div className="row d-flex align-items-center flex-wrap justify-content-between my-3 pt-2 mx-1">
                <div className=" d-flex " style={{ marginTop: "-10px" }}>
                  <div style={{ position: "relative", right: "1.25rem", display: "flex", alignItems: "center" }}>
                    <span className="radio me-4 cursor-unlocked">
                      <input id="printEnabledEveryone" name="PrintEnabled" type="radio" value="everyone"
                        checked={printEnabledType === "everyone"}
                        onChange={() => {
                          const temp = deepCopyArray(recipientPrintData);
                          temp.forEach(reader => { reader[7] = true; });
                          setRecipientPrintData(temp);
                          setAllRecipientPrintData(deepCopyArray(temp));
                          setPrintEnabledType("everyone");
                        }}
                      />
                      <label
                        htmlFor="printEnabledEveryone"
                        className="radio-label font-w500 control res-w res-left12"
                        style={{ fontSize: "14px !important" }}
                      >
                        {selectedLanguage.LstLanguageCodes.UI_EnabledForEveryone}
                      </label>
                    </span>

                    <span className="radio me-4 cursor-unlocked">
                      <input id="printEnabledSelected" name="PrintEnabled" type="radio" value="selectedUsers"
                        checked={printEnabledType === "selectedUsers"}
                        onChange={() => {
                          const temp = deepCopyArray(recipientPrintData);
                          if (temp.every(reader => reader[7] !== true)) {
                            temp.forEach(reader => {
                              reader[7] = true;
                            });
                            setRecipientPrintData(temp);
                            setAllRecipientPrintData(JSON.parse(JSON.stringify(temp)));
                          }
                          setPrintEnabledType("selectedUsers");
                        }}
                      />
                      <label
                        htmlFor="printEnabledSelected"
                        className="radio-label font-w500 control res-w res-left12"
                        style={{ fontSize: "14px !important" }}
                      >
                        {selectedLanguage.LstLanguageCodes.UI_EnabledForSelectedUsers}
                      </label>
                    </span>
                  </div>
                  <div style={{ display: "flex", position: "relative", left: "5rem" }}>
                    <input className="custom-inputBorder" type="text" style={{ width: "16rem" }} autoComplete="none" placeholder={selectedLanguage.LstLanguageCodes.UI_NameOrEmailSearch}
                      value={recipientPrintSearch}
                      onChange={(e) => setRecipientPrintSearch(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleRecipientPrintSearch();
                        }
                      }}
                    />
                    <div style={{ display: "flex" }}>
                      <span className="material-icons searchHistory" style={{ cursor: "pointer" }}
                        onClick={handleRecipientPrintSearch}
                      > search
                      </span>
                      <span
                        className="material-icons cancelHistory"
                        style={{ cursor: "pointer" }}
                        onClick={clearRecipientPrintSearch}
                      > block
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="card-body-new pt-0" style={{ height: "350px", overflow: "hidden auto", }}>
                  <div className="table-responsive res-card">
                    <table className="fold-table table tablelayout" cellPadding="0" cellSpacing="0">
                      <thead className="bg-lightblue">
                        <tr>
                          <th className="w-35p">
                            <span>{selectedLanguage.LstLanguageCodes.UI_Email}</span>
                          </th>
                          <th className="w-25p">
                            <span>{selectedLanguage.LstLanguageCodes.UI_Name}</span>
                          </th>
                          <th className="w-15p text-center">
                            <div
                              className="checkbox d-flex align-items-center justify-content-center"
                              style={{ position: "relative", left: "1rem" }}
                            >
                              <label className="p-0 mb-0">
                                <input type="checkbox" disabled={printEnabledType === "everyone"}
                                  checked={(recipientPrintData.length > 0 && printEnabledType === "everyone") || (recipientPrintData.length > 0 && recipientPrintData.every((reader) => reader[7] === true))}
                                  onChange={(e) => handleCheckAllPrints(e.target.checked)}
                                />
                                <span className="cr">
                                  <i className="cr-icon material-icons">
                                    check
                                  </i>
                                </span>
                                <span style={{ marginLeft: "8px" }}>
                                  {selectedLanguage.LstLanguageCodes.UI_LabelPrint}
                                </span>
                              </label>
                            </div>
                          </th>
                          <th className="w-25p text-center">
                            <span>
                              {selectedLanguage.LstLanguageCodes.UI_MaxAllowedPrints}
                            </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {recipientPrintData.length === 0 ? (
                          <tr>
                            <td colSpan="4" className="text-center py-4">
                              {selectedLanguage.LstLanguageCodes.UI_NoReadersFound}
                            </td>
                          </tr>
                        ) : (
                          recipientPrintData.map((reader, index) => (
                            <tr key={index} className="borderrow">
                              <td className="text-start" title={reader[0]} style={{ borderLeft: "0.1rem solid rgba(231, 229, 229, 0.44)", }}>
                                <div className="d-flex flex-wrap textwrap">
                                  {reader[0]}
                                </div>
                              </td>
                              <td className="text-start" title={`${reader[1] || ""} ${reader[2] || ""}`} style={{ borderLeft: "0.1rem solid rgba(231, 229, 229, 0.44)", }}>
                                <span className="Wordbreak">
                                  {(reader[1] || "") + " " + (reader[2] || "")}
                                </span>
                              </td>
                              <td className="text-center" style={{ borderLeft: "0.1rem solid rgba(231, 229, 229, 0.44)", }}>
                                <div className="checkbox mt-n5p marginTop8">
                                  <label className="p-0 mb-0">
                                    <input type="checkbox" disabled={printEnabledType === "everyone"}
                                      checked={printEnabledType === "everyone" ? true : reader[7] === true}
                                      onChange={(e) => {
                                        const temp = deepCopyArray(recipientPrintData);

                                        temp[index][7] = e.target.checked;

                                        setRecipientPrintData(temp);
                                        setAllRecipientPrintData(JSON.parse(JSON.stringify(temp)));
                                      }}
                                    />
                                    <span className="cr">
                                      <i className="cr-icon material-icons">
                                        check
                                      </i>
                                    </span>
                                  </label>
                                </div>
                              </td>
                              <td style={{ borderLeft: "0.1rem solid rgba(231, 229, 229, 0.44)", }}>
                                <input type="text" placeholder={selectedLanguage.LstLanguageCodes.UI_EnterMaxAllowedPrints}
                                  className="form-control custom-inputBorder" disabled={printEnabledType !== "everyone" && !reader[7]}
                                  value={
                                    printEnabledType === "everyone"
                                      ? (reader[9] === true
                                        ? (reader[8] !== undefined && reader[8] !== null ? reader[8] : "")
                                        : (maxPrintsPerReaderText !== undefined && maxPrintsPerReaderText !== null ? maxPrintsPerReaderText : ""))
                                      : (!reader[7] ? "" : (reader[8] !== undefined && reader[8] !== null ? reader[8] : ""))
                                  }
                                  onChange={(e) => {
                                    const temp = [...recipientPrintData];
                                    const printValue = e.target.value.replace(/[^0-9]+/g, "");
                                    const numberValue = parseInt(printValue, 10);
                                    if (printValue === "") {
                                      temp[index][8] = "";
                                    }
                                    else if (printValue.length <= 4 && numberValue >= 1 && numberValue <= 9999) {
                                      temp[index][8] = numberValue;
                                    }
                                    temp[index][9] = true;
                                    setRecipientPrintData(temp);
                                  }}
                                />
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {recipientPrintData.length > 0 && (<div className="d-flex align-items-center justify-content-end mb-1 mt-3" style={{ marginTop: "8px" }}>
                <button type="button" className="btn btn-danger px-4 me-1" onClick={() => onClosePrintRestriction()}>
                  {selectedLanguage.LstLanguageCodes.UI_Cancel}
                </button>
                <button type="button" className="btn btn-primary px-4 ms-3" onClick={saveRecipientPrintSettings}>
                  {selectedLanguage.LstLanguageCodes.UI_Confirm}
                </button>
              </div>)}
            </div>
          </div>
        </div >
      )}
      <Footer></Footer>
    </>
  );
}
export default SendCreate;
